<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep, sortBy, orderBy, groupBy } from "lodash";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import SupplierRfq from "@/components/modals/supplier-rfq";
import PrintOptions from "@/components/modals/print-options.vue";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import ResourceDetails from "@/components/modals/resource-details.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import EmployeeModal from '@/components/modals/employee.vue';
import SubmissionTab from '@/router/views/procurement/rfq/submission.vue';
import RawData from "@/components/widgets/raw-data.vue";
import Unit from "@/components/modals/unit.vue";
import WavedItems from "@/router/views/procurement/rfq/waved-items.vue";
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import ConsolidatedItems from "@/components/modals/pr-consolidated-items.vue";
import RFQNumberModal from "@/components/modals/rfq-number.vue";
import BACMembers from '@/router/views/procurement/bidding/bac-members.vue'
import BACMemberModal from '@/components/modals/bac-member.vue'

export default {
    page: {
        title: "Bids and Quotations",
    },
    components: {
        Layout,
        PageHeader,
        MaskedInput,
        DatePicker,
        Multiselect,
        SupplierRfq,
        PrintOptions,
        AttachmentModal,
        ResourceDetails,
        UploadPopover,
        EmployeeModal,
        SubmissionTab,
        RawData,
        Unit,
        WavedItems,
        LoadingTemplate,
        ConsolidatedItems,
        RFQNumberModal,
        BACMembers,
        BACMemberModal
    },
    data() {
        return {
            title: "Bids and Quotations",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Bids and Quotations",
                    active: true,
                },
            ],
            singleSelection: true,
            currencyMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: true,
                allowDecimal: true,
            }),
            dayMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false,
                allowDecimal: false,
            }),
            modalTitle: "",
            availableTable: [],
            canceledTable: [],
            availableBusy: false,
            filterItem: "",
            filterCanceledItem: "",
            filterCartItems: "",
            filterUpdateItems: "",
            pageOptions: [10, 25, 50, 100],
            perPageItem: 10,
            perPageUpdate: 10,
            perSubmittedPage: 10,
            perPostedPage: 10,
            currentPostedPage: 1,
            waved: [],
            wavedBusy: false,
            perWavedPage: 10,
            currentWavedPage: 1,
            filterWaved: "",
            currentPageItem: 1,
            currentPageUpdate: 1,
            selectedItems: [],
            currentOfferPage: 1,
            perOfferPage: 5,
            offerPageOptions: [5, 10, 25, 50, 100],
            monthsNickname: ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"],
            cartCount: 0,
            cartItems: [],
            rfq: {
                id: 0,
                description: "",
                tracking: "",
                modeOfProcurementId: "",
                deliveryTerms: "",
                paymentTerms: "",
                deliveryPeriod: "",
                deadline: "",
                supplierIds: [],
                cycle: this.$store.state.data.cycle,
                dateSubmitted: "",
                note: "",
                // bacSettingId: "",
            },
            rfqHeader: {
                id: 0,
                description: "",
            },
            form: {
                id: "",
                remarks: "",
            },
            tabIndex: 0,
            posted: [],
            returned: [],
            submittedRFQ: [],
            postedBusy: false,
            returnBusy: false,
            submittedBusy: false,
            updateItems: [],
            cartBusy: false,
            updateBusy: false,
            suppliers: [],
            selectedSupplier: [],
            mop: [],
            units: [],
            offers: [],

            filterSubmittedRFQ: "",
            filterPostedRFQ: "",
            addSupplier: {},
            selectedRFQ: {},
            addItem: false,
            po: {
                description: "",
                poNumber: "",
                cycle: this.$store.state.data.cycle,
                rfqSupplierId: 0,
                poDateReceived: new Date(),
                poDate: new Date(),
            },
            rfqMigration: false,
            returnDate: null,
            selectedSupplierId: 0,
            selectedRFQId: 0,
            publicPost: {
                rfqId: 0,
                datePublish: null,
                publicationEnded: null,
                nonRefundableBidderFee: null,
                type: null,
            },
            selectedPublicRfq: null,
            bacSetting: null,
            bacSettings: [],
            bacMembers: [],
            bacMemberLoading: false,
            rfqUpdate: {
                id: 0,
                description: null,
                tracking: null,
                deadline: null,
                dateSubmitted: null,
                modeOfProcurementId: null,
                note: null,
            },
            uploadOptions: {
                type: "Bids & Quotations",
                placement: "lefttop",
                folder: "Procurement",
            },
            publicPostOptions: {
                type: "RFQ Public Post",
                placement: "lefttop",
                folder: "Procurement",
            },
            wActions: false,
            attachmentTitle: "",
            publicPostLabels: [],
            getPublicPostLoading: false,
            multipleFilePosting: [],
            selectedPostedFile: null,
            filePostingType: 'add',
            selectedRFQForPosting: null,
            activePosts: [],
            activeBusy: false,
            filterActive: '',
            expiredPosts: [],
            expiredBusy: false,
            filterExpired: '',
            returnPRItem: null,
            selectedBACMember: null,
            selectedPR: null,
            currentSubmittedPage: 1,
            recanvases: [],
            recanvasItems: [],
            recanvasLoading: false,
            recanvasRfq: {
                id: 0,
                description: "",
                tracking: "",
                modeOfProcurementId: "",
                deliveryTerms: "",
                paymentTerms: "",
                deliveryPeriod: "",
                deadline: "",
                supplierIds: [],
                cycle: this.$store.state.data.cycle,
                dateSubmitted: "",
                note: "",
                // bacSettingId: "",
            },
            selectedRecanvasRfq: 0,
            updateUnit: null,
            searchOffer: '',
            rfqActivity: {
                id: 0,
                rfqId: 0,
                name: null,
                description: null,
                activityDateTime: null,
                remarks: null,
                status: null,
            },
            searchActivity: false,
            bacActivities: [],
            selectedRfqForAct: null,
            abstractList: 1,
            movePrItem: null,
            selectedRfqForReAward: null,
            reaward: {
                description: null,
                cycle: null,
                rfqSupplierId: null,
                poNumber: null,
                campusId: null,
                rfqSupplierOfferIds: [],
            },
            reawardRfqSuppliers: [],
            reawardItems: [],
            selectedParentPrItemId: null,
            selectedConsolidatedParent: null,
            showConsolidatedItems: false,
            consolidatedItems: [],
            selectedRFQForChanging: null
        };
    },
    async created() {
        this.pageLoader(true);
        await this.getMOP();
        await this.getBacSettings(this.$store.state.data.selectedCampus.id);
        await this.getUnits();
        this.pageLoader(false);
        this.getAvailableItems(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        this.getCartItems(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        this.getRecanvases(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
    },
    validations: {
        addSupplier: { required },
        form: { remarks: { required } },
        po: { 
            description: { required },
            poNumber: { required },
        },
        publicPost: {
            datePublish: { required },
            publicationEnded: { required },
            type: { required },
        },
        rfqUpdate: {
            description: { required },
            tracking: { required },
            deadline: { required },
            dateSubmitted: { required },
            modeOfProcurementId: { required },
        },
        rfqActivity: {
            name: { required },
            activityDateTime: { required },
            status: { required },
        },
        reaward: {
            // description: { required },
            rfqSupplierId: { required },
            // poNumber: { required },
        }
    },
    computed: {
        filteredActivity(){
            let data = this.bacActivities;
            return data.filter(x => x.name.toUpperCase().includes(this.rfqActivity.name.toUpperCase()));
        },
        filteredOffers(){
            let data = this.offers;
            var total = this.currentOfferPage * this.perOfferPage;
            if(this.searchOffer.trim() != "" && this.searchOffer){
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.searchOffer.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perOfferPage, total);
            if (this.currentOfferPage > 1 && currentData.length == 0) {
                total = (this.currentOfferPage - 1) * this.perOfferPage;
                currentData = data.slice(total - this.perOfferPage, total);
            }
            return currentData;
        },
        offerRows(){
            let data = this.offers;
            if(this.searchOffer.trim() != "" && this.searchOffer){
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.searchOffer.toUpperCase());
                });
            }
            return data.length;
        },
        filteredAvailableItems() {
            let data = this.availableTable;
            var total = this.currentPageItem * this.perPageItem;
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPageItem, total);
            if (this.currentPageItem > 1 && currentData.length == 0) {
                total = (this.currentPageItem - 1) * this.perPageItem;
                currentData = data.slice(total - this.perPageItem, total);
            }
            return currentData;
        },
        rowsAvailableItems(){
            let data = this.availableTable;
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            return data.length;
        },
        filteredCanceledItems() {
            let data = this.canceledTable;
            var total = this.currentPageItem * this.perPageItem;
            if (
                this.filterCanceledItem.trim() != "" &&
                this.filterCanceledItem
            ) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterCanceledItem.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPageItem, total);
            if (this.currentPageItem > 1 && currentData.length == 0) {
                total = (this.currentPageItem - 1) * this.perPageItem;
                currentData = data.slice(total - this.perPageItem, total);
            }
            return currentData;
        },
        selectedAvailableItems() {
            let items = [];
            this.availableTable.map((item) => {
                item.categoryGroups.map((x) => {
                    x.prItems.map((y) => {
                        y.toggleSelected && items.push(y);
                    });
                });
            });
            return items;
        },
        filteredCartItems() {
            let data = this.cartItems;
            var total = this.currentPageItem * this.perPageItem;
            if (this.filterCartItems.trim() != "" && this.filterCartItems) {
                data = data.filter((item) => {
                    return item.prItem.apiResource.itemName
                        .toUpperCase()
                        .includes(this.filterCartItems.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPageItem, total);
            if (this.currentPageItem > 1 && currentData.length == 0) {
                total = (this.currentPageItem - 1) * this.perPageItem;
                currentData = data.slice(total - this.perPageItem, total);
            }
            return currentData;
        },
        rowsCartItems() {
            if (this.filterCartItems.trim() != "" && this.filterCartItems) {
                return this.filteredCartItems.length;
            } else {
                return this.cartItems.length;
            }
        },
        filteredUpdateItems() {
            let data = this.updateItems;
            var total = this.currentPageUpdate * this.perPageUpdate;
            if (this.filterUpdateItems.trim() != "" && this.filterUpdateItems) {
                data = data.filter((item) => {
                    return item.apiResource.itemName
                        .toUpperCase()
                        .includes(this.filterUpdateItems.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPageUpdate, total);
            if (this.currentPageUpdate > 1 && currentData.length == 0) {
                total = (this.currentPageUpdate - 1) * this.perPageUpdate;
                currentData = data.slice(total - this.perPageUpdate, total);
            }
            return currentData;
        },
        rowsUpdateItems() {
            if (this.filterUpdateItems.trim() != "" && this.filterUpdateItems) {
                return this.filteredUpdateItems.length;
            } else {
                return this.updateItems.length;
            }
        },
        filteredSubmittedRFQ() {
            let data = this.submittedRFQ;
            var total = this.currentSubmittedPage * this.perSubmittedPage;
            if (this.filterSubmittedRFQ.trim() != "" && this.filterSubmittedRFQ) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterSubmittedRFQ.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perSubmittedPage, total);
            if (this.currentSubmittedPage > 1 && currentData.length == 0) {
                total = (this.currentSubmittedPage - 1) * this.perSubmittedPage;
                currentData = data.slice(total - this.perSubmittedPage, total);
            }
            return currentData;
        },
        submittedRows(){
            let data = this.submittedRFQ;
            if (this.filterSubmittedRFQ.trim() != "" && this.filterSubmittedRFQ) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterSubmittedRFQ.toUpperCase());
                });
            }
            return data.length;
        },
        filteredPostedRFQ() {
            let data = this.posted;
            var total = this.currentPostedPage * this.perPostedPage;
            if (this.filterPostedRFQ.trim() != "" && this.filterPostedRFQ) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterPostedRFQ.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPostedPage, total);
            if (this.currentPostedPage > 1 && currentData.length == 0) {
                total = (this.currentPostedPage - 1) * this.perPostedPage;
                currentData = data.slice(total - this.perPostedPage, total);
            }
            return currentData;
        },
        postedRows(){
            let data = this.posted;
            if (this.filterPostedRFQ.trim() != "" && this.filterPostedRFQ) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterPostedRFQ.toUpperCase());
                });
            }
            return data.length;
        },
        filteredActivePosts() {
            let data = this.activePosts;
            var total = this.currentPageItem * this.perPageItem;
            if (
                this.filterActive.trim() != "" &&
                this.filterActive
            ) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterActive.toUpperCase());
                });
            }
            data = data.slice(total - this.perPageItem, total);
            return data;
        },
        filteredExpiredPosts() {
            let data = this.expiredPosts;
            var total = this.currentPageItem * this.perPageItem;
            if (
                this.filterExpired.trim() != "" &&
                this.filterExpired
            ) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterExpired.toUpperCase());
                });
            }
            data = data.slice(total - this.perPageItem, total);
            return data;
        },
    },
    methods: {
        async changeCycle(cycle) {
            await this.getAvailableItems(cycle, this.$store.state.data.selectedCampus.id);
            await this.getCanceledItems(cycle, this.$store.state.data.selectedCampus.id);
            await this.getSubmittedRFQ(cycle, this.$store.state.data.selectedCampus.id);
            await this.getPostedRFQ(cycle, this.$store.state.data.selectedCampus.id);
            await this.getWavedItems(cycle, this.$store.state.data.selectedCampus.id);
            await this.getCartItems(cycle, this.$store.state.data.selectedCampus.id);
            this.getRecanvases(cycle, this.$store.state.data.selectedCampus.id);
        },
        async changeCampus(campusId) {
            this.pageLoader(true);
            this.onResetRFQ();
            await this.getAvailableItems(this.$store.state.data.cycle, campusId);
            await this.getCanceledItems(this.$store.state.data.cycle, campusId);
            await this.getSubmittedRFQ(this.$store.state.data.cycle, campusId);
            await this.getPostedRFQ(this.$store.state.data.cycle, campusId);
            await this.getWavedItems(this.$store.state.data.cycle, campusId);
            await this.getCartItems(this.$store.state.data.cycle, campusId);
            await this.getBacSettings(campusId);
            this.getActivePosts(campusId);
            this.getExpiredPosts(campusId);
            this.getRecanvases(this.$store.state.data.cycle, campusId);
            this.pageLoader(false);
        },
        getPublicPosts(){
            this.getActivePosts(this.$store.state.data.selectedCampus.id);
            this.getExpiredPosts(this.$store.state.data.selectedCampus.id);
        },
        async getActivePosts(campusId){
            this.activeBusy = true;
            this.activePosts = [];
            await this.$store.dispatch("publicpostedrfq/GetActivePublicPostRfqByCampus", campusId).then((res) => {
                if(res.data.error){
                    return this.showToast(res.data.errorMessage, "error");
                }
                res.data.map(item => {
                    item.visible = true;
                    item.detailShow = true;
                    item.searchKey = item.rfqNumber + " " + item.description;
                    item.postOptionShow = false;
                    item.postLoading = false;
                    item.posts = [];
                })
                this.activePosts = res.data;
            });
            this.activeBusy = false;
        },
        async getExpiredPosts(campusId){
            this.expiredBusy = true;
            this.expiredPosts = [];
            await this.$store.dispatch("publicpostedrfq/GetArchivePublicPostRfqByCampus", campusId).then((res) => {
                if(res.data.error){
                    return this.showToast(res.data.errorMessage, "error");
                }
                res.data.map(item => {
                    item.visible = true;
                    item.detailShow = true;
                    item.searchKey = item.rfqNumber + " " + item.description;
                    item.postOptionShow = false;
                    item.postLoading = false;
                    item.posts = [];
                })
                this.expiredPosts = res.data;
            });
            this.expiredBusy = false;
        },
        async getBacSettings(campusId){
            await this.$store
                .dispatch(
                    "bacsetting/GetBacSetting",
                    campusId
                )
                .then((res) => {
                    this.bacSettings = res.data;
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        selectBacSetting(x){
            this.rfq.bacSettingId = x.id;
            this.getBacMembers(x.id);
        },
        async getBacMembers(id){
            this.bacMemberLoading = true;
            await this.$store
                .dispatch("bacsetting/GetBacMemberAll", id)
                .then((res) => {
                    this.bacMembers = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            this.bacMemberLoading = false;
        },
        async getWavedItems(cycle, campusId) {
            this.wavedBusy = true;
            await this.$store
                .dispatch("rfq/GetWavedItems", {cycle, campusId})
                .then(async (res) => {
                    this.wavedBusy = false;
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.filterKey = `${item.apiResource.itemName} ${item.apiResource.description} ${item.poNumber} ${item.rfqNumber} ${item.pr.prNumber}`
                        item.showDetails = false;
                        item.selected = false;
                    })
                    let grouped = [];
                    var groupedRfq = groupBy(res.data, "rfqId");
                    for(var key in groupedRfq){
                        grouped.push({
                            rfqId: key,
                            rfqNumber: groupedRfq[key][0].rfqNumber,
                            description: groupedRfq[key][0].pr.description,
                            prNumber: groupedRfq[key][0].pr.prNumber,
                            filterKey: `${groupedRfq[key][0].pr.description} ${groupedRfq[key][0].pr.prNumber} ${groupedRfq[key][0].rfqNumber}`,
                            visible: false,
                            selectItems: false,
                            selectAll: false,
                            searchItem: "",
                            rfqItems: groupedRfq[key]
                        });
                    }
                    this.waved = grouped;
                })
                .catch((err) => {
                    this.showToast("Something went wrong - getting posted RFQ", "error");
                });
            this.wavedBusy = false;
        },
        async getPostedRFQ(cycle, campusId) {
            this.postedBusy = true;
            this.posted = [];
            await this.$store
                .dispatch("rfq/GetPostedRfq", {cycle, campusId})
                .then(async (res) => {
                    if(res.data.error){
                        return this.showToast(`${res.data.errorMessage} - posted RFQ`, "error");
                    }
                    for await (const item of res.data) {
                        item.searchKey = `${item.description} ${item.prNumber} ${item.rfqNumber}`;
                        item.itemLoaded = false;
                        item.itemLoading = false;
                        item.visible = false;
                        item.itemVisible = false;
                        item.mop = this.mop.find((x) => x.value == item.modeOfProcurementId) ? this.mop.find((x) => x.value == item.modeOfProcurementId) : {text: 'N/A'};
                        item.supplierShow = false;
                        item.detailShow = true;
                        item.generatePO = false;
                        item.loadingPoNumber = false;
                        item.generatingPO = false;
                        item.itemMessage = "";
                        item.itemMsgType = "";
                        item.isPosting = false;
                        item.postingMessage = "";
                        item.errorPost = false;
                        item.migrationItems = [];
                        if (item.isMigration) {
                            await this.getMigrations(item);
                            this.loopCart(item.migrationItems, true);
                            item.rfqItems = item.migrationItems;
                        }
                        item.attachmentVisible = false
                        item.rfqFiles = [];
                        item.fileSearch = "";
                        item.attachmentLoading = true;
                        item.addDocu = false;
                        item.postOptionShow = false;
                        item.posts = [];
                        item.postLoading = false;
                        item.showBACMember = false;

                        item.publicPostedRfqs = [];
                        item.detailsLoaded = false;
                        item.rfqItems = [];
                        item.copyItems = [];
                        item.rfqBacSettings = [];
                        item.rfqSuppliers = [];
                        item.bacLoading = false;
                        item.rfqItemLoading = false;
                        item.selectItems = false;
                        item.forReAward = false;
                        item.forRecanvas = false;
                        item.selectAll = false;
                        item.poExist = true;

                        item.activityLoading = false;
                        item.rfqActivities = [];
                        item.showRfqActivity = false;
                        item.searchItem = "";
                        item.reAward = false;
                    }
                    this.posted = res.data;
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting posted RFQ",
                        "error"
                    );
                });
            this.postedBusy = false;
        },
        async getSubmittedRFQ(cycle, campusId) {
            this.submittedBusy = true;
            await this.$store
                .dispatch("rfq/GetSubmittedRfq", {cycle, campusId})
                .then(async (res) => {
                    for await (const item of res.data) {
                        item.searchKey = `${item.description} ${item.prNumber} ${item.rfqNumber}`;
                        item.itemLoaded = false;
                        item.itemLoading = false;
                        item.visible = false;
                        item.itemVisible = false;
                        item.addSupplier = false;
                        item.mop = this.mop.find((x) => x.value == item.modeOfProcurementId) ? this.mop.find((x) => x.value == item.modeOfProcurementId) : {text: 'N/A'};
                        item.supplierShow = false;
                        item.detailShow = true;
                        item.generatePO = false;
                        item.loadingPoNumber = false;
                        item.generatingPO = false;
                        item.supplierMessage = "";
                        item.supplierMsgType = "";
                        item.itemMessage = "";
                        item.itemMsgType = "";
                        item.isPosting = false;
                        item.postingMessage = "";
                        item.errorPost = false;
                        item.migrationItems = [];
                        item.bacApproved = false;
                        // if (item.isMigration) {
                        //     await this.getMigrations(item);
                        //     this.loopCart(item.migrationItems, true);
                        //     item.rfqItems = item.migrationItems;
                        // }
                        
                        item.attachmentVisible = false
                        item.rfqFiles = [];
                        item.fileSearch = "";
                        item.attachmentLoading = true;
                        item.addDocu = false;
                        item.postOptionShow = false;
                        item.posts = [];
                        item.showBACMember = false;

                        item.publicPostedRfqs = [];
                        item.detailsLoaded = false;
                        item.rfqItems = [];
                        item.copyItems = [];
                        item.rfqBacSettings = [];
                        item.rfqSuppliers = [];
                        item.bacLoading = false;
                        item.rfqItemLoading = false;
                        item.selectItems = false;
                        item.forReAward = false;
                        item.forRecanvas = false;
                        item.selectAll = false;
                        item.poExist = true;

                        item.activityLoading = false;
                        item.rfqActivities = [];
                        item.showRfqActivity = false;
                        item.searchItem = "";
                        item.reAward = false;
                        item.updateSorting = false;
                    }
                    this.submittedRFQ = res.data;
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting submitted RFQ",
                        "error"
                    );
                });
            this.submittedBusy = false;
        },
        async getMOP() {
            await this.$store
                .dispatch("modeofprocurement/GetModeOfProcurement")
                .then((res) => {
                    var mop = [{ text: "" }];
                    res.data.forEach((item) => {
                        mop.push({ text: item.name, value: item.id });
                    });
                    this.mop = mop;
                })
                .catch(() => {
                    this.showToast(
                        "Something went wrong - getting mode of procurement",
                        "error"
                    );
                });
        },
        async getUnits() {
            await this.$store
                .dispatch("unit/GetUnit")
                .then((res) => {
                    this.units = res.data;
                })
                .catch(() => {
                    this.showToast(
                        "Something went wrong - getting units",
                        "error"
                    );
                });
        },
        async getAvailableItems(cycle, campusId) {
            this.availableTable = [];
            this.availableBusy = true;
            await this.$store
                .dispatch("rfqitem/GetAvailablePRs", {cycle, campusId})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.availableBusy = false;
                    res.data.forEach((y) => {
                        y.checkAllWork = false;
                        y.showDetails = false;
                        y.searchKey = `${y.description} ${y.prNumber}`;
                        y.selectionActivated = false;
                        y.categoryGroups.map(x => {
                            x.checkAllItemCat = false;
                            x.prItems.forEach((item) => {
                                item.pr = {
                                    description: y.description,
                                    prNumber: y.prNumber,
                                    deliveryPeriod: y.deliveryPeriod,
                                    deliveryTerms: y.deliveryTerms,
                                    modeOfProcurementId: y.modeOfProcurementId,
                                    paymentTerms: y.paymentTerms,
                                }
                                item.prId = y.id;
                                item.catId = x.id;
                                item.toggleSelected = false;
                                item.submitError = false;
                                item.total = parseFloat(item.totalQuantity) * parseFloat(item.unitCost);
                            });
                        });
                    });
                    this.availableTable = res.data;
                })
                .catch((err) => {
                    this.availableBusy = false;
                    this.showToast(
                        "Something went wrong - getting available items",
                        "error"
                    );
                });
        },
        async getCanceledItems(cycle, campusId) {
            this.canceledTable = [];
            this.availableBusy = true;
            await this.$store
                .dispatch("rfqitem/GetCanceledPRs", {cycle, campusId})
                .then((res) => {
                    this.availableBusy = false;
                    res.data.forEach((y) => {
                        y.checkAllWork = false;
                        y.searchKey = "";
                        y.prItems.forEach((item) => {
                            item.toggleSelected = false;
                            item.submitError = false;
                            y.searchKey += item.apiResource.itemName + " ";
                        });
                    });
                    this.canceledTable = res.data;
                })
                .catch((err) => {
                    this.availableBusy = false;
                    this.showToast(
                        "Something went wrong - getting canceled items",
                        "error"
                    );
                });
        },
        async getCartItems(cycle, campusId) {
            this.cartItems = [];
            this.cartBusy = true;
            await this.$store
                .dispatch("rfq/GetRFQCarts", {cycle, campusId})
                .then(async (res) => {
                    if (res.data) {
                        res.data.migrationItems = [];
                        res.data.rfqItems.map(x => {
                            x.total = x.quantity * x.unitCost;
                        })
                        if (res.data.isMigration) {
                            await this.getMigrations(res.data);
                            if (res.data.migrationItems.length > 0) {
                                this.rfq.description =
                                    res.data.migrationItems[0].migrationPrItem.pr.description;
                            }
                        } 
                        this.loopCart(
                            res.data.isMigration
                                ? res.data.migrationItems
                                : res.data.rfqItems,
                            res.data.isMigration
                        );
                        this.rfq.id = res.data.id;
                        this.rfq.description = res.data.description;
                        this.rfq.modeOfProcurementId = res.data.modeOfProcurementId;
                        this.rfq.modeOfProcurement = this.mop.find(x => x.value == res.data.modeOfProcurementId).text;
                        this.rfq.deliveryTerms = res.data.deliveryTerms;
                        this.rfq.deliveryPeriod = res.data.deliveryPeriod;
                        this.rfq.paymentTerms = res.data.paymentTerms;
                        this.rfqMigration = res.data.isMigration;
                        this.cartItems = res.data.isMigration
                            ? res.data.migrationItems
                            : res.data.rfqItems;
                        this.cartCount = this.cartItems.length;
                        this.cartBusy = false;
                    } else {
                        this.cartCount = 0;
                        this.cartBusy = false;
                    }
                })
                .catch((err) => {
                    this.cartBusy = false;
                    this.showToast(
                        "Something went wrong - getting cart items",
                        "error"
                    );
                });
        },
        async getRecanvasItems(id){
            this.recanvasLoading = true;
            await this.$store
                .dispatch("rfqitem/GetRfqItems", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.error, "error");
                    }
                    res.data.map(x => {
                        x.total = parseFloat(x.quantity) * parseFloat(x.unitCost);
                    })
                    this.recanvasItems = res.data;
                    // this.loopCart(res.data, false);
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting recanvas items",
                        "error"
                    );
                });   
            this.recanvasLoading = false;
        },
        async getRecanvases(cycle, campusId){
            this.cartItems = [];
            this.cartBusy = true;
            await this.$store
                .dispatch("rfq/GetRecanvasItems", {cycle, campusId})
                .then(async (res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.recanvases = res.data;
                    if(res.data.length > 0){
                        let rfq = res.data[0];
                        await this.getRecanvasItems(rfq.id);
                        this.recanvasRfq.id = rfq.id;
                        this.recanvasRfq.description = rfq.description;
                        this.recanvasRfq.deliveryTerms = rfq.deliveryTerms;
                        this.recanvasRfq.deliveryPeriod = rfq.deliveryPeriod;
                        this.recanvasRfq.paymentTerms = rfq.paymentTerms;
                        this.recanvasRfq.modeOfProcurement = this.mop.find(x => x.value == rfq.modeOfProcurementId) ? this.mop.find(x => x.value == rfq.modeOfProcurementId).text : 'N/A';
                        this.selectedRecanvasRfq = rfq.id;
                    }
                })
                .catch((err) => {
                    this.cartBusy = false;
                    this.showToast(
                        "Something went wrong - getting recanvasses",
                        "error"
                    );
                });
        },
        async getMigrations(data) {
            await this.$store
                .dispatch("rfqitem/GetRfqItems", data.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.error, "error");
                    }
                    res.data.forEach((item) => {
                        item.prItem = {
                            apiResource: { ...item.migrationPrItem },
                            unitCost: item.migrationPrItem.unitCost,
                            total: item.migrationPrItem.total,
                            totalQuantity: 0,
                        };
                    });
                    data.migrationItems = res.data;
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting cart items",
                        "error"
                    );
                });
        },
        loopCart(row, isMigration = false) {
            if (isMigration) {
                row.forEach((item) => {
                    item.editQty = false;
                    item.prItem.totalQuantity = 0;
                    item.migrationPrItem.migrationPrItemDetails.forEach((x) => {
                        if (x.monthId == 1) {
                            item.JanValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 2) {
                            item.FebValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 3) {
                            item.MarValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 4) {
                            item.AprValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 5) {
                            item.MayValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 6) {
                            item.JuneValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 7) {
                            item.JulyValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 8) {
                            item.AugValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 9) {
                            item.SepValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 10) {
                            item.OctValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 11) {
                            item.NovValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 12) {
                            item.DecValue = parseFloat(x.quantity).toString();
                        }
                        item.prItem.totalQuantity += x.quantity;
                    });
                });
            } else {
                row.forEach((item) => {
                    item.editQty = false;
                    item.prItemDetails.forEach((x) => {
                        if (x.monthId == 1) {
                            item.JanValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 2) {
                            item.FebValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 3) {
                            item.MarValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 4) {
                            item.AprValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 5) {
                            item.MayValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 6) {
                            item.JuneValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 7) {
                            item.JulyValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 8) {
                            item.AugValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 9) {
                            item.SepValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 10) {
                            item.OctValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 11) {
                            item.NovValue = parseFloat(x.quantity).toString();
                        }
                        if (x.monthId == 12) {
                            item.DecValue = parseFloat(x.quantity).toString();
                        }
                    });
                });
            }
        },
        refreshData(idx) {
            if (idx == this.tabIndex) return;
            if (idx == 0) {
                this.getAvailableItems(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                this.getCanceledItems(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
            } else if (idx == 1) {
                this.getCartItems(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
            }
        },
        toggleSelectionMode() {
            this.singleSelection = !this.singleSelection;
            this.availableTable.forEach((item) => {
                item.checkAllWork = false;
                this.checkEntireWork(item);
            });
        },
        checkEntireWork(x) {
            x.categoryGroups.map((item) => {
                item.checkAllItemCat = x.checkAllWork;
                this.checkEntireItemCat(item, null);
            });
        },
        checkEntireItemCat(x, parent){
            x.prItems.map((item) => {
                item.toggleSelected = x.checkAllItemCat;
            });
            if(parent){
                let count = 0;
                parent.categoryGroups.map((item) => {
                    item.checkAllItemCat && count++;
                });
                parent.checkAllWork = count == parent.categoryGroups.length ? true : false;
            }
        },
        checkApiResource(y, parent) {
            let count = 0;
            y.prItems.forEach((item) => {
                item.toggleSelected && count++;
            });
            y.checkAllItemCat = count == y.prItems.length ? true : false;
            let countItemCat = 0;
            parent.categoryGroups.map((item) => {
                item.checkAllItemCat && countItemCat++;
            });
            parent.checkAllWork = countItemCat == parent.categoryGroups.length ? true : false;
        },
        sumUp(row) {
            row.submitError = false;
            row.q1 =
                (row.JanValue ? parseFloat(row.JanValue) : 0) +
                (row.FebValue ? parseFloat(row.FebValue) : 0) +
                (row.MarValue ? parseFloat(row.MarValue) : 0);
            row.q2 =
                (row.AprValue ? parseFloat(row.AprValue) : 0) +
                (row.MayValue ? parseFloat(row.MayValue) : 0) +
                (row.JuneValue ? parseFloat(row.JuneValue) : 0);
            row.q3 =
                (row.JulyValue ? parseFloat(row.JulyValue) : 0) +
                (row.AugValue ? parseFloat(row.AugValue) : 0) +
                (row.SepValue ? parseFloat(row.SepValue) : 0);
            row.q4 =
                (row.OctValue ? parseFloat(row.OctValue) : 0) +
                (row.NovValue ? parseFloat(row.NovValue) : 0) +
                (row.DecValue ? parseFloat(row.DecValue) : 0);
            row.totalQuantity = row.q1 + row.q2 + row.q3 + row.q4;
            row.total =
                parseFloat(row.totalQuantity) * parseFloat(row.unitCost);
        },
        addToCart(x) {
            if(this.cartItems.length > 0 && (x[0].prId != this.cartItems[0].prItem.prId)){
                return this.showToast("Cannot add items from different PR", "error");
            }
            this.rfq.description = x[0].pr.description;
            this.rfq.modeOfProcurementId = x[0].pr.modeOfProcurementId;
            this.rfq.modeOfProcurement = this.mop.find((y) => y.value == x[0].pr.modeOfProcurementId).text;
            this.rfq.deliveryTerms = x[0].pr.deliveryTerms;
            this.rfq.deliveryPeriod = x[0].pr.deliveryPeriod;
            this.rfq.paymentTerms = x[0].pr.paymentTerms;
            var selectedItems = cloneDeep(x);
            var prItemIds = [];
            var spliceThis = [];
            selectedItems.forEach((item) => {
                prItemIds.push(item.id);
                var prIndex = this.availableTable.findIndex((y) => y.id == item.prId);
                var catIndex = this.availableTable[prIndex].categoryGroups.findIndex((y) => y.id == item.catId);
                var prItemIndex = this.availableTable[prIndex].categoryGroups[catIndex].prItems.findIndex((z) => z.id == item.id);
                spliceThis.push({ prIndex: prIndex, prItemIndex: prItemIndex, catIndex: catIndex });
            });
            let data = {
                cycle: this.$store.state.data.cycle,
                prItemId: prItemIds,
                campusId: this.$store.state.data.selectedCampus.id,
            };
            this.$store
                .dispatch("rfqitem/CreateRfqItem", data)
                .then(async (res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.rfq.id = res.data.rfqId;
                    let rfqData = {
                        id: res.data.rfqId,
                        rfqItems: [],
                        rfqItemLoading: false,
                    };
                    this.cartBusy = true;
                    this.pageLoader(true);
                    await this.getRfqItems(rfqData);
                    this.pageLoader(false);
                    this.cartBusy = false;
                    this.cartItems = rfqData.rfqItems;
                    this.cartCount = spliceThis.length;
                    let splicing = sortBy(spliceThis, ['catIndex', 'prItemIndex']).reverse();
                    splicing.map((item) => {
                        this.availableTable[item.prIndex].categoryGroups[item.catIndex].prItems.splice(item.prItemIndex, 1);
                        if(this.availableTable[item.prIndex].categoryGroups[item.catIndex].prItems.length == 0){
                            this.availableTable[item.prIndex].categoryGroups.splice(item.catIndex, 1);
                        }
                        if (this.availableTable[item.prIndex].categoryGroups.length == 0) {
                            this.availableTable.splice(item.prIndex, 1);
                        }
                    });
                    this.tabIndex = 1;
                    this.showToast("Successfully moved to Bids/RFQ Form!", "success");
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - creating RFQ",
                        "error"
                    );
                });
        },
        loopMonthsForDeduction(row, result) {
            this.monthsNickname.forEach((item) => {
                if (
                    row[`${item}Value`] &&
                    parseFloat(row[`${item}Value`]) > 0
                ) {
                    result[`${item}Max`] =
                        parseFloat(result[`${item}Max`]) -
                        parseFloat(row[`${item}Value`]);
                    result[`${item}Value`] = result[`${item}Max`];
                }
            });
        },
        totalOrderedAmt() {
            return this.selectedItems.reduce((pv, cv) => {
                return pv + parseFloat(cv.total);
            }, 0);
        },
        totalUpdateAmt() {
            return this.updateItems.reduce((pv, cv) => {
                return pv + parseFloat(cv.total);
            }, 0);
        },
        deleteCartItem(x) {
            var index = this.cartItems.indexOf(x);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("rfqitem/DeleteRfqItem", x.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "warning"
                                );
                            }
                            this.cartItems.splice(index, 1);
                            this.cartCount--;
                            var prIndex = this.availableTable.findIndex(
                                (item) => item.id == x.prItem.prId
                            );
                            if (prIndex > -1) {
                                this.availableTable[prIndex].prItems.push({
                                    ...x.prItem,
                                    submitError: false,
                                    toggleSelected: false,
                                });
                            } else {
                                delete x.prItem.pr.prItems;
                                var prItems = cloneDeep(x);
                                delete prItems.prItem.pr;
                                var object = {
                                    ...x.prItem.pr,
                                    prItems: [
                                        {
                                            ...prItems.prItem,
                                            submitError: false,
                                            toggleSelected: false,
                                        },
                                    ],
                                    checkAllWork: false,
                                };
                                this.availableTable.push(object);
                            }
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast(
                                "Something went wrong - deleting RFQ",
                                "error"
                            );
                        });
                }
            });
        },
        onResetRFQ() {
            this.rfq = {
                id: 0,
                description: "",
                tracking: "",
                // resolutionNumber: "",
                modeOfProcurementId: "",
                deliveryTerms: "",
                paymentTerms: "",
                deliveryPeriod: "",
                deadline: "",
                supplierIds: [],
                cycle: this.$store.state.data.cycle,
                dateSubmitted: "",
                // bacSettingId: "",
                note: "",
            };
            this.recanvasRfq = {
                id: 0,
                description: "",
                tracking: "",
                // resolutionNumber: "",
                modeOfProcurementId: "",
                deliveryTerms: "",
                paymentTerms: "",
                deliveryPeriod: "",
                deadline: "",
                supplierIds: [],
                cycle: this.$store.state.data.cycle,
                dateSubmitted: "",
                // bacSettingId: "",
                note: "",
            }
            this.selectedSupplier = [];
        },
        checkOut(data) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to submit this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, submit it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("rfq/SubmitRfq", data)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "warning"
                                );
                            }
                            if(data.type === 'rfq'){
                                this.cartItems = [];
                                this.cartCount = 0;
                            }else{
                                let index = this.recanvases.findIndex(x => x.id == data.id);
                                this.recanvases.splice(index, 1);
                                this.recanvasItems = [];
                            }
                            this.getSubmittedRFQ(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                            this.tabIndex = 2;
                            this.onResetRFQ();
                            this.showToast("Successfully submitted!", "success");
                        })
                        .catch((err) => {
                            this.submitted = false;
                            this.showToast(
                                "Something went wrong - submitting RFQ",
                                "error"
                            );
                        });
                }
            });
        },
        postRFQ(row) {
            if(row.containsRealignedItem){
                return this.showToast("This RFQ contains realigned item. Please remove it first.", "warning");
            }
            var index = this.submittedRFQ.findIndex((x) => x.id == row.id);
            Swal.fire({
                title: "Are you sure?",
                text: "You want to make it as final?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, finalize it!",
            }).then(async (result) => {
                if (result.value) {
                    row.errorPost = false;
                    const wait = (delay, ...args) =>
                        new Promise((resolve) =>
                            setTimeout(resolve, delay, ...args)
                        );
                    row.isPosting = true;
                    let winner = [];
                    if (!row.itemLoaded) {
                        this.pageLoader(true);
                        row.postingMessage = "Getting Supplier offers...";
                        await wait(1000);
                        await this.showRfqSupplier(row);
                        this.pageLoader(false);
                    }
                    this.pageLoader(true);
                    row.postingMessage = "Determining the winner/s...";
                    await wait(3000);
                    for await (const item of row.rfqSuppliers) {
                        item.rfqSupplierOffers = [];
                        item.isWinner = false;
                        for await (const x of item.supplierRFQ) {
                            if (x.offer.isWinner) {
                                let win = winner.find(
                                    (y) => y.itemId == x.offer.rfqItemId
                                );
                                if (!win) {
                                    winner.push({
                                        itemId: x.offer.rfqItemId,
                                        winCount: 1,
                                    });
                                } else {
                                    win.winCount++;
                                    winner.splice(winner.indexOf(win), 1, win);
                                }
                                item.isWinner = true;
                            }
                            if (x.offer.id > 0) {
                                item.rfqSupplierOffers.push(x.offer);
                            }
                        }
                    }
                    if (winner.length == 0) {
                        row.postingMessage =
                            "No winner yet. Please check and try posting again";
                        row.errorPost = true;
                        this.pageLoader(false);
                        await wait(5000);
                        row.isPosting = false;
                        return;
                    }
                    let anomaly = false;
                    winner.forEach((item) => {
                        if (item.winCount > 1) {
                            anomaly = true;
                        }
                    });
                    if (anomaly) {
                        row.postingMessage = `There's an anomaly in the winner/s. Please check and try posting again.`;
                        row.errorPost = true;
                        this.pageLoader(false);
                        await wait(5000);
                        row.isPosting = false;
                        return;
                    }
                    if (winner.length > row.rfqItems.length) {
                        row.postingMessage = `There's an anomaly in the winner/s. Please check and try posting again.`;
                        row.errorPost = true;
                        this.pageLoader(false);
                        await wait(5000);
                        row.isPosting = false;
                        return;
                    }
                    row.postingMessage = "Posting the RFQ...";
                    this.$store
                        .dispatch("rfq/PostRfq", row.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            row.visible = false;
                            row.errorPost = false;
                            row.isPosting = false;
                            row.publicPostedRfqs = [];
                            row.detailsLoaded = false;
                            row.rfqItems = [];
                            row.rfqBacSettings = [];
                            row.rfqSuppliers = [];
                            row.bacLoading = false;
                            row.rfqItemLoading = false;
                            row.selectItems = false;
                            row.forReAward = false;
                            row.forRecanvas = false;
                            row.selectAll = false;
                            row.poExist = true;
                            this.submittedRFQ.splice(index, 1);
                            this.posted.push(row);
                            this.showToast("Successfully posted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("RFQ Item went wrong!", "error");
                        });
                }
            });
        },
        returnRFQ(row) {
            this.form.id = row.id;
            this.form.remarks = "";
            this.$bvModal.show("return-modal");
        },
        async showRfqSupplier(x) {
            x.supplierShow = !x.supplierShow;
            if (x.supplierShow && !x.itemLoaded) {
                x.itemLoading = true;
                if(x.rfqItems.length == 0){
                    await this.getRfqItems(x);
                }
                this.getRfqSupplier(x);
            }
        },
        async getRfqSupplier(x){
            await this.$store
                .dispatch("rfqsupplier/GetSingleRfqSupplierByRFQ", x.id ? x.id : x.rfqId)
                .then((res) => {
                    x.itemLoading = false;
                    if (res.data.error) {
                        return this.showToast(
                            res.data.errorMessage,
                            "error"
                        );
                    }
                    res.data.forEach((z) => {
                        var rfqItems = cloneDeep(x.rfqItems);
                        z.isWinner = false;
                        rfqItems.forEach((w) => {
                            w.clamped = false;
                            let offer = z.rfqSupplierOffers.find((a) => a.rfqItemId == w.id);
                            if (offer) {
                                offer.unit = this.units.find((a) => a.id == offer.unitId) || {};
                                offer.totalAmt = parseFloat(offer.unitCost) * parseFloat(offer.quantity);
                                offer.showMoreSpec = false;
                                offer.deliveryPeriod = parseFloat(offer.deliveryPeriod) > 0 ? parseFloat(offer.deliveryPeriod).toString() : "7";
                                rfqItems[rfqItems.indexOf(w)].offer = offer;
                                if(offer.isWinner){
                                    z.isWinner = true;
                                }
                            }
                        });
                        z.supplierRFQ = rfqItems;
                        z.visible = false;
                    });
                    x.itemLoaded = true;
                    x.rfqSuppliers = sortBy(res.data, ['supplier.name']);
                    let countPOExist = 0;
                    let isWinner = 0;
                    x.rfqSuppliers.map(item => {
                        countPOExist += item.withPo ? 1 : 0;
                        isWinner += item.isWinner ? 1 : 0;
                    })
                    x.poExist = countPOExist == isWinner;
                    // x.poExist = x.rfqSuppliers.filter(x=> x.withPo).length > 0 ? false : true;
                })
                .catch((err) => {
                    this.showToast("RFQ Item went wrong!", "error");
                });
        },
        getTotalPerPR(prItems) {
            return prItems.reduce((pv, cv) => {
                return pv + parseFloat(cv.total);
            }, 0);
        },
        getTotalABC(rfqItems){
            return rfqItems.reduce((pv, cv) => {
                return pv + (cv.offer.isWinner ? parseFloat(cv.total) : 0);
            }, 0);
        },
        autoGrow(element, size) {
            element.target.style.height = `${size}px`;
            element.target.style.height = `${element.target.scrollHeight}px`;
        },
        autoWidth(element, id) {
            let width = element ? element.length : 23;
            if(this.$refs[`ref-offer-${id}`]){
                let ref = this.$refs[`ref-offer-${id}`][0];
                ref.$el.style.width = `${width}ch`;
            }
        },
        getTotalByRow(z) {
            let qty = z.quantity ? this.getExactAmt(z.quantity) : 0;
            let unitCost = z.unitCost ? this.getExactAmt(z.unitCost) : 0;
            return parseFloat(qty) * parseFloat(unitCost);
        },
        updateOffer(data, index, id, returnDate, parentId) {
            this.submitted = false;
            data.forEach((item, index) => {
                item.offer.rfqSupplierId = id;
                item.offer.quantity = "" + item.offer.quantity + "";
                item.offer.unitCost = "" + item.offer.unitCost + "";
                item.filterKey = item.itemName + ' ' + item.description;
                item.offerIndex = index + 1;
                item.errorItemName = false;
                item.errorDescription = false;
                item.errorDelivery = false;
            });
            this.offers = cloneDeep(data);
            this.selectedSupplierIndex = cloneDeep(index);
            this.selectedSupplierId = cloneDeep(id);
            this.selectedRFQId = cloneDeep(parentId);
            this.returnDate = returnDate === '0001-01-01T00:00:00' ? new Date() : new Date(returnDate);
            this.modalTitle = `Update Offer`;
            this.$bvModal.show("offer-modal");
            this.$nextTick(() => {
                setTimeout(() => {
                    this.offers.forEach((item) => {
                        if (item.offer.deliveryPeriod && !item.offer.noOffer) {
                            this.autoWidth(item.offer.deliveryPeriod, item.offer.rfqItemId);
                        }
                        let element = this.$refs[`itemDescription${item.offer.rfqItemId}`];
                        if(element && element.length > 0) {
                            this.autoGrowTemplate(element[0], 15);
                        }
                    });
                }, 100);
            });
        },
        autoGrowTemplate(element, size){
            element.style.height = `${size}px`;
            element.style.height = `${element.scrollHeight}px`;
        },
        async saveReturnDate() {
            let returnBool = false;
            await this.$store
                .dispatch("rfqsupplier/UpdateReturnedDate", {
                    id: this.selectedSupplierId,
                    rfqDate: this.getDate(this.returnDate),
                })
                .then((res) => {
                    var rfqIndex = this.submittedRFQ.findIndex(
                        (x) => x.id == this.selectedRFQId
                    );
                    this.submittedRFQ[rfqIndex].rfqSuppliers[
                        this.selectedSupplierIndex
                    ].rfqReturnDate = this.getDate(this.returnDate);
                    returnBool = true;
                })
                .catch((err) => {
                    returnBool = true;
                });
            return returnBool;
        },
        async saveOffers() {
            await this.saveReturnDate();
            var count = 0;
            var errors = 0;
            var data = [];
            this.offers.forEach((item) => {
                if(parseFloat(item.offer.quantity) > 0 && parseFloat(item.offer.unitCost) > 0 && !item.offer.noOffer){
                    if((!item.offer.itemName.trim() || item.offer.itemName.trim().length < 3)){
                        errors++;
                        item.errorItemName = true;
                    }
                    if(!item.offer.description.trim()){
                        errors++;
                        item.errorDescription = true;
                    }
                    if(!item.offer.deliveryPeriod.trim()){
                        errors++;
                        item.errorDelivery = true;
                    }
                }
                if ((!item.offer.itemName.trim() || !parseFloat(item.offer.quantity) || !parseFloat(item.offer.unitCost)) && !item.offer.noOffer) {
                    count++;
                } else {
                    item.offer.unitId = item.offer.unit.id;
                    item.offer.index = this.offers.indexOf(item);
                    item.offer.totalAmt = parseFloat(this.getExactAmt(item.offer.quantity)) * parseFloat(this.getExactAmt(item.offer.unitCost));
                    data.push(item.offer);
                }
            });
            if(errors > 0){
                this.showToast(`You have ${errors} errors. Please check the inputs`, "warning");
                return this.submitted = true;
            }
            if (count == this.offers.length) {
                return this.showToast("Cannot save empty offer", "warning");
            }
            this.saveOfferMethod(data);
        },
        async saveOfferMethod(data) {
            let done = 0;
            for (const offer of data) {
                let offerRequest = cloneDeep(offer);
                offerRequest.unitCost = this.getExactAmt(offer.unitCost);
                offerRequest.quantity = this.getExactAmt(offer.quantity);
                offerRequest.itemName = offer.itemName.trim();
                offerRequest.description = offer.description.trim();
                if (offer.id > 0) {
                    await this.$store
                        .dispatch("rfqsupplieroffer/UpdateRSO", offerRequest)
                        .then((res) => {
                            this.offers[offer.index].offer = offerRequest;
                            done++;
                        })
                        .catch((err) => {
                            this.showToast("RFQ Item went wrong!", "error");
                        });
                } else {
                    await this.$store
                        .dispatch("rfqsupplieroffer/CreateRSO", offerRequest)
                        .then((res) => {
                            offerRequest.id = res.data.id;
                            this.offers[offer.index].offer = offerRequest;
                            done++;
                        })
                        .catch((err) => {
                            this.showToast("RFQ Item went wrong!", "error");
                        });
                }
            }
            if (done == data.length) {
                this.showToast("Successfully saved!", "success");
                var rfqIndex = this.submittedRFQ.findIndex((x) => x.id == this.offers[0].rfqId);
                this.submittedRFQ[rfqIndex].rfqSuppliers[this.selectedSupplierIndex].supplierRFQ = this.offers;
                this.offers = [];
                this.selectedSupplierIndex = -1;
                this.$bvModal.hide("offer-modal");
            }
        },
        getTotalOffer(data, type = "submitted") {
            if (type === "submitted") {
                return data.reduce((pv, cv) => {
                    return pv + (cv.offer.isWinner ? parseFloat(cv.offer.totalAmt) : 0);
                }, 0);
            } else {
                return data.reduce((pv, cv) => {
                    return pv + parseFloat(cv.totalAmt);
                }, 0);
            }
        },
        removeOffer(offer) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then(async (result) => {
                if (result.value) {
                    await this.$store
                        .dispatch("rfqsupplieroffer/DeleteRSO", offer.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.error, "error");
                            }
                            offer.id = 0;
                            offer.rfqSupplierId = 0;
                            offer.unitCost = "0";
                            offer.note = "";
                            offer.isWinner = false;
                            offer.totalAmt = 0;
                            this.showToast("Successfully deleted", "success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        returnRFQSubmit() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            this.$store
                .dispatch("rfq/ReturnRfq", this.form)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    var index = this.posted.findIndex(
                        (x) => x.id == this.form.id
                    );
                    let rfq = cloneDeep(this.posted[index]);
                    rfq.status = "SUBMITTED";
                    rfq.rfqSuppliers.forEach((z) => {
                        var rfqItems = cloneDeep(rfq.rfqItems);
                        rfqItems.forEach((w) => {
                            let offer = z.rfqSupplierOffers.find((a) => a.rfqItemId == w.id);
                            if (offer) {
                                offer.unit = this.units.find((a) => a.id == offer.unitId) || {};
                                offer.totalAmt = parseFloat(offer.unitCost) * parseFloat(offer.quantity);
                                rfqItems[rfqItems.indexOf(w)].offer = offer;
                            }
                        });
                        z.supplierRFQ = rfqItems;
                        z.visible = false;
                    });
                    this.submittedRFQ.push(rfq);
                    this.posted.splice(index, 1);
                    this.showToast("Successfully returned", "success");
                    this.$bvModal.hide("return-modal");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        addSup(id) {
            var index = this.submittedRFQ.findIndex((x) => x.id == id);
            var data = {
                rfqId: id,
                supplierId: this.addSupplier.id,
            };
            this.$store
                .dispatch("rfqsupplier/CreateRfqSupplier", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.supplier = cloneDeep(this.addSupplier);
                    res.data.supplierRFQ = this.submittedRFQ[index].rfqItems;
                    res.data.rfqSupplierOffers = [];
                    res.data.visible = false;
                    this.submittedRFQ[index].rfqSuppliers.push(res.data);
                    this.submittedRFQ[index].addSupplier = false;
                    this.addSupplier = {};
                    this.submittedRFQ[index].supplierMessage = `Successfully saved!`;
                    this.submittedRFQ[index].supplierMsgType = "success";
                    setTimeout(() => {
                        this.submittedRFQ[index].supplierMessage = "";
                    }, 5000);
                })
                .catch((err) => {
                    this.submittedRFQ[index].supplierMessage = `Error adding supplier!`;
                    this.submittedRFQ[index].supplierMsgType = "danger";
                    setTimeout(() => {
                        this.submittedRFQ[index].supplierMessage = "";
                    }, 5000);
                });
        },
        removeSup(xId, yId) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    var xIndex = this.submittedRFQ.findIndex((x) => x.id == xId);
                    var yIndex = this.submittedRFQ[xIndex].rfqSuppliers.findIndex((x) => x.id == yId);
                    this.$store
                        .dispatch("rfqsupplier/DeleteRfqSupplier", yId)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            this.submittedRFQ[xIndex].rfqSuppliers.splice(yIndex, 1);
                            this.showToast("Successfully deleted", "success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted", "error");
                        });
                }
            });
        },
        clearSelection() {
            this.availableTable.forEach((item) => {
                item.prItems.forEach((x) => {
                    x.toggleSelected = false;
                });
            });
        },
        async addMoreItems(row) {
            if (!row.itemLoaded) {
                this.pageLoader(true);
                await this.showRfqSupplier(row);
                this.pageLoader(false);
            }
            this.addItem = true;
            this.selectedRFQ = cloneDeep(row);
            this.selectedItems = [];
            this.tabIndex = 0;
        },
        cancelItems() {
            this.addItem = false;
            this.selectedRFQ = {};
            this.clearSelection();
            setTimeout(() => {
                this.tabIndex = 2;
            }, 50);
        },
        async addToRFQ() {
            var spliceThis = [];
            var done = 0;
            var xIndex = this.submittedRFQ.findIndex(
                (x) => x.id == this.selectedRFQ.id
            );
            for (const item of this.selectedAvailableItems) {
                var prIndex = this.availableTable.findIndex((y) => y.id == item.prId);
                var prItemIndex = this.availableTable[prIndex].prItems.findIndex((z) => z.id == item.id);
                spliceThis.push({ prIndex: prIndex, prItemIndex: prItemIndex });
                var data = {
                    rfqId: this.selectedRFQ.id,
                    prItemId: item.id,
                };
                await this.$store
                    .dispatch("rfqitem/CreateSingleRfqItem", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        var unit = this.units.find((y) => y.id == res.data.prItem.apiResource.unitId);
                        res.data.offer = {
                            id: 0,
                            rfqSupplierId: 0,
                            rfqItemId: res.data.id,
                            itemName: '',
                            description: '',
                            unitId: "",
                            unit: unit ? unit : {},
                            unitCost: "0",
                            quantity: "0",
                            note: "",
                            isWinner: false,
                            totalAmt: 0,
                        };
                        res.data.prItem.apiResource.unit = unit ? unit : {};
                        this.submittedRFQ[xIndex].rfqItems.push(res.data);
                        this.submittedRFQ[xIndex].rfqSuppliers.forEach((z) => {
                            var rfqItems = cloneDeep(this.submittedRFQ[xIndex].rfqItems);
                            rfqItems.forEach((w) => {
                                let offer = z.rfqSupplierOffers.find((a) => a.rfqItemId == w.id);
                                if (offer) {
                                    offer.unit = this.units.find((a) => a.id == offer.unitId) || {};
                                    offer.totalAmt = parseFloat(offer.unitCost) * parseFloat(offer.quantity);
                                    rfqItems[rfqItems.indexOf(w)].offer = offer;
                                }
                            });
                            z.supplierRFQ = rfqItems;
                            z.visible = false;
                        });
                        done++;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            if (done == this.selectedAvailableItems.length) {
                spliceThis
                    .sort((a, b) => b.prItemIndex - a.prItemIndex)
                    .forEach((item) => {
                        this.availableTable[item.prIndex].prItems.splice(
                            item.prItemIndex,
                            1
                        );
                        if (
                            this.availableTable[item.prIndex].prItems.length ==
                            0
                        ) {
                            this.availableTable.splice(item.prIndex, 1);
                        }
                    });
                this.cancelItems();
                this.submittedRFQ[xIndex].itemMessage = "Successfully added!";
                this.submittedRFQ[xIndex].itemMsgType = "success";
                setTimeout(() => {
                    this.submittedRFQ[xIndex].itemMessage = "";
                }, 5000);
            } else {
                this.cancelItems();
                this.submittedRFQ[xIndex].itemMessage = "Something went wrong!";
                this.submittedRFQ[xIndex].itemMsgType = "danger";
                setTimeout(() => {
                    this.submittedRFQ[xIndex].itemMessage = "";
                }, 5000);
            }
        },
        async removeItem(row, type) {
            var xIndex = -1;
             var yIndex = -1;
            if(type === 'submitted'){
                xIndex = this.submittedRFQ.findIndex((x) => x.id == row.rfqId);
                yIndex = this.submittedRFQ[xIndex].rfqItems.findIndex((x) => x.id === row.id);
            }else{
                xIndex = this.posted.findIndex((x) => x.id == row.rfqId);
                yIndex = this.posted[xIndex].rfqItems.findIndex((x) => x.id === row.id);
            }
            var realData = [row]; 
            // var realData = row.grouped ? row.children : [row]; 
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then(async (result) => {
                if (result.value) {
                    let done = 0;
                    for await(const child of realData){
                        await this.$store
                            .dispatch("rfqitem/DeleteRfqItem", child.id)
                            .then((res) => {
                                if (res.data.error) {
                                    return this.showToast(res.data.errorMessage, "error");
                                }
                                done++
                            })
                            .catch((err) => {});
                    }
                    if(done == realData.length){
                        if(type === 'submitted'){
                            this.submittedRFQ[xIndex].rfqItems.splice(yIndex, 1);
                        }else{
                            this.posted[xIndex].rfqItems.splice(yIndex, 1);
                        }
                        this.showToast("Successfully removed!", "success");
                        this.getAvailableItems(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                    }else{
                        this.showToast("Something went wrong!", "error");
                    }
                }
            });
        },
        printRFQ(id, type) {
            if(type === 'blank'){
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/Procurement/RFQ/Blank",
                    routeVariables: [id],
                });
            }else{
                this.$refs.printOpt.putOptions({
                    apiUrl: "api/Report/Procurement/RFQ",
                    routeVariables: [id],
                });
            }
            this.$bvModal.show("print-options-modal");
        },
        async printBacRes(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/BacRes",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        printNOA(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/NOA",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        printAbstract(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/Abstract",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        printInvitation(id, withSGD){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/RFQ/Invitation",
                routeVariables: [id, withSGD],
            });
            this.$bvModal.show("print-options-modal");
        },
        async openPO(item) {
            if(item.containsRealignedItem){
                return this.showToast("This RFQ contains realigned items. Please remove them first.", "warning");
            }
            item.loadingPoNumber = true;
            item.generatePO = true;
            let poNumber = await this.getPONumber();
            item.loadingPoNumber = false;
            this.po = {
                description: item.description,
                cycle: this.$store.state.data.cycle,
                rfqSupplierId: 0,
                poDateReceived: this.getDate(new Date()),
                poDate: this.getDate(new Date()),
                poNumber: poNumber,
            };
        },
        async getPONumber(){
            let poNumber = '';
            await this.$store.dispatch("po/GetPONumber", {cycle: this.$store.state.data.cycle, campusId: this.$store.state.data.selectedCampus.id}).then((res) => {
                if (res.data.error) {
                    this.showToast(res.data.errorMessage, "error");
                    return;
                }
                poNumber = res.data;
            });
            return poNumber;
        },
        async generatePO(item) {
            if(item.rfqSuppliers.length === 0){
                this.pageLoader(true);
                await this.getRfqSupplier(item);
                this.pageLoader(false);
            }
            for (const x of item.rfqSuppliers) {
                if (x.isWinner && !x.withPo) {
                    var data = {
                        ...this.po,
                        rfqSupplierId: x.id,
                        campusId: this.$store.state.data.selectedCampus.id,
                        deliveryInDays: 0,
                    };
                    await this.$store
                        .dispatch("po/CreatePo", data)
                        .then((res) => {
                            this.showToast("Successfully generated P.O - " + x.supplier.name, "success");
                        })
                        .catch((err) => {
                            this.showToast(
                                x.supplier.name -
                                    +"P.O Generation unsuccessful",
                                "error"
                            );
                        });
                }
            }
            item.generatePO = false;
            item.poExist = true;
        },
        getSuppliers(type) {
            if(type === 'rfq'){
                if (this.cartItems.length == 0) {
                    return this.showToast("No items in cart", "warning");
                }
                this.$refs.supplier.onModalOpen({
                    supplierSelected: this.selectedSupplier,
                });
                this.$refs.supplier.getData(this.rfq.id);
            }else{
                if (this.recanvasItems.length == 0) {
                    return this.showToast("No items in cart", "warning");
                }
                this.$refs.supplier.onModalOpen({
                    supplierSelected: this.selectedSupplier,
                });
                this.$refs.supplier.getData(this.recanvasRfq.id);
            }
            this.$bvModal.show("rfq-supplier-modal");
        },
        dropSuppliers(data) {
            this.selectedSupplier = cloneDeep(data);
        },
        removeSupplier(idx) {
            this.selectedSupplier.splice(idx, 1);
        },
        async addMoreSupplier(row) {
            let ssup = [];
            this.suppliers = [];
            row.rfqSuppliers.forEach((item) => {
                ssup.push(item.supplier);
            });
            this.$refs.supplier.onModalOpen({ supplierSelected: ssup });
            await this.$refs.supplier.getData(row.id);
            let suppliers = this.$refs.supplier.getSuppliers();
            suppliers.forEach((item) => {
                !item.selectedSup && this.suppliers.push(item);
            });
            row.addSupplier = true;
        },
        moveToCart(item) {
            if (this.cartCount > 0) {
                return this.showToast("Bids/RFQ Form is not empty", "warning");
            }
            this.rfq.description = item.description;
            let data = {
                cycle: this.$store.state.data.cycle,
                campusId: this.$store.state.data.selectedCampus.id,
                prId: item.id,
            };
            this.$store
                .dispatch("rfqitem/CreateRfqItem", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    // if (item.isMigrationPr) {
                    //     res.data.forEach((item) => {
                    //         item.prItem = {
                    //             apiResource: { ...item.migrationPrItem },
                    //             unitCost: item.migrationPrItem.unitCost,
                    //             total: item.migrationPrItem.total,
                    //             totalQuantity: 0,
                    //         };
                    //     });
                    // }
                    this.availableTable.splice(
                        this.availableTable.indexOf(item),
                        1
                    );
                    this.getCartItems(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                    // this.loopCart(res.data, item.isMigrationPr);
                    // this.cartItems = res.data;
                    // this.cartCount = res.data.length;
                    this.tabIndex = 1;
                    this.showToast(
                        "Successfully moved to Bids/RFQ Form!",
                        "success"
                    );
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - creating RFQ",
                        "error"
                    );
                });
        },
        async cancelPR(data) {
            // for await (const row of this.cartItems) {
            //     await this.$store
            //         .dispatch("rfqitem/DeleteRfqItem", row.id)
            //         .then((res) => {
            //             if (res.data.error) {
            //                 return this.showToast(res.data.errorMessage, "error");
            //             }
            //         })
            //         .catch((err) => {
            //             this.showToast("Something went wrong", "error");
            //         });
            // }
            this.$store
                .dispatch("rfq/DeleteRfq", data.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    if(data.type === 'rfq'){
                        this.cartItems = [];
                        this.cartCount = 0;
                        this.getAvailableItems(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                    }else{
                        let index = this.recanvases.findIndex(x => x.id === data.id);
                        this.recanvasItems = [];
                        this.recanvases.splice(index, 1);
                    }
                    this.onResetRFQ();
                    this.showToast("Successfully cancelled", "success");
                })
            
        },
        async markAsWinner(offer) {
            let data = {
                id: offer.id,
                IsWinner: offer.isWinner ? false : true,
            };
            await this.$store
                .dispatch("rfqsupplieroffer/MarkWinnerRSO", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    offer.isWinner = data.IsWinner;
                })
                .catch((err) => {
                    this.showToast("Something went wrong", "error");
                });
            
        },
        addToItemList(id) {
            this.$store
                .dispatch("rfqsupplieroffer/AddAllOfferToItem", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.showToast(
                        "Successfully added to Item List",
                        "success"
                    );
                })
                .catch((err) => {
                    this.showToast("Something went wrong", "error");
                });
        },
        onResetPublicPost(rfqId){
            this.publicPost = {
                id: 0,
                rfqId: rfqId,
                datePublish: null,
                publicationEnded: null,
                nonRefundableBidderFee: "",
                type: "",
            };
        },
        postToPublic(row) {
            this.selectedPublicRfq = cloneDeep(row);
            this.onResetPublicPost(row.id);
            this.modalTitle = "Add RFQ Public Posting";
            this.$bvModal.show("modal-post-to-public");
        },
        unPostToPublic(row, type = false){
            if(type){
                this.$store
                    .dispatch("publicpostedrfq/RemovePublicPostRfq", row.id)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.showToast("Successfully unposted!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Cannot be unpost!", "error");
                    });
            }else{
                let item = row.publicPostedRfqs[0];
                this.$store
                    .dispatch("publicpostedrfq/RemovePublicPostRfq", item.id)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        row.publicPostedRfqs.splice(0, 1);
                        this.showToast("Successfully unposted!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Cannot be unpost!", "error");
                    });
            }
            
        },
        postNow() {
            this.submitted = true;
            this.$v.publicPost.$touch();
            if (this.$v.publicPost.$invalid) {
                return;
            }
            let data = cloneDeep(this.publicPost);
            data.datePublish = this.getDate(this.publicPost.datePublish);
            data.publicationEnded = this.getDate(this.publicPost.publicationEnded);
            data.nonRefundableBidderFee = this.publicPost.nonRefundableBidderFee ? this.getExactAmt(this.publicPost.nonRefundableBidderFee) : 0;
            if(this.publicPost.id == 0){
                this.$store
                    .dispatch("publicpostedrfq/CreatePublicPostRfq", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.selectedPublicRfq.isPosting = true;
                        this.showToast("Successfully posted!", "success");
                        this.$bvModal.hide("modal-post-to-public");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }else{
                this.$store
                    .dispatch("publicpostedrfq/UpdatePublicPostRfq", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.activePosts.findIndex(x => x.id == this.publicPost.id);
                        this.activePosts.splice(index, 1, data);
                        this.showToast("Successfully updated!", "success");
                        this.$bvModal.hide("modal-post-to-public");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            
        },
        getPublicReference(row) {
            this.attachmentTitle = 'RFQ Public Reference'
            this.wActions = true;
            this.$refs.attachmentModal.setUploadOpt({
                type: "Public RFQ",
                placement: "left",
                folder: "Procurement",
            });
            this.$refs.attachmentModal.getData(row.id);
            this.$bvModal.show("upload-attachment-modal");
        },
        removeFromPublic(row) {
            this.$store
                .dispatch("publicpost/RemovePublicPostPRItem", row.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    row.isPublished = false;
                    this.showToast("Successfully removed!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        selectThisPR(row) {
            this.availableTable.map(x => {
                x.selectionActivated = false;
                x.checkAllWork = false;
                x.categoryGroups.map(y => {
                    y.checkAllItemCat = false;
                    y.prItems.map(z => {
                        z.toggleSelected = false
                    })
                })
            });
            row.selectionActivated = !row.selectionActivated;
            row.checkAllWork = row.selectionActivated;
            row.categoryGroups.map(y => {
                y.checkAllItemCat = row.selectionActivated;
                 y.prItems.map(z => {
                    z.toggleSelected = row.selectionActivated;
                })
            })
        },
        unSelectThisPR(row){
            row.selectionActivated = false;
            row.checkAllWork = false;
            row.categoryGroups.map(y => {
                y.checkAllItemCat = false;
                y.prItems.map(x => {
                    x.toggleSelected = false;
                });
            })
        },
        addAttachment(row, wActions) {
            this.wActions = wActions;
            let id = row ? row.id : this.selectedSupplierId;
            this.attachmentTitle = 'Supplier Offer Attachment'
            this.$refs.attachmentModal.setUploadOpt({
                type: "RFQ Supplier Item Offer",
                placement: "left",
                folder: "Procurement",
            });
            this.$refs.attachmentModal.getData(id);
            this.$bvModal.show("upload-attachment-modal");
        },
        updateRFQ(row) {
            this.rfqUpdate = {
                id: row.id,
                description: row.description,
                dateSubmitted: new Date(row.dateSubmitted),
                deadline: new Date(row.deadline),
                tracking: row.tracking,
                modeOfProcurementId: row.modeOfProcurementId,
                note: row.note,
            }
            this.$bvModal.show("rfq-update");
        },
        onSubmitUpdateRFQ() {
            let data = cloneDeep(this.rfqUpdate);
            let index = this.submittedRFQ.findIndex(x => x.id == data.id);
            data.deadline = this.getDate(data.deadline);
            data.dateSubmitted = this.getDate(data.dateSubmitted);
            this.$store
                .dispatch("rfq/UpdateRfq", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.submittedRFQ[index].description = data.description;
                    this.submittedRFQ[index].dateSubmitted = data.dateSubmitted;
                    this.submittedRFQ[index].deadline = data.deadline;
                    this.submittedRFQ[index].tracking = data.tracking;
                    this.submittedRFQ[index].mop = this.mop.find(x => x.value == data.modeOfProcurementId);
                    this.submittedRFQ[index].modeOfProcurementId = data.modeOfProcurementId;
                    this.submittedRFQ[index].note = data.note;
                    this.showToast("Successfully updated!", "success");
                    this.$bvModal.hide("rfq-update");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        getResourceInfo(id){
            this.$refs.resourceDetails.getApiResourceDetails(id);
            this.$bvModal.show("resource-details-modal");
        },
        getAttachments(row) {
            row.attachmentVisible = !row.attachmentVisible;
            if (row.attachmentVisible) {
                row.rfqFiles = [];
                row.fileSearch = "";
                row.attachmentLoading = true;
                this.$store
                    .dispatch("filemanager/GetFiles", {
                        id: row.id,
                        type: this.uploadOptions.type,
                    })
                    .then((res) => {
                        row.attachmentLoading = false;
                        row.rfqFiles = res.data;
                    })
                    .catch(() => {
                        row.attachmentLoading = false;
                        this.showToast(
                            "Something went wrong! - getting documents",
                            "error"
                        );
                    });
            }
        },
        searchDocu(row) {
            let data = row.rfqFiles;
            if (row.fileSearch.trim() != "" && row.fileSearch) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(row.fileSearch.toUpperCase());
                });
            }
            return data;
        },
        uploadedPosted(response, id) {
            var index = this.posted.findIndex((x) => x.id == id);
            this.posted[index].rfqFiles.push(response);
        },
        uploadedSubmitted(response, id) {
            var index = this.submittedRFQ.findIndex((x) => x.id == id);
            this.submittedRFQ[index].rfqFiles.push(response);
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        removeFile(id, parentId, type) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("filemanager/DeleteFile", id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            if (type === "posted") {
                                let index = this.posted.findIndex(
                                    (item) => item.id == parentId
                                );
                                let yIndex = this.posted[
                                    index
                                ].rfqFiles.findIndex((item) => item.id == id);
                                this.posted[index].rfqFiles.splice(
                                    yIndex,
                                    1
                                );
                            }  else {
                                let index = this.submittedRFQ.findIndex(
                                    (item) => item.id == parentId
                                );
                                let yIndex = this.submittedRFQ[
                                    index
                                ].rfqFiles.findIndex((item) => item.id == id);
                                this.submittedRFQ[index].rfqFiles.splice(
                                    yIndex,
                                    1
                                );
                            }
                            this.showToast("Successfully removed!", "success");
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        async getPublicPostAttachments(row) {
            row.postOptionShow = !row.postOptionShow;
            if(row.posts.length > 0) return;
            row.postLoading = true;
            await this.$store
                .dispatch("rfqpostingfile/GetRfqPostingFiles", row.id)
                .then(async (res) => {
                    for await(const item of res.data){
                        let attachments = [];
                        await this.$store.dispatch("filemanager/GetFiles", {id: item.id, type: this.publicPostOptions.type}).then(res => {
                            attachments = res.data;
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                        item.attachments = attachments;
                        item.showAttachment = false;
                    }
                    row.posts = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            row.postLoading = false;
        },
        async getPublicPostLabels(){
            await this.$store.dispatch('postingfilelabel/GetAllPFL')
                .then(res => {
                    this.publicPostLabels = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async addPublicPost(row){
            this.multipleFilePosting = [];
            this.filePostingType = 'add';
            this.modalTitle = 'Add Public Post Attachment';
            this.selectedRFQForPosting = row;
            this.$bvModal.show('rfq-posting-file-modal');
            if(this.publicPostLabels.length == 0){
                this.getPublicPostLoading = true;
                await this.getPublicPostLabels();
                this.getPublicPostLoading = false;
            }
            this.multipleFilePosting.push({
                id: 0,
                title: '',
                description: '',
                search: false,
            })
        },
        async updatePublicAttachment(row, parent){
            this.multipleFilePosting = [];
            this.filePostingType = 'update';
            this.modalTitle = 'Update Public Post Attachment';
            this.selectedRFQForPosting = parent;
            this.$bvModal.show('rfq-posting-file-modal');
            if(this.publicPostLabels.length == 0){
                this.getPublicPostLoading = true;
                await this.getPublicPostLabels();
                this.getPublicPostLoading = false;
            }
            this.multipleFilePosting.push(cloneDeep(row))
        },
        addMoreMultipleFiles(){
            this.multipleFilePosting.push({
                id: 0,
                title: '',
                description: '',
                search: false,
            });
        },
        removeMultipleFiles(index){
            this.multipleFilePosting.splice(index, 1);
        },
        async onSubmitPublicPostFile(){
            let data = cloneDeep(this.multipleFilePosting)
            data.map(x => {
                x.title = x.title.trim();
                x.description = x.description.trim();
                x.publicPostedRfqId = this.selectedRFQForPosting.id;
            });
            let fillUpFields = false;
            data.forEach(x => {
                if(x.title.trim() === ''){
                    fillUpFields = true;
                }
            });
            if(fillUpFields){
                return this.showToast('Please fill up all fields', 'warning');
            }
            if(this.filePostingType === 'add'){
                let error = 0;
                for await (const item of data) {
                    await this.$store.dispatch('rfqpostingfile/CreateRfqPostingFile', item)
                        .then(res => {
                            item.id = res.data.id;
                            item.showAttachment = false;
                            item.attachments = [];
                        })
                        .catch(() => {
                            error++;
                        });
                    this.selectedRFQForPosting.posts.push(item);
                }
                if(error > 0){
                    return this.showToast("Something went wrong!", "error");
                }
                this.showToast('Successfully added!', 'success');
                this.$bvModal.hide('rfq-posting-file-modal');
            }else{
                let item = data[0];
                await this.$store.dispatch('rfqpostingfile/UpdateRfqPostingFile', item)
                    .then(res => {
                        let index = this.selectedRFQForPosting.posts.findIndex(x => x.id == item.id);
                        this.selectedRFQForPosting.posts.splice(index, 1, item)
                        this.showToast('Successfully updated!', 'success');
                        this.$bvModal.hide('rfq-posting-file-modal');
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
        filteredFileLabel(title){
            let data = this.publicPostLabels;
            return data.filter(x => x.title.toUpperCase().includes(title.toUpperCase()));
        },
        selectFileLabel(item, index){
            this.multipleFilePosting[index].title = item.title;
            this.multipleFilePosting[index].description = item.description;
            this.multipleFilePosting[index].search = false;
        },
        closeThisLabel(){
            this.selectedPostedFile.search = false;
        },
        selectPostedFile(file){
            this.selectedPostedFile = file;
            file.search = true;
        },
        deletePublicAttachment(row, parent){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("rfqpostingfile/DeleteRfqPostingFile", row.id)
                        .then(() => {
                            let index = parent.posts.findIndex(
                                (item) => item.id == row.id
                            );
                            parent.posts.splice(index, 1);
                            this.showToast("Successfully removed!", "success");
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        uploadedPublicPostAttachment(file, parent){
            this.selectedPost = parent;
            this.attachmentForPushing = file;
        },
        closePublicPostAttachment(post){
            post.showAttachment = false;
            this.selectedPost.attachments.push(this.attachmentForPushing);
        },
        removePublicPostAttachment(file, parent){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("filemanager/DeleteFile", file.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            let fileIndex = parent.attachments.findIndex(x => x.id == file.id);
                            parent.attachments.splice(fileIndex, 1);
                            this.showToast("Successfully removed!", "success");
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        updatePublicPosting(post){
            this.publicPost = cloneDeep(post);
            this.publicPost.datePublish = new Date(post.datePublish);
            this.publicPost.publicationEnded = new Date(post.publicationEnded);
            this.publicPost.nonRefundableBidderFee = post.nonRefundableBidderFee.toString();
            this.modalTitle = 'Update Public Posting';
            this.$bvModal.show('modal-post-to-public');
        },
        returnPRItems(prItem){
            this.returnPRItem = prItem;
            this.$bvModal.show('return-pr-item-modal');
        },
        returnPRItemSubmit(){
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            let data = {
                remarks: this.form.remarks,
                id: this.returnPRItem.id
            }
            this.$store
                .dispatch("pritem/ReturnPrItem", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.returnPRItem.status = 'Returned';
                    this.showToast("Successfully returned", "success");
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            this.$bvModal.hide('return-pr-item-modal');
        },
        addBACMember(parent){
            this.selectedPR = parent;
            this.$bvModal.show('add-member-modal');
        },
        updateBACMember(row, parent){
            this.selectedBACMember = row;
            this.selectedPR = parent;
            this.$refs.empModal.getSingleSelection();
            this.$bvModal.show('employee-modal');
        },
        selectBACEmployee(){
            this.selectedBACMember = null;
            this.$refs.empModal.getSingleSelection();
            this.$bvModal.show('employee-modal');
        },
        createMember(data){
            data.rfqId = this.selectedPR.id;
            data.status = 'PENDING';
            this.$store
                .dispatch("rfqbacsetting/AddBACMember", data)
                .then((res) => {
                    if(res.data.error){
                        this.showToast(res.data.errorMessage, 'error');
                    }
                    data.id = res.data.id;
                    this.selectedPR.rfqBacSettings.push(data);
                    this.$bvModal.hide("add-member-modal");
                    this.showToast("Successfully created!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        dropSingleEmployee(e) {
            if(!this.selectedBACMember){
                this.$refs.addBacModal.dropEmployee(e);
            }else{
                Swal.fire({
                    title: "Are you sure?",
                    text: "You want to change BAC Member?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes, change it!",
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.pageLoader(true);
                        let data = {
                            id: this.selectedBACMember.id,
                            applicationUserId: e.applicationUser.id,
                        };
                        await this.$store.dispatch('rfqbacsetting/ChangeBACMember', data).then(res => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            this.selectedBACMember.applicationUser = e.applicationUser;
                            this.selectedBACMember.employeeName = e.applicationUser.completeName;
                            this.showToast('Successfully changed!', 'success');
                        }).catch(err => {
                            this.showToast('Something went wrong!', 'error');
                        });
                        this.pageLoader(false);
                    }
                });
            }
        },
        didNotSubmit(supplier){
            let didNotSubmit = !supplier.didNotSubmit;
            let data = {
                id: supplier.id,
                status: didNotSubmit
            }
            this.$store
                .dispatch("rfqsupplier/RfqSupplierSubmission", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    supplier.didNotSubmit = didNotSubmit;
                    this.showToast("Successfully updated status", "success");
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        cashOnDelivery(supplier){
            let isCod = !supplier.isCod;
            let data = {
                id: supplier.id,
                status: isCod
            }
            this.$store
                .dispatch("rfqsupplier/RfqSupplierCOD", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    supplier.isCod = isCod;
                    this.showToast("Successfully updated status", "success");
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async noSupplierOffer(offer){
            let noOffer = !offer.noOffer;
            let data = { id: offer.id, status: noOffer}
            let done = 0;
            if(offer.id == 0){
                offer.unitId = offer.unit.id;
                offer.unitCost = offer.unitCost ? offer.unitCost : 0;
                await this.$store.dispatch("rfqsupplieroffer/CreateRSO", offer)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        data.id = res.data.id;
                        offer.id = res.data.id;
                    })
                    .catch((err) => {
                        return this.showToast("RFQ Item went wrong!", "error");
                    });
            }
            await this.$store
                .dispatch("rfqsupplieroffer/ChangeOfferStatus", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    done++;
                })
            if(done > 0){
                this.showToast("Successfully updated status", "success");
            }else{
                this.showToast("Something went wrong!", "error");
            }
        },
        deleteRFQ(id){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("rfq/DeleteRfq", id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = this.submittedRFQ.findIndex(x => x.id == id);
                            this.submittedRFQ.splice(index, 1);
                            this.getAvailableItems(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                            this.showToast("Successfully deleted", "success");
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        getQuotationItems(){
            this.getSubmittedRFQ(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
            this.getPostedRFQ(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
            this.getWavedItems(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        },
        async getRFQDetails(row){
            row.visible = !row.visible;
            if(row.visible && !row.detailsLoaded){
                row.detailsLoaded = false;
                await this.$store
                    .dispatch("rfq/GetSingleRfq", row.id)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        row.detailsLoaded = true;
                        row.datePosted = res.data.datePosted;
                        row.dateSubmitted = res.data.dateSubmitted;
                        row.deadline = res.data.deadline;
                        row.tracking = res.data.tracking;
                        row.note = res.data.note;
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
        async showRfqItems(row){
            row.itemVisible = !row.itemVisible
            if(row.itemVisible && row.rfqItems.length == 0){
                this.getRfqItems(row)
            }
        },
        async getRfqItems(row){
            row.rfqItemLoading = true;
            row.rfqItems = [];
            await this.$store
                .dispatch("rfqitem/GetRfqItems", row.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.error, "error");
                    }
                    let reAward = false;
                    res.data.forEach((x) => {
                        x.selected = false;
                        x.sortName = x.sort > 0 ? x.sort : x.itemName.replace(' - ', 'a').replace('-', '').replace('–', '').replace(':', '1').replace(/\s+/g,'').replace(/'/g, '').trim().toLowerCase();
                        x.sortDescription = x.sort > 0 ? x.sort : x.description.replace(' - ', 'a').replace('-', '').replace('–', '').replace(':', '1').replace(/'/g, '').replace(/\s+/g,'').replace(/[\r\n]/gm, '').trim().toLowerCase();
                        x.total = parseFloat(x.unitCost) * parseFloat(x.quantity);
                        x.grouped = false;
                        x.offer = {
                            id: 0,
                            rfqSupplierId: 0,
                            rfqItemId: x.id,
                            itemName: cloneDeep(x.itemName),
                            description: cloneDeep(x.description),
                            unitId: "",
                            unit: x.unit,
                            quantity: cloneDeep(x.quantity).toString(),
                            unitCost: "",
                            note: "",
                            isWinner: false,
                            totalAmt: parseFloat(x.unitCost) * parseFloat(x.quantity),
                            specification: "",
                            brand: "",
                            model: "",
                            color: "",
                            dimensionDescription: "",
                            materialUsed: "",
                            packageDescription: "",
                            condition: "",
                            deliveryPeriod: "7",
                        };
                        x.prItem = { id: x.prItemId, status: 'Approved'}
                        if(x.isReAward){
                            reAward = true;
                        }
                    });
                    row.reAward = reAward;
                    row.rfqItems = orderBy(res.data, ['sortName', 'sortDescription'], ['asc', 'asc']);
                    row.copyItems = cloneDeep(row.rfqItems);
                    // row.rfqItems = orderBy(res.data, ['sortName', 'sortDescription', 'quantity'], ['asc', 'asc', 'desc']);
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting cart items",
                        "error"
                    );
                });   
            row.rfqItemLoading = false;
        },
        async getRFQBacMembers(row){
            row.showBACMember = !row.showBACMember;
            if(row.showBACMember && row.rfqBacSettings.length == 0){
                row.bacLoading = true;
                await this.$store
                    .dispatch("rfqbacsetting/GetRfqBacSetting", row.id)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.error, "error");
                        }
                        row.rfqBacSettings = res.data;
                    })  
                row.bacLoading = false;
            }
        },
        selectAllItems(rfq){
            rfq.rfqItems.map(x => x.selected = rfq.selectAll)
        },
        selectRfqItem(rfq){
            if(rfq.forRecanvas){
                let count = rfq.rfqItems.filter(x => x.selected).length;  
                rfq.selectAll = count == rfq.rfqItems.length;   
            }else{
                let count = rfq.rfqItems.filter(x => x.selected && x.isReAward).length;  
                rfq.selectAll = count == rfq.rfqItems.filter(x => x.isReAward).length;
            }
           
        },
        countItemSelected(rfq, type){
            if(type === 'reaward'){
                return rfq.rfqItems.filter(x => x.selected && x.isReAward).length;
            }
            return rfq.rfqItems.filter(x => x.selected).length;
        },
        recanvasItem(rfq){
            let items = rfq.rfqItems.filter(x => x.selected);
            if(items.length == 0){
                return this.showToast("Please select item(s) to recanvass", "error");
            }
            let data = [];
            items.forEach(x => {
                data.push(x.id)
            })
            this.$store
                .dispatch("rfq/RecanvasItems", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.getRecanvases(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
                    this.showToast("Successfully recanvased", "success");
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        cancelSelectionOfItems(rfq){
            rfq.selectItems = false;
            rfq.rfqItems.map(x => x.selected = false);
            rfq.selectAll = false;
        },
        async changeRfq(rfqId){
            this.selectedRecanvasRfq = parseInt(rfqId);
            if(rfqId == 0){
                this.recanvasItems = [];
                this.recanvasRfq = {
                    id: 0,
                    description: "",
                };
                return;
            }
            let rfq = this.recanvases.find(x => x.id == rfqId);
            await this.getRecanvasItems(rfqId);
            this.recanvasRfq.id = rfq.id;
            this.recanvasRfq.description = rfq.description;
        },
        filteredRfqItems(rfq){
            let data = rfq.rfqItems;
            if(rfq.reAward){
                data = rfq.rfqItems.filter(x => x.isReAward);
            }
            if(rfq.searchItem && rfq.searchItem != ""){
                data = data.filter(x => x.itemName.toLowerCase().includes(rfq.searchItem.toLowerCase()))
            }
            return data;
        },
        regenerateRFQ(row){
            Swal.fire({
                title: "Are you sure?",
                text: `You want to regenerate RFQ Number`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28c76f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, regenerate it!",
            }).then((result) => {
                if(!result.value){
                    return;
                }
                this.$store
                    .dispatch("rfq/RegenerateRfqNumber", row.id)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        row.rfqNumber = res.data;
                        this.showToast("Successfully regenerated", "success");
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            })
        },
        changeRFQNo(row){
            this.$bvModal.show('rfq-number-modal');
            this.$refs.rfqNumberModal.getRFQ(row);
            this.selectedRFQForChanging = row;
        },
        updateRFQNumber(rfqNumber){
            this.selectedRFQForChanging.rfqNumber = rfqNumber;
        },
        async getPostedDetails(row){
            await this.getRFQDetails(row);
            if(row.visible){
                await this.getRfqItems(row);
                this.getRfqSupplier(row);
            }
        },
        async changeUnit(rfqItem){
            this.selectedRfqItem = rfqItem;
            this.pageLoader(true);
            try{
                const {data} =  await this.$store.dispatch("apiresource/GetSinglePPMPItem", rfqItem.apiResourceId)
                this.updateUnit = data;
                this.$refs.unit.tableData = cloneDeep(this.units);
                this.$bvModal.show("unit-modal");
            }catch(err){
                this.showToast("Something went wrong!", "error");
            }
            this.pageLoader(false);
        },
        dropUnit(data) {
            Swal.fire({
                title: "Are you sure?",
                text: `You want to update the unit from ${this.selectedRfqItem.unit.shortName} to ${data.shortName}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28c76f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, update it!",
            }).then((result) => {
                if(!result.value){
                    return;
                }
                let requestData = cloneDeep(this.updateUnit);
                requestData.unitId = data.id;
                this.$store
                    .dispatch("apiresource/UpdatePPMPItem", requestData)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.selectedRfqItem.unit = data;
                        let rfq = this.submittedRFQ.find(x => x.id == this.selectedRfqItem.rfqId);
                        if(rfq.rfqSuppliers.length > 0){
                            rfq.rfqSuppliers.map(x => {
                                let index = x.supplierRFQ.findIndex(y => y.id == this.selectedRfqItem.id);
                                if(index != -1){
                                    x.supplierRFQ[index].unit = data;
                                }
                            })
                        }
                        this.showToast("Successfully updated", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            });
        },
        async getRfqActivities(row){
            row.showRfqActivity = !row.showRfqActivity;
            if(this.bacActivities.length == 0){
                this.getBacActivities();
            }
            if(row.rfqActivities.length == 0){
                row.activityLoading = true;
                await this.$store.dispatch('rfqactivity/GetRfqActivity', row.id)
                    .then(res => {
                        res.data.map(item => {
                            item.dateWTime = this.formatDateWithTime(
                                new Date(item.activityDateTime)
                            );
                            item.splitted = item.dateWTime.split(" at ");
                        })
                        row.rfqActivities = res.data;
                    })
                    .catch(err => {
                        this.showToast("Something went wrong!", "error");
                    })
                row.activityLoading = false;
            }
        },
        resetActivity(id){
            this.rfqActivity = {
                id: 0,
                rfqId: id,
                name: '',
                description: '',
                activityDateTime: new Date(),
                remarks: '',
                status: '',
            }
        },
        addNewActivity(row){
            this.selectedRfqForAct = row;
            this.resetActivity(row.id);
            this.modalTitle = "Add New Activity";
            this.$bvModal.show('rfq-activity-modal');
        },
        updateRfqActivity(row, parent){
            this.selectedRfqForAct = parent;
            this.rfqActivity = cloneDeep(row);
            this.rfqActivity.activityDateTime = new Date(row.activityDateTime);
            this.modalTitle = "Update Activity";
            this.$bvModal.show('rfq-activity-modal');
        },
        typeRfqActivity(){
            this.searchActivity = true;
        },
        closeTypeActivity(){
            this.searchActivity = false;
        },
        selectBacActivity(item){
            this.rfqActivity.name = item.name;
            this.rfqActivity.description = item.description;
        },
        async getBacActivities(){
            await this.$store.dispatch('bacactivity/GetAllBacActivity', this.$store.state.data.selectedCampus.id)
                .then(res => {
                    this.bacActivities = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async onSubmitRfqActivity(){
            let data = cloneDeep(this.rfqActivity);
            data.activityDateTime = this.getDate(data.activityDateTime);
            if(this.rfqActivity.id > 0){
                await this.$store.dispatch('rfqactivity/UpdateRfqActivity', data).then(res => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.selectedRfqForAct.rfqActivities.findIndex(x => x.id == this.rfqActivity.id);
                    data.dateWTime = this.formatDateWithTime(new Date(data.activityDateTime));
                    data.splitted = data.dateWTime.split(" at ");
                    this.selectedRfqForAct.rfqActivities.splice(index, 1, data);
                    this.showToast("Successfully updated", "success");
                    this.$bvModal.hide('rfq-activity-modal');
                }).catch((err) => {
                    this.showToast("Something went wrong!", "error");
                })
            }else{
                await this.$store.dispatch('rfqactivity/CreateRfqActivity', data).then(res => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.showToast("Successfully added", "success");
                    res.data.dateWTime = this.formatDateWithTime(new Date(res.data.activityDateTime));
                    res.data.splitted = res.data.dateWTime.split(" at ");
                    this.selectedRfqForAct.rfqActivities.push(res.data);
                    this.$bvModal.hide('rfq-activity-modal');
                }).catch(() => {
                    this.showToast("Something went wrong!", "error");
                })
            }
        },
        removeRfqActivity(row, parent){
            Swal.fire({
                title: "Are you sure?",
                text: `You want to remove this activity?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if(!result.value){
                    return;
                }
                this.$store.dispatch('rfqactivity/DeleteRfqActivity', row.id).then(res => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.showToast("Successfully removed", "success");
                    let index = parent.rfqActivities.findIndex(x => x.id == row.id);
                    parent.rfqActivities.splice(index, 1);
                }).catch(() => {
                    this.showToast("Something went wrong!", "error");
                })
            });
        },
        getOffer(offer, itemId){
            let index = offer.findIndex(x => x.offer.rfqItemId === itemId);
            return offer[index];
        },
        async reawardItem(row){
            await this.$store.dispatch('rfq/ReAwardItem', row.iarItemId).then(res => {
                if(res.data.error){
                    return this.showToast(res.data.errorMessage, "error");
                }
                let parentIndex = this.waved.findIndex(x => x.rfqId == row.rfqId);
                let childIndex = this.waved[parentIndex].rfqItems.find(x => x.iarItemId == row.iarItemId);
                this.waved[parentIndex].rfqItems.splice(childIndex, 1);
                if(this.waved[parentIndex].rfqItems.length == 0){
                    this.waved.splice(parentIndex, 1);
                }
            }).catch((err) => {
                this.showToast("Something went wrong!", "error");
            })
        },
        handleMouseDown(e, item) {
            if(item.withChild){
                return;
            }
            this.movePrItem = item;
            e.target.style.cursor = 'grabbing';
            e.target.parentNode.parentNode.setAttribute('draggable', 'true');
        },
        handleMouseUp(e, item) {
            if(item.withChild){
                return;
            }
            e.target.style.cursor = 'grab';
            e.target.parentNode.parentNode.setAttribute('draggable', 'false');
        },
        onDropZone(e, item, rfq) {
            if(rfq.updateSorting){
                if(this.movePrItem.rfqId != item.rfqId) return;
                let fromIndex = rfq.rfqItems.findIndex(x => x.id == this.movePrItem.id);
                let toIndex = rfq.rfqItems.findIndex(x => x.id == item.id);
                if(fromIndex < -1) return;
                if(toIndex < -1) return;
                const element = rfq.rfqItems.splice(fromIndex, 1)[0];
                rfq.rfqItems.splice(toIndex, 0, element);
            }else{
                if(this.movePrItem.prItemId == item.prItemId){
                    return;
                }
                if(this.movePrItem.unitCost != item.unitCost){
                    this.showToast('Cannot consolidate items with different unit cost!', 'error')
                    return;
                }
                Swal.fire({
                    title: 'Are you sure?',
                    text: `You want to consolidate item '${this.movePrItem.itemName}' to '${item.itemName}'?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, transfer it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$store
                            .dispatch("pritem/SetParentPrItem", {
                                prItemId: this.movePrItem.prItemId,
                                parentId: item.prItemId,
                            })
                            .then((res) => {
                                this.getRfqItems(rfq)
                                this.showToast("Successfully consolidated!", "success");
                            })
                            .catch(() => {
                                this.showToast("Something went wrong!", "error");
                            });
                    }
                })
            }
        },
        async returnRfqFromWaived(form){
            await this.$store
                .dispatch("rfq/ReturnRfq", {
                    id: form.rfqId,
                    reason: 'Return RFQ because items were waived',
                    remarks: 'Return RFQ because items were waived',
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    var index = this.posted.findIndex((x) => x.id == form.rfqId);
                    let rfq = cloneDeep(this.posted[index]);
                    rfq.status = "SUBMITTED";
                    rfq.reAward = true;
                    rfq.rfqSuppliers.forEach((z) => {
                        var rfqItems = cloneDeep(rfq.rfqItems);
                        rfqItems.forEach((w) => {
                            let offer = z.rfqSupplierOffers.find((a) => a.rfqItemId == w.id);
                            if (offer) {
                                offer.unit = this.units.find((a) => a.id == offer.unitId) || {};
                                offer.totalAmt = parseFloat(offer.unitCost) * parseFloat(offer.quantity);
                                rfqItems[rfqItems.indexOf(w)].offer = offer;
                            }
                        });
                        z.supplierRFQ = rfqItems;
                        z.visible = false;
                    });
                    this.submittedRFQ.push(rfq);
                    this.posted.splice(index, 1);
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        reawardRfq(rfq){
            Swal.fire({
                title: 'Are you sure?',
                text: `You want to reaward this items?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, reaward this!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.reAwardRfqItems(rfq);
                    // let error = 0;
                    // for await(const x of rfq.rfqItems){
                    //     if(x.selected){
                    //         try{
                    //             let {data: response} = await this.$store.dispatch('rfqitem/ReAwardWavedItems', {
                    //                 id: x.rfqItemId
                    //             });
                    //             if(response.error){
                    //                 error++;
                    //                 return this.showToast(response.errorMessage, "error");
                    //             }
                    //             // await this.reawardItem(x);
                    //         }catch(err){
                    //             error++;
                    //             this.showToast("Something went wrong!", "error");
                    //         }
                    //     }
                    // }
                    // if(error == 0){
                    //     await this.returnRfqFromWaived(rfq);
                    //     this.showToast("Successfully reawarded!", "success");
                    // }else{
                    //     this.showToast("Something went wrong!", "error");
                    // }
                }
            })
        },
        async changeRfqAwardStatus(rfq){
            try{
                let {data: response} = await this.$store.dispatch('rfq/ReAwardRfq', {
                    id: rfq.id,
                    award: false
                });
                if(response.error){
                    return this.showToast(response.errorMessage, "error");
                }
                rfq.reAward = false;
            }catch(err){
                this.showToast("Something went wrong!", "error");
            }
        },
        showReAward(rfq){
            return rfq.rfqItems.filter(x => x.isReAward).length > 0;
        },
        selectForRecanvas(rfq){
            rfq.forReAward = false;
            rfq.forRecanvas = true;
            rfq.selectItems = true;
        },
        selectForReAward(rfq){
            rfq.forRecanvas = false;
            rfq.forReAward = true;
            rfq.selectItems = true;
        },
        async reAwardRfqItems(rfq){
            let selectedRfqItems = rfq.rfqItems.filter(x => x.selected);
            if(selectedRfqItems.length == 0){
                return this.showToast("Please select item(s) to reaward", "error");
            }
            rfq.rfqSuppliers = [];
            this.pageLoader(true);
            await this.getRfqSupplier(rfq);
            this.pageLoader(false);
            this.reaward.poNumber = "";
            let poNumber = await this.getPONumber();
            this.reaward.poNumber = poNumber;
            let rfqSuppliers = [];
            rfq.rfqSuppliers.map(item => {
                let items = [];
                rfqSuppliers.push({...item.supplier, rfqSupplierId: item.id});
                item.rfqSupplierOffers.map(offer => {
                    if(selectedRfqItems.find(x => x.rfqItemId == offer.rfqItemId)){
                        let rfqItem = selectedRfqItems.find(y => y.rfqItemId == offer.rfqItemId)
                        items.push({
                            ...offer, 
                            mustQuantity: rfqItem ? rfqItem.quantity : 0,
                            mustTotal: rfqItem ? parseFloat(rfqItem.quantity) * parseFloat(rfqItem.apiResource.unitCost) : 0,
                            error: false,
                            errorMessage: ''
                        });
                    }
                })
                item.reawardItemOffers = items;
            })
            this.selectedRfqForReAward = cloneDeep(rfq);
            this.reawardRfqSuppliers = cloneDeep(rfqSuppliers);
            this.reawardItems = [];
            this.reaward.rfqSupplierId = null;
            this.modalTitle = "Re-award RFQ Items";
            this.$bvModal.show('re-award-modal');
        },
        async approveForReaward(){
            this.submitted = true;
            this.$v.reaward.$touch();
            if (this.$v.reaward.$invalid) {
                return;
            }
            this.reawardItems.map(items => items.error = false);
            let selectedRfqItems = this.selectedRfqForReAward.rfqItems.filter(x => x.selected);
            let rfqSupplier = this.selectedRfqForReAward.rfqSuppliers.find(x => x.id == this.reaward.rfqSupplierId);
            if(!rfqSupplier){
                return this.showToast("Please select supplier", "error");
            }
            let notFoundItems = [];
            let foundItems = [];
            selectedRfqItems.map(item => {
                if(item.selected){
                    let found = this.reawardItems.find(x => x.rfqItemId == item.rfqItemId);
                    if(found.id && found.unitCost > 0){
                        // let err = parseFloat(found.quantity) * parseFloat(found.unitCost) > found.mustTotal;
                        foundItems.push({
                            rfqSupplierOfferId: found.id,
                            quantity: this.getExactAmt(found.quantity),
                            iarItemId: item.iarItemId,
                            // triggerWarning: err
                            triggerWarning: false
                        });
                        // if(err){
                        //     let ind = this.reawardItems.findIndex(x => x.rfqItemId == item.rfqItemId);
                        //     this.reawardItems[ind].error = err;
                        //     this.reawardItems[ind].errorMessage = `Total must not exceed to ${this.formatCurrency(found.mustTotal)}`;
                        // }
                    }else{
                        notFoundItems.push(item);
                    }
                }
            })
            if(notFoundItems.length){
                return this.showToast("Selected Supplier has no offer on these item(s): " + notFoundItems.map(x => x.apiResource.itemName).join(", "), "error");
            }
            if(foundItems.filter(x=> x.triggerWarning).length){
                return;
            }
            try{
                let {data: response} = await this.$store.dispatch('rfq/ReAwardWavedItems', foundItems);
                if(response.error){
                    return this.showToast(response.errorMessage, "error");
                }
                let parentIndex = this.waved.findIndex(x => x.rfqId == this.selectedRfqForReAward.rfqId);
                foundItems.forEach(item => {
                    let ind = this.waved[parentIndex].rfqItems.findIndex(i => i.iarItemId == item.iarItemId);
                    this.waved[parentIndex].rfqItems.splice(ind, 1);
                })
                if(this.waved[parentIndex].rfqItems.length == 0){
                    this.waved.splice(parentIndex, 1);
                }
                this.$bvModal.hide('re-award-modal');
                this.showToast("Successfully reawarded!", "success");
            }catch(err){
                this.showToast("Something went wrong!", "error");
            }
        },
        async postRfqFromWaived(row){
            let index = this.submittedRFQ.findIndex(x => x.id == row.id);
            await this.$store
                .dispatch("rfq/PostRfq", row.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    row.visible = false;
                    row.errorPost = false;
                    row.isPosting = false;
                    row.publicPostedRfqs = [];
                    row.detailsLoaded = false;
                    row.rfqItems = [];
                    row.rfqBacSettings = [];
                    row.rfqSuppliers = [];
                    row.bacLoading = false;
                    row.rfqItemLoading = false;
                    row.selectItems = false;
                    row.forReAward = false;
                    row.forRecanvas = false;
                    row.selectAll = false;
                    row.poExist = true;
                    this.submittedRFQ.splice(index, 1);
                    this.posted.push(row);
                })
                .catch((err) => {
                    this.showToast("RFQ Item went wrong!", "error");
                });
        },
        changeSupplier(event){
            let items = this.selectedRfqForReAward.rfqSuppliers.find(x => x.id == event);
            if(!items){
                return this.reawardItems = [];
            }
            items.reawardItemOffers.map(item => {
                item.quantity = item.mustQuantity.toString();
            })
            this.reawardItems = items.reawardItemOffers;
        },
        removeSelected(rfq){
            let items = rfq.rfqItems.filter(x => x.selected);
            if(items.length == 0){
                return this.showToast("Please select item(s) to remove", "error");
            }
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.value) {
                    let done = 0;
                    for await(const z of items){
                        await this.$store
                            .dispatch("rfqitem/DeleteRfqItem", z.id)
                            .then((res) => {
                                if (res.data.error) {
                                    return this.showToast(res.data.errorMessage, "error");
                                }
                                done++;
                                let xIndex = this.posted.findIndex(x => x.id == rfq.id);
                                let yIndex = this.posted[xIndex].rfqItems.findIndex(y => y.id == z.id);
                                this.posted[xIndex].rfqItems.splice(yIndex, 1);
                            })
                    }
                    if(done == items.length){
                        return this.showToast('Successfully removed', "success");
                    }
                    return this.showToast("Something went wrong", "error");
                }
            });
        },
        async viewConsolidatedItems(id, parent){
            this.$bvModal.show('consolidated-item-modal')
            this.selectedParentPrItemId = id;
            this.selectedConsolidatedParent = parent;
            this.showConsolidatedItems = true;
            await this.getConsolidatedItems(id)
            this.showConsolidatedItems = false;
        },
        async getConsolidatedItems(id){
            await this.$store
                .dispatch("pritem/GetItemByParent", id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error')
                    }
                    this.consolidatedItems = res.data.items;
                })
                .catch(() => {
                    this.showToast("Something went wrong!","error");
                });
        },
        removeFromConsolidation(row){
            this.$store
                .dispatch("pritem/SetParentPrItem", {
                    prItemId: row.id,
                    parentId: 0,
                })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    this.getRfqItems(this.selectedConsolidatedParent);
                    this.$bvModal.hide('consolidated-item-modal')
                    this.showToast("Successfully removed!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        addAllToItemList(rfqItems){
            let items = [];
            rfqItems.map(x => {
                items.push({ id: x.offer.id });
            });
            Swal.fire({
                title: "Are you sure?",
                text: "You want to add all item offers?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, add all!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("rfqsupplieroffer/AddAllOfferToItem", items)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            this.showToast("Successfully added to item list", "success");
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        filteredSupplierOffer(data, isReaward){
            let dat = data;
            if(isReaward){
                dat = data.filter(x => x.offer.id > 0);
            }
            return dat;
        },
        updateItemsSort(rfq){
            rfq.updateSorting = !rfq.updateSorting;
            if(rfq.updateSorting){
                rfq.copyItems = cloneDeep(rfq.rfqItems);
            }else{
                rfq.rfqItems = cloneDeep(rfq.copyItems);
            }
        },
        ifSortMoved(rfq){
            return JSON.stringify(rfq.rfqItems) != JSON.stringify(rfq.copyItems);
        },
        saveSort(rfq){
            let data = [];
            rfq.rfqItems.map((item, index) => {
                data.push({
                    id: item.id,
                    sort: index + 1
                })
            })
            Swal.fire({
                title: "Are you sure?",
                text: "You want to update the sorting?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, update!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("rfqitem/UpdateSorting", data)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            rfq.copyItems = cloneDeep(rfq.rfqItems);
                            this.showToast("Successfully updated!", "success");
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        deleteBACMember(row, parent){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await this.$store.dispatch('rfqbacsetting/DeleteBACMember', row.id).then(res => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        let index = parent.rfqBacSettings.findIndex(x => x.id == row.id);
                        parent.rfqBacSettings.splice(index, 1);
                        this.showToast('Successfully removed!', 'success');
                    }).catch(err => {
                        this.showToast('Something went wrong!', 'error');
                    });
                }
            });
        },
    },
};
</script>
<template>
    <Layout @changeCycle="changeCycle" @changeCampus="changeCampus($event.id)">
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="offer-modal"
            :title="modalTitle"
            size="xl"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <div class="d-flex justify-content-between mb-2">
                <div>
                    <label for="" class="mb-0 me-2 text-nowrap">Search Item:</label>
                    <div class="d-flex">
                        <input type="text" class="form-control w-250px" placeholder="Search Item..." v-model="searchOffer">
                        <b-form-select
                            class="form-select ms-1 w-25"
                            v-model="perOfferPage"
                            :options="offerPageOptions"
                        ></b-form-select>
                    </div>
                </div>
                <div>
                    <label for="" class="mb-0 me-2 text-nowrap">Date Returned:</label>
                    <date-picker
                        v-model="returnDate"
                        :first-day-of-week="1"
                        lang="en"
                        placeholder="Enter Date Returned..."
                        input-class="form-control text-green font-weight-bold"
                    ></date-picker>
                </div>
            </div>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>
                            Item Name
                            <div>
                                <small>Item Description</small>
                            </div>
                        </th>
                        <th style="width: 120px">Unit</th>
                        <th style="width: 150px">Qty</th>
                        <th style="width: 150px">Unit Cost</th>
                        <th style="width: 150px">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="offer in filteredOffers">
                        <tr :key="offer.id">
                            <td class="position-relative">
                                <RawData 
                                    :data="offer" 
                                    v-if="$store.state.decrypt.isAdmin()" 
                                    placement="left"
                                    :key="`offer-${offer.id}`"
                                />
                                <div class="rotate-270">
                                    <span class="badge bg-purple"
                                        >RFQ Item</span
                                    >
                                </div>
                                <div class="d-flex align-items-center">
                                    <div
                                        style="min-width: 30px;"
                                        class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                        :isDragPlaceHolder="true"
                                    >
                                        <h5
                                            class="
                                                mb-0
                                                position-relative
                                            "
                                        >
                                            {{
                                                offer.offerIndex
                                            }}
                                        </h5>
                                    </div>
                                    <span class="text-white">{{ offer.itemName }}</span>
                                </div>
                                <div>
                                    <small>{{ offer.description }}</small>
                                </div>
                            </td>
                            <td>{{ offer.unit.shortName }}</td>
                            <td>{{ offer.quantity }}</td>
                            <td>{{ formatCurrency(offer.unitCost) }}</td>
                            <td>{{ formatCurrency(offer.total) }}
                                <div class="form-check form-checkbox-outline form-check-success mb-0 mt-2">
                                    <input
                                        autocomplete="off"
                                        class="form-check-input"
                                        type="checkbox"
                                        :id="`no-offer-${offer.offer.id}`"
                                        v-model="offer.offer.noOffer"
                                        @click="noSupplierOffer(offer.offer)"
                                    />&nbsp;&nbsp;
                                    <label 
                                        class="form-check-label"
                                        :for="`no-offer-${offer.offer.id}`"
                                    >
                                        No offer
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr
                            :key="`offer${offer.id}`"
                            class="custom-border-2"
                            :class="{ 'border-success': offer.offer.isWinner }"
                            v-if="!offer.offer.noOffer"
                        >
                            <td class="position-relative">
                                <div class="rotate-270">
                                    <span class="badge bg-secondary"
                                        >Item Offer</span
                                    >
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        placeholder="Item Name"
                                        class="w-100 form-control mb-1 text-warning"
                                        v-model="offer.offer.itemName"
                                        :class="{'is-invalid': submitted && offer.errorItemName}"
                                    />
                                    <textarea
                                        type="text"
                                        placeholder="Item Description"
                                        class="w-100 form-control short text-warning resize-none mb-1"
                                        @input="autoGrow($event, 15)"
                                        rows="1"
                                        v-model="offer.offer.description"
                                        :ref="`itemDescription${offer.offer.rfqItemId}`"
                                        :class="{'is-invalid': submitted && offer.errorDescription}"
                                    ></textarea>
                                    <div class="d-flex mt-2 align-items-center justify-content-between">
                                        <div>
                                            <masked-input
                                                v-model="offer.offer.deliveryPeriod"
                                                class="
                                                    text-warning
                                                    font-weight-bold
                                                    span-form-control
                                                "
                                                role="textbox"
                                                placeholder="Delivery Period in Days"
                                                :ref="`ref-offer-${offer.offer.rfqItemId}`"
                                                :mask="dayMask"
                                                @input="autoWidth($event, offer.offer.rfqItemId)"
                                                :class="{'is-invalid': submitted && offer.errorDelivery}"
                                            ></masked-input>
                                            <span v-if="offer.offer.deliveryPeriod"
                                                >calendar day<span
                                                    v-if="
                                                        offer.offer.deliveryPeriod >
                                                        1
                                                    "
                                                    >s</span
                                                ></span
                                            >
                                        </div>
                                    </div>
                                    <a
                                        href="javascript:void(0);"
                                        :id="`moreSpec${offer.offer.id}`"
                                        ><i
                                            class="
                                                mdi mdi-plus
                                                rotate rotate-90
                                                me-1
                                            "
                                        ></i
                                        >Add More Specifications</a
                                    >
                                    <b-popover
                                        :target="`moreSpec${offer.offer.id}`"
                                        triggers="click"
                                        placement="right"
                                        :show.sync="offer.offer.showMoreSpec"
                                        custom-class="popover-supplier"
                                    >
                                        <template v-slot:title>
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                "
                                            >
                                                <small
                                                    >More Specifications</small
                                                >
                                                <span
                                                    class="
                                                        bx bx-x
                                                        font-size-14
                                                        cursor-pointer
                                                    "
                                                    @click="
                                                        offer.offer.showMoreSpec = false
                                                    "
                                                ></span>
                                            </div>
                                        </template>
                                        <div class="row mb-2">
                                            <div class="col-md-6">
                                                <label for="" class="mb-0"
                                                    >Brand</label
                                                >
                                                <input
                                                    type="text"
                                                    placeholder="Enter Brand"
                                                    class="
                                                        form-control
                                                        form-control-sm
                                                        text-warning
                                                    "
                                                    v-model="offer.offer.brand"
                                                />
                                            </div>
                                            <div class="col-md-6">
                                                <label for="" class="mb-0"
                                                    >Model</label
                                                >
                                                <input
                                                    type="text"
                                                    placeholder="Enter Model"
                                                    class="
                                                        form-control
                                                        form-control-sm
                                                        text-warning
                                                    "
                                                    v-model="offer.offer.model"
                                                />
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-6">
                                                <label for="" class="mb-0"
                                                    >Color</label
                                                >
                                                <input
                                                    type="text"
                                                    placeholder="Enter Color"
                                                    class="
                                                        form-control
                                                        form-control-sm
                                                        text-warning
                                                    "
                                                    v-model="offer.offer.color"
                                                />
                                            </div>
                                            <div class="col-md-6">
                                                <label for="" class="mb-0"
                                                    >Condition</label
                                                >
                                                <input
                                                    type="text"
                                                    placeholder="Enter Condition"
                                                    class="
                                                        form-control
                                                        form-control-sm
                                                        text-warning
                                                    "
                                                    v-model="
                                                        offer.offer.condition
                                                    "
                                                />
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-6">
                                                <label for="" class="mb-0"
                                                    >Material Used</label
                                                >
                                                <input
                                                    type="text"
                                                    placeholder="Enter Material Used"
                                                    class="
                                                        form-control
                                                        form-control-sm
                                                        text-warning
                                                    "
                                                    v-model="
                                                        offer.offer.materialUsed
                                                    "
                                                />
                                            </div>
                                            <div class="col-md-6">
                                                <label for="" class="mb-0"
                                                    >Package Description</label
                                                >
                                                <input
                                                    type="text"
                                                    placeholder="Enter Package Description"
                                                    class="
                                                        form-control
                                                        form-control-sm
                                                        text-warning
                                                    "
                                                    v-model="
                                                        offer.offer
                                                            .packageDescription
                                                    "
                                                />
                                            </div>
                                        </div>
                                        <div class="mb-2">
                                            <label for="" class="mb-0"
                                                >Dimension Description</label
                                            >
                                            <textarea
                                                rows="2"
                                                placeholder="Enter Dimension Description"
                                                class="
                                                    form-control form-control-sm
                                                    text-warning
                                                "
                                                v-model="
                                                    offer.offer
                                                        .dimensionDescription
                                                "
                                            ></textarea>
                                        </div>
                                        <div class="mb-2">
                                            <label for="" class="mb-0"
                                                >Other Specifications</label
                                            >
                                            <textarea
                                                rows="2"
                                                placeholder="Enter Other Specifications"
                                                class="
                                                    form-control form-control-sm
                                                    text-warning
                                                "
                                                v-model="
                                                    offer.offer.specification
                                                "
                                            ></textarea>
                                        </div>
                                        <div class="mb-2">
                                            <label for="" class="mb-0"
                                                >Notes</label
                                            >
                                            <textarea
                                                type="text"
                                                placeholder="Note Here"
                                                rows="2"
                                                class="
                                                    form-control form-control-sm
                                                    text-warning
                                                "
                                                v-model="offer.offer.note"
                                            ></textarea>
                                        </div>
                                        <hr />
                                        <div class="d-flex float-end mb-3">
                                            <button
                                                type="button"
                                                class="btn btn-primary me-1"
                                                @click="
                                                    offer.offer.showMoreSpec = false
                                                "
                                            >
                                                Save
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-link"
                                                @click="
                                                    offer.offer.showMoreSpec = false
                                                "
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </b-popover>
                                </div>
                            </td>
                            <td>
                                <multiselect
                                    v-model="offer.offer.unit"
                                    :options="units"
                                    :searchable="true"
                                    :close-on-select="true"
                                    label="shortName"
                                    :show-labels="false"
                                    :allow-empty="false"
                                    placeholder="Pick a value"
                                    input-class="text-warning"
                                    class="border-0"
                                ></multiselect>
                            </td>
                            <td>
                                <masked-input
                                    type="text"
                                    placeholder="Qty"
                                    class="w-100 form-control text-warning"
                                    :mask="currencyMask"
                                    v-model="offer.offer.quantity"
                                ></masked-input>
                            </td>
                            <td>
                                <masked-input
                                    placeholder="Unit Cost"
                                    class="w-100 form-control text-warning"
                                    :mask="currencyMask"
                                    v-model="offer.offer.unitCost"
                                ></masked-input>
                            </td>
                            <td>
                                <div class="form-control text-warning">{{ formatCurrency(getTotalByRow(offer.offer)) }}</div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <div class="text-right mb-3">
                <div class="row">
                    <div class="col">
                        <div
                            class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                            "
                        >
                            <ul
                                class="
                                    pagination pagination-rounded
                                    mb-0
                                "
                            >
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentOfferPage"
                                    :total-rows="offerRows"
                                    :per-page="perOfferPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer d-flex justify-content-between">
                <div>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="addAttachment(null, true)"
                    >
                        <i class="mdi mdi-paperclip"></i> Attachments
                    </button>
                </div>
                <div>
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="saveOffers"
                    >
                        Save &amp; Apply Changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('offer-modal')"
                    >
                        Close
                    </button>
                </div>
            </div>
        </b-modal>
        <b-modal
            id="return-pr-item-modal"
            title="Return Reason"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form @submit.prevent="returnPRItemSubmit" class="needs-validation">
                <b-row>
                    <b-col>
                        <div class="mb-3">
                            <label>Remarks </label>
                            <textarea
                                id="description"
                                rows="3"
                                v-model="form.remarks"
                                placeholder="Enter Remarks..."
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        submitted && $v.form.remarks.$error,
                                }"
                            ></textarea>
                            <div
                                v-if="submitted && $v.form.remarks.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.remarks.required"
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Return PR Item
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('return-pr-item-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="return-modal"
            title="Return Remarks"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form @submit.prevent="returnRFQSubmit" class="needs-validation">
                <b-row>
                    <b-col>
                        <div class="mb-3">
                            <label>Remarks </label>
                            <textarea
                                id="description"
                                rows="3"
                                v-model="form.remarks"
                                placeholder="Enter Remarks..."
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        submitted && $v.form.remarks.$error,
                                }"
                            ></textarea>
                            <div
                                v-if="submitted && $v.form.remarks.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.remarks.required"
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Return RFQ
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('return-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="modal-post-to-public"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <form @submit.prevent="postNow" class="needs-validation">
                <div class="mb-3">
                    <label>Publication Date </label>
                    <date-picker
                        v-model="publicPost.datePublish"
                        :first-day-of-week="1"
                        lang="en"
                        placeholder="Enter Publication Date..."
                        :class="{
                            'is-invalid':
                                submitted &&
                                $v.publicPost.datePublish.$error,
                        }"
                    ></date-picker>
                    <div
                        v-if="
                            submitted && $v.publicPost.datePublish.$error
                        "
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.publicPost.datePublish.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label>Publication Ending </label>
                    <date-picker
                        v-model="publicPost.publicationEnded"
                        :first-day-of-week="1"
                        lang="en"
                        placeholder="Enter Publication Ending..."
                        :class="{
                            'is-invalid':
                                submitted &&
                                $v.publicPost.publicationEnded.$error,
                        }"
                    ></date-picker>
                    <div
                        v-if="
                            submitted && $v.publicPost.publicationEnded.$error
                        "
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.publicPost.publicationEnded.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label>Type</label>
                    <select class="form-select" v-model="publicPost.type" :class="{'is-invalid': submitted && $v.publicPost.type.$error}">
                        <option></option>
                        <option value="public-bidding">Public Bidding</option>
                        <option value="svp">Small Value Procurement</option>
                    </select>
                    <div
                        v-if="
                            submitted && $v.publicPost.type.$error
                        "
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.publicPost.type.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3" v-if="publicPost.type === 'public-bidding'">
                    <label>Non Refundable Bidder Fee</label>
                    <masked-input
                        v-model="publicPost.nonRefundableBidderFee"
                        class="form-control"
                        role="textbox"
                        placeholder="Enter Non Refundable Bidder Fee"
                        :mask="currencyMask"
                    ></masked-input>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-success">
                        <i class="bx bx-check"></i> {{publicPost.id == 0 ? 'Post Signed Bidding Docs to Public' : 'Update'}}
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('modal-post-to-public')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="rfq-update"
            title="Update Bids/RFQ"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <form @submit.prevent="onSubmitUpdateRFQ">
                <div class="mb-3">
                    <label>Bids/RFQ Description</label>
                    <textarea
                        rows="2"
                        placeholder="Bids/RFQ Description"
                        class="form-control text-warning"
                        v-model="rfqUpdate.description"
                        :class="{'is-invalid': submitted && $v.rfqUpdate.description.$error}"
                    >
                    </textarea>
                    <div 
                        v-if="submitted && $v.rfqUpdate.description.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.rfqUpdate.description.required">This value is required.</span>
                    </div>
                </div>
                <div class="mb-3">
                    <label>Tracking Number</label>
                    <input
                        id="tracking"
                        type="text"
                        v-model="rfqUpdate.tracking"
                        placeholder="Enter Tracking Number..."
                        class="form-control text-warning"
                        :class="{'is-invalid': submitted && $v.rfqUpdate.tracking.$error}"
                        autocomplete="off"
                    />
                    <div 
                        v-if="submitted && $v.rfqUpdate.tracking.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.rfqUpdate.tracking.required">This value is required.</span>
                    </div>
                </div>
                <div class="mb-3">
                    <label>Bids Opening Date</label>
                    <date-picker
                        v-model="rfqUpdate.dateSubmitted"
                        :first-day-of-week="1"
                        lang="en"
                        placeholder="Enter Bids Opening Date..."
                        :class="{'is-invalid': submitted && $v.rfqUpdate.dateSubmitted.$error}"
                        input-class="text-warning form-control"
                    ></date-picker>
                    <div
                        v-if="submitted && $v.rfqUpdate.dateSubmitted.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.rfqUpdate.dateSubmitted.required">This value is required.</span>
                    </div>
                </div>
                <div class="mb-3">
                    <label
                        >Submission Date
                    </label>
                    <date-picker
                        v-model="rfqUpdate.deadline"
                        :first-day-of-week="1"
                        lang="en"
                        placeholder="Enter Submission Date..."
                        :class="{'is-invalid': submitted && $v.rfqUpdate.deadline.$error}"
                        input-class="text-warning form-control"
                    ></date-picker>
                    <div
                        v-if="submitted && $v.rfqUpdate.deadline.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.rfqUpdate.deadline.required">This value is required.</span>
                    </div>
                </div>
                <div class="mb-3">
                    <label>Mode of Procurement</label>
                    <b-form-select
                        class="form-select"
                        v-model="rfqUpdate.modeOfProcurementId"
                        size="sm"
                        :options="mop"
                        :class="{'is-invalid': submitted && $v.rfqUpdate.modeOfProcurementId.$error}"
                    ></b-form-select>
                    <div
                        v-if="submitted && $v.rfqUpdate.modeOfProcurementId.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.rfqUpdate.modeOfProcurementId.required">This value is required.</span>
                    </div>
                </div>
                <div class="mb-3">
                    <label>Note</label>
                    <textarea rows="3" class="form-control" v-model="rfqUpdate.note"></textarea>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-success">
                        <i class="bx bx-save"></i> Update
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('rfq-update')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="rfq-posting-file-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div v-if="getPublicPostLoading">
                <LoadingTemplate />
            </div>
            <div v-else>
                <form @submit.prevent="onSubmitPublicPostFile">
                    <div v-for="(file, index) in multipleFilePosting" :key="index">
                        <hr v-if="index > 0">
                        <div class="mb-3" >
                            <div class="d-flex align-items-center justify-content-between">
                                <label
                                    >Title</label
                                >
                                <div class="d-flex align-items-center"  v-if="filePostingType === 'add'">
                                    <span>({{index+1}})</span>
                                    <a href="javascript:void(0);" class="text-danger" @click="removeMultipleFiles(index)"><i class="bx bx-trash"></i></a>
                                </div>
                            </div>
                            <input
                                type="text"
                                class="form-control"
                                v-model="file.title"
                                @input="selectPostedFile(file)"
                                :ref="`fileTitle${index}`"
                                v-click-outside="closeThisLabel"
                            />
                            <div
                                class="
                                    selection-wrapper
                                    position-absolute
                                "
                                :style="{'width': $refs[`fileTitle${index}`][0].clientWidth + 'px'}"
                                v-if="file.title && file.search"
                            >
                                <ul
                                    class="
                                        multiselect__content
                                        text-left
                                    "
                                >
                                    <li
                                        class="multiselect__element"
                                        v-for="label in filteredFileLabel(file.title)"
                                        :key="label.id"
                                        @click="selectFileLabel(label, index)"
                                    >
                                        <span
                                            class="multiselect__option"
                                            >{{
                                                label.title 
                                            }}</span
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label
                                >Description</label
                            >
                            <input
                                type="text"
                                class="form-control"
                                v-model="file.description"
                            />
                        </div>
                    </div>
                    <div class="mb-2" v-if="filePostingType === 'add'">
                        <button type="button" class="btn btn-block border border-2" @click="addMoreMultipleFiles"><i class="bx bx-plus"></i>Add More</button>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary">
                            <i class="bx bx-save"></i> Save Changes
                        </button>
                        <button
                            type="button"
                            class="btn btn-link"
                            @click="$bvModal.hide('rfq-posting-file-modal')"
                        >
                            Close
                        </button>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal
            id="rfq-activity-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div v-if="getPublicPostLoading">
                <LoadingTemplate />
            </div>
            <div v-else>
                <form @submit.prevent="onSubmitRfqActivity">
                    <div class="mb-3" >
                        <label
                            >Activity Name</label
                        >
                        <input
                            type="text"
                            class="form-control"
                            v-model="rfqActivity.name"
                            @input="typeRfqActivity"
                            :ref="`activityLabel`"
                            v-click-outside="closeTypeActivity"
                        />
                        <div
                            class="
                                selection-wrapper
                                position-absolute
                            "
                            :style="{'width': $refs[`activityLabel`].clientWidth + 'px'}"
                            v-if="rfqActivity.name && searchActivity"
                        >
                            <ul
                                class="
                                    multiselect__content
                                    text-left
                                "
                            >
                                <template v-if="bacActivities.length == 0">
                                    <li class="multiselect__element">
                                        <span
                                            class="multiselect__option"
                                            >No Activity Found</span
                                        >
                                    </li>
                                </template>
                                <li
                                    class="multiselect__element"
                                    v-for="label in filteredActivity"
                                    :key="label.id"
                                    @click="selectBacActivity(label)"
                                >
                                    <span class="multiselect__option">{{ label.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label
                            >Description</label
                        >
                        <input
                            type="text"
                            class="form-control"
                            v-model="rfqActivity.description"
                        />
                    </div>
                    <div class="mb-3">
                        <label
                            >Date &amp; Time</label
                        >
                        <date-picker
                            v-model="rfqActivity.activityDateTime"
                            :first-day-of-week="1"
                            :use12h="true"
                            lang="en"
                            type="datetime"
                            placeholder="Enter Activity Date Time..."
                            :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.rfqActivity.activityDateTime.$error,
                            }"
                        ></date-picker>
                    </div>
                    <div class="mb-3">
                        <label
                            >Status</label
                        >
                        <input
                            type="text"
                            class="form-control"
                            v-model="rfqActivity.status"
                        />
                    </div>
                    <div class="mb-3">
                        <label
                            >Remarks</label
                        >
                        <textarea
                            rows="3"
                            class="form-control"
                            v-model="rfqActivity.remarks"
                        ></textarea>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary">
                            <i class="bx bx-save"></i> Save Changes
                        </button>
                        <button
                            type="button"
                            class="btn btn-link"
                            @click="$bvModal.hide('rfq-activity-modal')"
                        >
                            Close
                        </button>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal
            id="re-award-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <form @submit.prevent="approveForReaward" class="needs-validation">
                <div class="mb-3">
                    <label>Re-award to Supplier:</label>
                    <select 
                        v-model="reaward.rfqSupplierId" class="form-select" 
                        :class="{ 'is-invalid': submitted && $v.reaward.rfqSupplierId.$error}"
                        @change="changeSupplier($event.target.value)"
                    >
                        <option></option>
                        <option v-for="x in reawardRfqSuppliers" :key="x.rfqSupplierId" :value="x.rfqSupplierId">{{x.name}}</option>
                    </select>
                </div>
                <!-- <div class="mb-3">
                    <label>P.O Number</label>
                    <input
                        v-model="reaward.poNumber"
                        placeholder="Enter P.O Number"
                        rows="5"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.po.poNumber.$error}"
                    />
                    <div
                        v-if="submitted && $v.po.poNumber.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.po.poNumber.required">This value is required.</span>
                    </div>
                </div>
                <div class="mb-3">
                    <label>P.O Description</label>
                    <textarea
                        rows="2"
                        placeholder="P.O Description"
                        class="form-control"
                        v-model="reaward.description"
                        :class="{ 'is-invalid': submitted && $v.reaward.description.$error}"
                    >
                    </textarea>
                    <div
                        v-if="submitted && $v.reaward.description.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.reaward.description.required">This value is required.</span>
                    </div>
                </div> -->
                <hr>
                <div v-for="(x, xInd) in reawardItems" :key="x.id" :class="{'border-danger border p-2': x.error, 'mt-2': xInd > 0 }">
                    <div class="mb-2">
                        <label class="mb-0">Item Name</label>
                        <div class="form-control">{{x.itemName}}</div>
                    </div>
                    <div class="mb-2">
                        <label class="mb-0">Description</label>
                        <div class="form-control">{{x.description}}</div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-4">
                            <label class="mb-0">Unit Cost</label>
                            <div class="form-control">{{formatCurrency(x.unitCost)}}</div>
                        </div>
                        <div class="col-md-4">
                            <label class="mb-0">Quantity</label>
                            <masked-input
                                type="text"
                                placeholder="Qty"
                                class="w-100 form-control text-warning"
                                :mask="currencyMask"
                                v-model="x.quantity"
                            ></masked-input>
                        </div>
                        <div class="col-md-4">
                            <label class="mb-0">Total</label>
                            <div class="form-control">{{formatCurrency(x.unitCost * x.quantity)}}</div>
                        </div>
                    </div>
                    <small v-if="x.error" class="text-danger"><b>{{ x.errorMessage }}</b></small>
                    <hr>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        <i class="bx bx-save"></i> Save Changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('re-award-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-tabs
            content-class="pt-3 pb-3 text-muted"
            v-model="tabIndex"
            nav-class="nav-tabs-custom"
        >
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Purchase Request Items</span
                    >
                </template>
                <b-tabs
                    pills
                    justified
                    content-class="py-3 text-muted"
                    nav-class="success"
                >
                    <b-tab>
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="bx bx-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block"
                                >Available Items</span
                            >
                        </template>
                        <div class="row">
                            <div class="col-md-6">
                                <h5 class="mb-0">List of Available Items</h5>
                                <div>
                                    <small class="cursor-pointer" >{{
                                        singleSelection
                                            ? "Single Selection"
                                            : "Mutiple Selection"
                                    }}</small>
                                    <!-- @click="toggleSelectionMode" -->
                                </div>
                            </div>
                            <div class="col-md-6 text-right">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter me-1"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filterItem"
                                            type="search"
                                            placeholder="Search Items..."
                                            class="form-control"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div>
                                    <div class="">
                                        <table
                                            class="
                                                table
                                                project-list-table
                                                table-centered table-borderless
                                            "
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        style="width: 500px"
                                                        class="
                                                            align-middle
                                                            border-2
                                                            border-top-0
                                                            border-start-0
                                                            border-bottom-0
                                                            border-dark-app
                                                        "
                                                        colspan="2"
                                                    >
                                                        Item Name
                                                    </th>
                                                    <th
                                                        class="
                                                            text-center
                                                            border-2
                                                            border-top-0
                                                            border-start-0
                                                            border-bottom-0
                                                            border-dark-app
                                                            p-0
                                                        "
                                                        style="width: 500px"
                                                    >
                                                        <div
                                                            class="text-center"
                                                        >
                                                            <div
                                                                class="
                                                                    border-dark-bottom
                                                                    py-1
                                                                "
                                                            >
                                                                Available
                                                                Quantity
                                                            </div>
                                                            <div class="d-flex">
                                                                <div
                                                                    class="
                                                                        w-25
                                                                        border-dark-right
                                                                        p-1
                                                                    "
                                                                >
                                                                    Quarter 1
                                                                </div>
                                                                <div
                                                                    class="
                                                                        w-25
                                                                        border-dark-right
                                                                        py-1
                                                                    "
                                                                >
                                                                    Quarter 2
                                                                </div>
                                                                <div
                                                                    class="
                                                                        w-25
                                                                        border-dark-right
                                                                        py-1
                                                                    "
                                                                >
                                                                    Quarter 3
                                                                </div>
                                                                <div
                                                                    class="
                                                                        w-25
                                                                        py-1
                                                                    "
                                                                >
                                                                    Quarter 4
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th
                                                        class="
                                                            align-middle
                                                            border-2
                                                            border-top-0
                                                            border-start-0
                                                            border-bottom-0
                                                            border-dark-app
                                                            text-center
                                                        "
                                                    >
                                                        Total Qty
                                                    </th>
                                                    <th
                                                        class="
                                                            align-middle
                                                            border-2
                                                            border-top-0
                                                            border-start-0
                                                            border-bottom-0
                                                            border-dark-app
                                                        "
                                                    >
                                                        Unit Cost
                                                    </th>
                                                    <th
                                                        class="
                                                            align-middle
                                                            border-2
                                                            border-top-0
                                                            border-start-0
                                                            border-bottom-0
                                                            border-dark-app
                                                        "
                                                    >
                                                        Total Amount
                                                    </th>
                                                    <!-- <th
                                                        scope="col"
                                                        width="120px"
                                                        class="
                                                            text-center
                                                            align-middle
                                                        "
                                                        v-if="singleSelection"
                                                    >
                                                        Action
                                                    </th> -->
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="availableBusy">
                                                    <td colspan="100%" class="position-relative">
                                                        <LoadingTemplate />
                                                    </td>
                                                </tr>
                                                <tr v-if="filteredAvailableItems.length == 0 && !availableBusy">
                                                    <td colspan="100%" class="text-muted text-center">
                                                        <i class="dripicons-warning me-1"></i>No data found
                                                    </td>
                                                </tr>
                                                <template
                                                    v-for="y in filteredAvailableItems"
                                                >
                                                    <tr
                                                        :key="'A' + y.id"
                                                        style="background-color: transparent;box-shadow: none;"
                                                    >
                                                        <td colspan="100%" class="py-0 position-relative">
                                                            <RawData 
                                                                :data="y" 
                                                                v-if="$store.state.decrypt.isAdmin()" 
                                                                placement="left"
                                                            />
                                                            <div class="d-flex align-items-center justify-content-between" v-if="y.selectionActivated">
                                                                <div class="form-check form-checkbox-outline form-check-success mb-0">
                                                                    <input
                                                                        type="checkbox"
                                                                        :id="`work-${y.id}`"
                                                                        checked="checked"
                                                                        class="form-check-input"
                                                                        v-model="y.checkAllWork"
                                                                        @change="checkEntireWork(y)"
                                                                    />
                                                                    <label :for="`work-${y.id}`" class="form-check-label">
                                                                        <h5 class="text-dark mb-0">
                                                                            <span class="text-warning">[{{y.prNumber}}]</span>
                                                                            {{  y.description }}
                                                                        </h5>
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                        text-warning
                                                                        cursor-pointer
                                                                        text-truncate
                                                                    "
                                                                    style="width:126px;"
                                                                    @click="
                                                                        unSelectThisPR(y)
                                                                    ">
                                                                    <i class="bx bx-x me-1"></i>
                                                                    Cancel Selection
                                                                </div>
                                                            </div>
                                                            <div
                                                                v-else
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                    justify-content-between
                                                                "
                                                            >
                                                                <h5
                                                                    class="
                                                                        text-dark
                                                                        mb-0
                                                                        cursor-pointer
                                                                    "
                                                                    @click="
                                                                        y.showDetails = !y.showDetails"
                                                                >
                                                                    <span class="text-warning">[{{y.prNumber}}]</span>
                                                                    {{
                                                                        y.description
                                                                    }}
                                                                    <i
                                                                        class="bx bx-caret-right rotate"
                                                                        :class="{
                                                                            'rotate-90': y.showDetails, 
                                                                            'text-white': !y.showDetails
                                                                        }"
                                                                    >
                                                                    </i>
                                                                </h5>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                        text-success
                                                                        cursor-pointer
                                                                        text-truncate
                                                                    "
                                                                    @click="
                                                                        selectThisPR(y)
                                                                    "
                                                                    v-if="y.showDetails"
                                                                    style="width:102px;"
                                                                >
                                                                    <i
                                                                        class="
                                                                            bx
                                                                            bx-cart
                                                                            me-1
                                                                        "
                                                                    ></i
                                                                    >Select this PR
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <template v-if="y.showDetails">
                                                        <template v-for="(w, wIndex) in y.categoryGroups">
                                                            <tr :key="`AB${y.id}${wIndex}`" 
                                                                style="
                                                                    background-color: transparent;
                                                                    box-shadow: none;
                                                                ">
                                                                <td
                                                                    :colspan="
                                                                        singleSelection
                                                                            ? 6
                                                                            : 5
                                                                    "
                                                                    class="py-0"
                                                                >
                                                                    <div class="ms-2 d-flex align-items-center justify-content-between" v-if="y.selectionActivated">
                                                                        <div
                                                                        
                                                                            class="
                                                                                form-check
                                                                                form-checkbox-outline
                                                                                form-check-success
                                                                                mb-0
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="checkbox"
                                                                                :id="`work-itemCat-${y.id}${wIndex}`"
                                                                                checked="checked"
                                                                                class="
                                                                                    form-check-input
                                                                                "
                                                                                v-model="
                                                                                    w.checkAllItemCat
                                                                                "
                                                                                @change="
                                                                                    checkEntireItemCat(
                                                                                        w, y
                                                                                    )
                                                                                "
                                                                            /><label
                                                                                :for="`work-itemCat-${y.id}${wIndex}`"
                                                                                class="
                                                                                    form-check-label
                                                                                "
                                                                            >
                                                                                <h6
                                                                                    class="
                                                                                        text-pink
                                                                                        mb-0
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        w.name
                                                                                    }}
                                                                                </h6>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div v-else class="ms-2">
                                                                        <h6
                                                                            class="
                                                                                text-pink
                                                                                mb-0
                                                                            "
                                                                        >
                                                                            {{
                                                                                w.name
                                                                            }}
                                                                        </h6>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <template
                                                                v-for="x in w.prItems"
                                                            >
                                                                <tr
                                                                    :key="x.id"
                                                                    class="
                                                                        position-relative
                                                                    "
                                                                    :class="{
                                                                        'border-1 border-danger':
                                                                            x.submitError,
                                                                    }"
                                                                    style="background-color: transparent; box-shadow: none;"
                                                                >
                                                                    <td style="width:50px;">
                                                                    </td>
                                                                    <td
                                                                        class="
                                                                            align-middle
                                                                            bg-table-tr
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                form-check
                                                                                form-checkbox-outline
                                                                                form-check-success
                                                                                mb-0
                                                                            "
                                                                            v-if="
                                                                                y.selectionActivated
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="checkbox"
                                                                                :id="`resources-${x.id}`"
                                                                                checked="checked"
                                                                                class="
                                                                                    form-check-input
                                                                                "
                                                                                v-model="
                                                                                    x.toggleSelected
                                                                                "
                                                                                @change="
                                                                                    checkApiResource(
                                                                                        w, y
                                                                                    )
                                                                                "
                                                                            /><label
                                                                                :for="`resources-${x.id}`"
                                                                                class="
                                                                                    form-check-label
                                                                                "
                                                                            >
                                                                                <span
                                                                                    class="
                                                                                        cursor-pointer
                                                                                    "
                                                                                    :id="`popover-${x.id}`"
                                                                                    >{{x.itemName}}</span
                                                                                >
                                                                                <div>
                                                                                    <small>{{x.description}}</small>
                                                                                </div>
                                                                            </label>
                                                                        </div>
                                                                        <div
                                                                            v-else
                                                                        >
                                                                            <span
                                                                                class="
                                                                                    cursor-pointer
                                                                                "
                                                                                >{{x.itemName}}</span
                                                                            >
                                                                            <div>
                                                                                <small>{{x.description}}</small>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td
                                                                        class="
                                                                            align-middle
                                                                            p-0
                                                                            bg-table-tr
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                d-flex
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    w-25
                                                                                    d-flex
                                                                                    align-items-center
                                                                                    justify-content-center
                                                                                    py-2
                                                                                "
                                                                            >
                                                                                {{ x.q1 }}
                                                                            </div>
                                                                            <div
                                                                                class="
                                                                                    w-25
                                                                                    d-flex
                                                                                    align-items-center
                                                                                    justify-content-center
                                                                                "
                                                                            >
                                                                                {{x.q2}}
                                                                            </div>
                                                                            <div
                                                                                class="
                                                                                    w-25
                                                                                    d-flex
                                                                                    align-items-center
                                                                                    justify-content-center
                                                                                "
                                                                            >
                                                                                {{x.q3}}
                                                                            </div>
                                                                            <div
                                                                                class="
                                                                                    w-25
                                                                                    d-flex
                                                                                    align-items-center
                                                                                    justify-content-center
                                                                                "
                                                                            >
                                                                                {{x.q4}}
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td
                                                                        class="
                                                                            text-center
                                                                            align-middle
                                                                            bg-table-tr
                                                                        "
                                                                    >
                                                                        {{x.totalQuantity}}
                                                                    </td>
                                                                    <td
                                                                        class="
                                                                            align-middle
                                                                            bg-table-tr
                                                                        "
                                                                    >
                                                                        {{
                                                                            formatCurrency(
                                                                                x.unitCost
                                                                            )
                                                                        }}
                                                                    </td>
                                                                    <td
                                                                        class="
                                                                            align-middle
                                                                            bg-table-tr
                                                                        "
                                                                    >
                                                                        {{
                                                                            formatCurrency(
                                                                                x.total
                                                                            )
                                                                        }}
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </tbody>
                                        </table>
                                        <div class="mt-3" v-if="rowsAvailableItems > 10">
                                            <div
                                                class="
                                                    dataTables_paginate
                                                    paging_simple_numbers
                                                    float-end
                                                "
                                            >
                                                <ul class="pagination pagination-rounded mb-0">
                                                    <b-pagination
                                                        v-model="currentPageItem"
                                                        :total-rows="rowsAvailableItems"
                                                        :per-page="perPageItem"
                                                    ></b-pagination>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="bx bx-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block"
                                >Cancelled Items</span
                            >
                        </template>
                        <div class="row">
                            <div class="col-md-6">
                                <h5 class="mb-0">List of Cancelled Items</h5>
                                <div>
                                    <small
                                        class="cursor-pointer"
                                        >{{
                                            singleSelection
                                                ? "Single Selection"
                                                : "Mutiple Selection"
                                        }}</small
                                    >
                                    <!-- @click="toggleSelectionMode" -->
                                </div>
                            </div>
                            <div class="col-md-6 text-right">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter me-1"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filterCanceledItem"
                                            type="search"
                                            placeholder="Search Items..."
                                            class="form-control"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div>
                                    <div class="">
                                        <table
                                            class="
                                                table
                                                project-list-table
                                                table-centered table-borderless
                                            "
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        style="width: 500px"
                                                        class="
                                                            align-middle
                                                            border-2
                                                            border-top-0
                                                            border-start-0
                                                            border-bottom-0
                                                            border-dark-app
                                                        "
                                                        colspan="2"
                                                    >
                                                        Item Name
                                                    </th>
                                                    <th
                                                        class="
                                                            text-center
                                                            border-2
                                                            border-top-0
                                                            border-start-0
                                                            border-bottom-0
                                                            border-dark-app
                                                            p-0
                                                        "
                                                        style="width: 500px"
                                                    >
                                                        <div
                                                            class="text-center"
                                                        >
                                                            <div
                                                                class="
                                                                    border-dark-bottom
                                                                    py-1
                                                                "
                                                            >
                                                                Available
                                                                Quantity
                                                            </div>
                                                            <div class="d-flex">
                                                                <div
                                                                    class="
                                                                        w-25
                                                                        border-dark-right
                                                                        p-1
                                                                    "
                                                                >
                                                                    Quarter 1
                                                                </div>
                                                                <div
                                                                    class="
                                                                        w-25
                                                                        border-dark-right
                                                                        py-1
                                                                    "
                                                                >
                                                                    Quarter 2
                                                                </div>
                                                                <div
                                                                    class="
                                                                        w-25
                                                                        border-dark-right
                                                                        py-1
                                                                    "
                                                                >
                                                                    Quarter 3
                                                                </div>
                                                                <div
                                                                    class="
                                                                        w-25
                                                                        py-1
                                                                    "
                                                                >
                                                                    Quarter 4
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th
                                                        class="
                                                            align-middle
                                                            border-2
                                                            border-top-0
                                                            border-start-0
                                                            border-bottom-0
                                                            border-dark-app
                                                            text-center
                                                        "
                                                    >
                                                        Total Qty
                                                    </th>
                                                    <th
                                                        class="
                                                            align-middle
                                                            border-2
                                                            border-top-0
                                                            border-start-0
                                                            border-bottom-0
                                                            border-dark-app
                                                        "
                                                    >
                                                        Unit Cost
                                                    </th>
                                                    <th
                                                        class="
                                                            align-middle
                                                            border-2
                                                            border-top-0
                                                            border-start-0
                                                            border-bottom-0
                                                            border-dark-app
                                                        "
                                                    >
                                                        Total Amount
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        width="120px"
                                                        class="
                                                            text-center
                                                            align-middle
                                                        "
                                                        v-if="singleSelection"
                                                    >
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="availableBusy">
                                                    <td colspan="100%">
                                                        <LoadingTemplate />
                                                    </td>
                                                </tr>
                                                <tr
                                                    v-if="
                                                        filteredCanceledItems.length ==
                                                            0 && !availableBusy
                                                    "
                                                >
                                                    <td
                                                        :colspan="
                                                            singleSelection
                                                                ? 7
                                                                : 6
                                                        "
                                                        class="
                                                            text-muted
                                                            text-center
                                                        "
                                                    >
                                                        <i
                                                            class="
                                                                dripicons-warning
                                                                me-1
                                                            "
                                                        ></i
                                                        >No data found
                                                    </td>
                                                </tr>
                                                <template
                                                    v-for="y in filteredCanceledItems"
                                                >
                                                    <tr
                                                        :key="'A' + y.id"
                                                        style="
                                                            background-color: transparent;
                                                            box-shadow: none;
                                                        "
                                                    >

                                                        <td
                                                            :colspan="
                                                                singleSelection
                                                                    ? 7
                                                                    : 6
                                                            "
                                                            class="py-0"
                                                        >
                                                            <div
                                                                v-if="
                                                                    !singleSelection
                                                                "
                                                                class="
                                                                    form-check
                                                                    form-checkbox-outline
                                                                    form-check-success
                                                                    mb-0
                                                                "
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    :id="`work-${y.id}`"
                                                                    checked="checked"
                                                                    class="
                                                                        form-check-input
                                                                    "
                                                                    v-model="
                                                                        y.checkAllWork
                                                                    "
                                                                    @change="
                                                                        checkEntireWork(
                                                                            y
                                                                        )
                                                                    "
                                                                /><label
                                                                    :for="`work-${y.id}`"
                                                                    class="
                                                                        form-check-label
                                                                    "
                                                                >
                                                                    <h5
                                                                        class="
                                                                            text-dark
                                                                            mb-0
                                                                        "
                                                                    >
                                                                        {{
                                                                            y.description
                                                                        }}
                                                                    </h5>
                                                                </label>
                                                            </div>
                                                            <div v-else>
                                                                <h5
                                                                    class="
                                                                        text-dark
                                                                        mb-0
                                                                    "
                                                                >
                                                                    {{
                                                                        y.description
                                                                    }}
                                                                </h5>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <template
                                                        v-for="x in y.prItems"
                                                    >
                                                        <tr
                                                            :key="x.id"
                                                            class="
                                                                position-relative
                                                            "
                                                            :class="{
                                                                'border-1 border-danger':
                                                                    x.submitError,
                                                            }"
                                                        >
                                                            <td></td>
                                                            <td
                                                                class="
                                                                    align-middle
                                                                "
                                                            >
                                                                <small
                                                                    v-if="
                                                                        x.submitError
                                                                    "
                                                                    class="
                                                                        position-absolute
                                                                        text-white
                                                                        error-message
                                                                        px-1
                                                                    "
                                                                    >Quantity
                                                                    must not
                                                                    exceed the
                                                                    max
                                                                    Quantity</small
                                                                >
                                                                <div
                                                                    class="
                                                                        form-check
                                                                        form-checkbox-outline
                                                                        form-check-success
                                                                        mb-0
                                                                    "
                                                                    v-if="
                                                                        !singleSelection
                                                                    "
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        :id="`resources-${x.id}`"
                                                                        checked="checked"
                                                                        class="
                                                                            form-check-input
                                                                        "
                                                                        v-model="
                                                                            x.toggleSelected
                                                                        "
                                                                        @change="
                                                                            checkApiResource(
                                                                                w, y
                                                                            )
                                                                        "
                                                                    /><label
                                                                        :for="`resources-${x.id}`"
                                                                        class="
                                                                            form-check-label
                                                                        "
                                                                    >
                                                                        <span
                                                                            class="
                                                                                cursor-pointer
                                                                            "
                                                                            :id="`popover-${x.id}`"
                                                                            >{{
                                                                                x
                                                                                    .apiResource
                                                                                    .itemName
                                                                            }}
                                                                            ({{
                                                                                x
                                                                                    .apiResource
                                                                                    .description
                                                                            }})</span
                                                                        >
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    v-else
                                                                >
                                                                    <span
                                                                        class="
                                                                            cursor-pointer
                                                                        "
                                                                        >{{
                                                                            x
                                                                                .apiResource
                                                                                .itemName
                                                                        }}
                                                                        ({{
                                                                            x
                                                                                .apiResource
                                                                                .description
                                                                        }})</span
                                                                    >
                                                                </div>
                                                            </td>
                                                            <td
                                                                class="
                                                                    align-middle
                                                                    p-0
                                                                "
                                                            >
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        d-flex
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            w-25
                                                                            d-flex
                                                                            align-items-center
                                                                            justify-content-center
                                                                            py-2
                                                                        "
                                                                    >
                                                                        {{
                                                                            x.q1
                                                                        }}
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            w-25
                                                                            d-flex
                                                                            align-items-center
                                                                            justify-content-center
                                                                        "
                                                                    >
                                                                        {{
                                                                            x.q2
                                                                        }}
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            w-25
                                                                            d-flex
                                                                            align-items-center
                                                                            justify-content-center
                                                                        "
                                                                    >
                                                                        {{
                                                                            x.q3
                                                                        }}
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            w-25
                                                                            d-flex
                                                                            align-items-center
                                                                            justify-content-center
                                                                        "
                                                                    >
                                                                        {{
                                                                            x.q4
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td
                                                                class="
                                                                    text-center
                                                                    align-middle
                                                                "
                                                            >
                                                                {{
                                                                    y.isMigrationPr
                                                                        ? x.totalQty
                                                                        : x.totalQuantity
                                                                }}
                                                            </td>
                                                            <td
                                                                class="
                                                                    align-middle
                                                                "
                                                            >
                                                                {{
                                                                    formatCurrency(
                                                                        x.unitCost
                                                                    )
                                                                }}
                                                            </td>
                                                            <td
                                                                class="
                                                                    align-middle
                                                                "
                                                            >
                                                                {{
                                                                    formatCurrency(
                                                                        x.total
                                                                    )
                                                                }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-tab>
            <b-tab :disabled="addItem">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span
                        class="d-none d-sm-inline-block position-relative" :class="{'me-2': cartCount > 0}"
                        >Bids/RFQ Form
                        <small
                            ><span
                                class="
                                    badge
                                    bg-danger
                                    position-absolute
                                    py-1
                                    ms-1
                                "
                                style="top: -2px"
                                v-if="cartCount > 0"
                                >{{ cartCount }}</span
                            ></small
                        ></span
                    >
                </template>
                <SubmissionTab 
                    title="Bids/RFQ Form"
                    :cartItems="cartItems"
                    :cartBusy="cartBusy"
                    :cartCount="cartCount"
                    :rfq="rfq"
                    :selectedSupplier="selectedSupplier"
                    :mop="mop"
                    @getSuppliers="getSuppliers"
                    @removeSupplier="removeSupplier"
                    @checkOut="checkOut"
                    @cancelPR="cancelPR"
                    @getResourceInfo="getResourceInfo"
                />
            </b-tab>
            <b-tab :disabled="addItem" @click="getQuotationItems">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Request for Quotation List</span
                    >
                </template>
                <b-tabs
                    pills
                    vertical
                    nav-class="p-0"
                    nav-wrapper-class="col-sm-2"
                    content-class="pt-0 px-2 text-muted"
                >
                    <b-tab title-item-class="mb-2">
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="bx bx-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block"
                                >Submitted (<template v-if="!submittedBusy">{{
                                    submittedRFQ.length
                                }}</template
                                ><template v-if="submittedBusy"
                                    ><b-spinner
                                        type="grow"
                                        class="wh-10p"
                                        variant="success"
                                        role="status"
                                    ></b-spinner></template
                                >)</span
                            >
                        </template>
                        <div class="card">
                            <div class="card-body bg-success bg-soft">
                                <div
                                    class="
                                        d-flex
                                        justify-content-between
                                        align-items-center
                                        mb-3
                                    "
                                >
                                    <div>
                                        <h4 class="card-title mb-0">
                                            Submitted Request for Quotation
                                        </h4>
                                        <p class="card-title-desc mb-0">
                                            List of submitted Request for
                                            Quotation
                                        </p>
                                    </div>
                                    <div v-if="submittedRFQ.length > 0">
                                        <div class="d-flex">
                                            <input
                                                autocomplete="off"
                                                type="text"
                                                v-model="filterSubmittedRFQ"
                                                placeholder="Search RFQ..."
                                                class="form-control"
                                            />
                                            <b-form-select
                                                class="form-select ms-1 w-25"
                                                v-model="perSubmittedPage"
                                                :options="pageOptions"
                                            ></b-form-select>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="submittedRFQ.length == 0"
                                    class="text-center"
                                >
                                    <h5>No data available</h5>
                                </div>
                                <div
                                    v-if="
                                        filterSubmittedRFQ &&
                                        filteredSubmittedRFQ.length == 0
                                    "
                                    class="text-center"
                                >
                                    <h5>Search not found</h5>
                                </div>
                                <template v-if="submittedRFQ.length > 0">
                                    <div
                                        role="tablist"
                                        v-for="(x, index) in filteredSubmittedRFQ"
                                        :key="x.id"
                                    >
                                        <b-card
                                            no-body
                                            class="mb-1 shadow-none"
                                            :style="{
                                                'z-index': `${filteredSubmittedRFQ.length - index}`,
                                            }"
                                        >
                                            <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" placement="left"/>
                                            <b-card-header
                                                header-tag="header"
                                                role="tab"
                                                header-class="cursor-pointer"
                                                @click="getRFQDetails(x)"
                                            >
                                                <div
                                                    class="
                                                        d-flex
                                                        justify-content-between
                                                        align-items-center
                                                    "
                                                >
                                                    <h6 class="m-0">
                                                        <a class="text-dark" href="javascript: void(0);">
                                                            &nbsp;
                                                            <span class="text-warning">[{{ x.rfqNumber}}]</span>
                                                            <span>[{{x.prNumber}}]</span>
                                                            :&nbsp;
                                                            {{ x.description }}
                                                            <span v-if="x.publicPostedRfqs.length > 0" class="ms-1">
                                                                <img src="@/assets/images/verified-icon.png" alt="verified" style="height:18px;">
                                                            </span>
                                                        </a>
                                                    </h6>
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                        "
                                                    >
                                                        <div>
                                                            <span
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                    text-truncate
                                                                "
                                                                ><small
                                                                    v-if="
                                                                        !x.visible
                                                                    "
                                                                    >Click here
                                                                    to
                                                                    expand</small
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-chevron-right
                                                                        rotate
                                                                        font-size-18
                                                                        ms-3
                                                                    "
                                                                    :class="{
                                                                        'rotate-90':
                                                                            x.visible,
                                                                    }"
                                                                ></i
                                                            ></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-card-header>
                                            <b-collapse
                                                :visible="x.visible"
                                                :accordion="`posted-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <b-card-body class="border">
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            cursor-pointer
                                                        "
                                                    >
                                                        <div class="d-flex align-items-end">
                                                            <h5 class="mb-0 me-1">
                                                                Bids/RFQ Details
                                                            </h5>
                                                            <a href="javascript:void(0);" @click="updateRFQ(x)">
                                                                <div class="d-flex align-items-center">
                                                                    [<i class="bx bx-edit"></i>Update Details]
                                                                </div>
                                                            </a>
                                                            <a href="javascript:void(0);" @click="regenerateRFQ(x)" class="hover-underline text-green" v-if="x.rfqNumber.substring(0, 3) !== 'RE-'">
                                                                <div class="d-flex align-items-center">
                                                                    [<i class="mdi mdi-cog-counterclockwise me-1"></i>Regenerate RFQ Number]
                                                                </div>
                                                            </a>
                                                            <a href="javascript:void(0);" @click="changeRFQNo(x)" class="hover-underline text-info" v-if="$store.state.decrypt.isAdmin()">
                                                                <div class="d-flex align-items-center">
                                                                    [<i class="mdi mdi-cog-counterclockwise me-1"></i>Update RFQ Number]
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.detailShow,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="x.detailShow"
                                                        :accordion="`rfq-details-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <div v-if="!x.detailsLoaded">
                                                            <LoadingTemplate />
                                                        </div>
                                                        <div class="row" v-if="x.detailsLoaded">
                                                            <div
                                                                class="col-md-6"
                                                            >
                                                            <ul>
                                                                <li>
                                                                    <div>
                                                                    <label
                                                                        class="
                                                                            me-1
                                                                        "
                                                                        ><i
                                                                            class="
                                                                                bx
                                                                                bx-receipt
                                                                                me-1
                                                                            "
                                                                        ></i
                                                                        >Tracking
                                                                        Number:</label
                                                                    >
                                                                    <u>{{
                                                                        x.tracking
                                                                    }}</u>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div>
                                                                        <label class="me-1">
                                                                            <i class="bx bx-calendar-event me-1"></i>
                                                                            Bids Opening Date:
                                                                        </label>
                                                                        <u>{{ formatDate(new Date(x.dateSubmitted)) }}</u>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div>
                                                                        <label class="me-1">
                                                                            <i class="bx bx-calendar-event me-1"></i>
                                                                            Submission Date:
                                                                        </label>
                                                                        <u>{{ formatDate(new Date(x.deadline)) }}</u>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                            </div>
                                                            <div
                                                                class="col-md-6"
                                                            >
                                                                <ul>
                                                                    <li>
                                                                       <i class="bx bx-receipt me-1"></i>Note: <u>{{x.note}}</u>
                                                                    </li>
                                                                    <li>
                                                                        <label
                                                                            class="
                                                                                me-1
                                                                            "
                                                                            ><i
                                                                                class="
                                                                                    bx
                                                                                    bx-link-external
                                                                                    me-1
                                                                                "
                                                                            ></i
                                                                            >Mode of
                                                                            Procurement:</label
                                                                        >
                                                                        <u>
                                                                            {{
                                                                            x.mop.text
                                                                        }}
                                                                        </u>
                                                                    </li>
                                                                    <li>
                                                                        <label
                                                                            class="
                                                                                me-1
                                                                            "
                                                                            ><i
                                                                                class="
                                                                                    bx
                                                                                    bx-link-external
                                                                                    me-1
                                                                                "
                                                                            ></i
                                                                            >Delivery Unit:</label
                                                                        >
                                                                        <u>
                                                                            {{
                                                                            x.deliveryUnit
                                                                        }}
                                                                        </u>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </b-collapse>
                                                    <hr />
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            cursor-pointer
                                                        "
                                                        @click="showRfqItems(x)"
                                                    >
                                                        <div>
                                                            <h5 class="mb-0">
                                                                Bids/RFQ Items
                                                            </h5>
                                                            <div class="text-warning">
                                                                <small>Note: If you want to return items to delivery unit, click the button `Return to Delivery Unit in every RFQ Items</small>
                                                            </div>
                                                        </div>
                                                        
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.itemVisible,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="x.itemVisible"
                                                        :accordion="`rfq-item-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <div>
                                                            <div class="d-flex align-items-center justify-content-between">
                                                                <div v-if="!x.selectItems">
                                                                    <button type="button" class="btn btn-sm btn-outline-success" @click="selectForRecanvas(x)" v-if="!showReAward(x)"><i class="bx bx-list-check"></i> Select Items for Recanvass</button>
                                                                    <!-- <button type="button" class="btn btn-sm btn-outline-warning ms-1" @click="selectForReAward(x)" v-if="x.reAward"><i class="bx bx-award"></i> Select Items for ReAward</button> -->
                                                                </div>
                                                                <div class="d-flex align-items-center justify-content-between" v-if="x.selectItems">
                                                                    <div class="form-check form-checkbox-outline form-check-success">
                                                                        <input
                                                                            type="checkbox"
                                                                            :id="`select-all-items-${x.id}`"
                                                                            checked="checked"
                                                                            class="form-check-input"
                                                                            v-model="x.selectAll"
                                                                            @change="selectAllItems(x)"
                                                                        />
                                                                        <label :for="`select-all-items-${x.id}`" class="form-check-label">
                                                                            Select all
                                                                        </label>
                                                                    </div>
                                                                    <span class="mx-2"></span>
                                                                    <button type="button" class="btn btn-sm btn-outline-warning" @click="cancelSelectionOfItems(x)"><i class="bx bx-x"></i> Cancel</button>
                                                                </div>
                                                                <div v-else>
                                                                    <input type="text" class="form-control form-control-sm" placeholder="Search item..." v-model="x.searchItem">
                                                                </div>
                                                                <div v-if="countItemSelected(x, 'recanvas') != 0 && x.forRecanvas" class="d-flex align-items-center">
                                                                    With {{ countItemSelected(x, 'recanvas') }} selected: Recanvass? <button type="button" class="ms-1 btn btn-sm btn-outline-success" @click="recanvasItem(x)"><i class="bx bx-check"></i> Go</button>
                                                                </div>
                                                                <div v-if="countItemSelected(x, 'reaward') != 0 && x.forReAward" class="d-flex align-items-center">
                                                                    With {{ countItemSelected(x, 'reaward') }} selected: Reaward? <button type="button" class="ms-1 btn btn-sm btn-outline-success" @click="reAwardRfqItems(x)"><i class="bx bx-check"></i> Go</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex justify-content-between mb-3">
                                                            <p class="mb-0" :class="{'text-success': x.itemMsgType === 'success', 'text-danger': x.itemMsgType === 'danger'}">
                                                                {{ x.itemMessage }}
                                                            </p>
                                                            <!-- <a
                                                                    href="javascript:void(0);"
                                                                    class="border border-primary text-primary p-2"
                                                                    @click="addMoreItems(x)"
                                                                ><i class="bx bx-plus"></i>Add More Items
                                                            </a> -->
                                                        </div>
                                                        <table
                                                            class="
                                                                table
                                                                table-bordered
                                                            "
                                                        >
                                                            <thead>
                                                                <tr class="custom-border-2">
                                                                    <th>Item Name
                                                                        <div><small>Item Description</small></div>
                                                                    </th>
                                                                    <th style="width: 120px;">Unit</th>
                                                                    <th style="width: 70px;">Qty</th>
                                                                    <th style="width: 150px;">Unit Cost</th>
                                                                    <th style="width: 150px;">Total</th>
                                                                    <th style="width: 50px;"></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template v-if="!x.rfqItemLoading && x.rfqItems.length > 0">
                                                                    <tr
                                                                        v-for="(z, zIndex) in filteredRfqItems(x)"
                                                                        :key="`poffer-${z.id}`"
                                                                        @drop="onDropZone($event, z, x)"
                                                                        @dragenter.prevent
                                                                        @dragover.prevent
                                                                    >
                                                                        
                                                                        <td class="position-relative">
                                                                            <RawData 
                                                                                :data="z"
                                                                                placement="left"
                                                                                :keyId="`rfq-item-${x.id}${z.id}-${zIndex}`"
                                                                                v-if="$store.state.decrypt.isAdmin()" 
                                                                            />
                                                                            <div class="d-flex">
                                                                                <div style="min-width:20px;height:20px;" class="bg-success bg-gradient text-white d-flex align-items-center justify-content-center me-1">{{zIndex + 1}}</div>
                                                                                <div 
                                                                                    v-if="!x.selectItems || (x.selectItems && x.forReAward && !z.isReAward)" 
                                                                                    :class="{'grab-cursor': !x.withChild}" 
                                                                                    @mousedown="handleMouseDown($event, z)" 
                                                                                    @mouseup="handleMouseUp($event, z)"
                                                                                >
                                                                                    {{ z.itemName}}
                                                                                </div>
                                                                                <div v-if="(x.selectItems && x.forRecanvas) || (x.selectItems && x.forReAward && z.isReAward)">
                                                                                    <div
                                                                                        class="
                                                                                            form-check
                                                                                            form-checkbox-outline
                                                                                            form-check-success
                                                                                        "
                                                                                    >
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            :id="`select-rfq-items-${z.id}`"
                                                                                            class="form-check-input"
                                                                                            v-model="z.selected"
                                                                                            @change="selectRfqItem(x)"
                                                                                        />
                                                                                        <label
                                                                                            :for="`select-rfq-items-${z.id}`"
                                                                                            class="form-check-label"
                                                                                        >
                                                                                            {{ z.itemName}}
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <small>
                                                                                    {{
                                                                                        z.description
                                                                                    }}
                                                                                </small>
                                                                            </div>
                                                                            <div>
                                                                                <a href="javascript:void(0);" class="hover-underline btn btn-primary btn-sm" @click="returnPRItems(z.prItem)">Return to Delivery Unit for Editing</a> 
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div class="d-flex align-items-center">
                                                                                {{ z.unit.shortName }}
                                                                                <a href="javascript:void(0);" class="text-green ms-1" @click="changeUnit(z)"><i class="bx bx-edit"></i></a>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div>{{ z.quantity}}</div>
                                                                            <div v-if="z.withChild"><a href="javascript:void(0);" @click="viewConsolidatedItems(z.prItemId, x)">Child</a></div>
                                                                        </td>
                                                                        <td> {{formatCurrency(z.unitCost)}}</td>
                                                                        <td>{{formatCurrency(z.total)}}</td>
                                                                        <td class="text-center">
                                                                            <a
                                                                                href="javascript:void(0);"
                                                                                title="Remove Item"
                                                                                @click="removeItem(z, 'submitted')"
                                                                                v-if="!z.withChild"
                                                                            >
                                                                                <i class="bx bx-trash text-danger font-size-18"></i>
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                                <tr v-if="x.rfqItemLoading">
                                                                    <td colspan="5">
                                                                        <LoadingTemplate />
                                                                    </td>
                                                                </tr>
                                                                <tr
                                                                    v-if="!x.rfqItemLoading && x.rfqItems.length == 0"
                                                                >
                                                                    <td
                                                                        colspan="6"
                                                                        class="
                                                                            text-center
                                                                        "
                                                                    >
                                                                        <i
                                                                            >No
                                                                            items
                                                                            found</i
                                                                        >
                                                                    </td>
                                                                </tr>
                                                                <tr
                                                                    class="border border-dashed"
                                                                    v-if="!x.rfqItemLoading && x.rfqItems.length > 0"
                                                                >
                                                                    <td colspan="3" class="d-flex">
                                                                        <button type="button" class="btn btn-success btn-sm me-2" v-if="ifSortMoved(x)" @click="saveSort(x)">
                                                                            <i class="bx bx-save"></i> Save Sort
                                                                        </button>
                                                                        <a 
                                                                            href="javascript:void(0);" 
                                                                            class="d-flex align-items-center" 
                                                                            :class="[!x.updateSorting ? 'text-green' : 'text-warning']" 
                                                                            @click="updateItemsSort(x)"
                                                                        >
                                                                            <i class="bx bx-edit me-1"></i>
                                                                            {{x.updateSorting ? 'Cancel Updating' : 'Update'}} Sorting
                                                                        </a>
                                                                    </td>
                                                                    <td class="text-right py-2 px-2" :colspan="$store.state.decrypt.isAdmin() ? 1 : 4">
                                                                        Total RFQ Amount:
                                                                    </td>
                                                                    <td colspan="2" class="py-2">
                                                                        {{ formatCurrency(getTotalPerPR(x.rfqItems)) }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </b-collapse>
                                                    <hr />
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            cursor-pointer
                                                        "
                                                        @click="getRFQBacMembers(x)"
                                                    >
                                                        <h5 class="mb-0 text-primary">
                                                            BAC Members
                                                        </h5>
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.showBACMember,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                     <b-collapse
                                                        :visible="x.showBACMember"
                                                        :accordion="`rfq-bac-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <BACMembers
                                                            :data="x"
                                                            viewFrom="rfq"
                                                            @updateBACMember="updateBACMember($event, x)"
                                                            @addBACMember="addBACMember(x)"
                                                            @deleteBACMember="deleteBACMember($event, x)"
                                                        />
                                                    </b-collapse>
                                                    <hr />
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            cursor-pointer
                                                        "
                                                        @click="
                                                            showRfqSupplier(x)
                                                        "
                                                    >
                                                        <h5 class="mb-0">
                                                            Suppliers &amp; Offers
                                                        </h5>
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.supplierShow,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="
                                                            x.supplierShow
                                                        "
                                                        :accordion="`supplier-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <div
                                                            class="
                                                                d-flex
                                                                align-items-center
                                                                justify-content-between
                                                                mb-3
                                                            "
                                                        >
                                                            <div class="d-flex" v-if="x.rfqSuppliers.length == 0 && !x.itemLoading">
                                                                <p
                                                                    class="mb-0"
                                                                >
                                                                    No suppliers found
                                                                </p>
                                                                <p
                                                                    class="mb-0" 
                                                                    :class="{
                                                                        'text-success': x.supplierMsgType === 'success',
                                                                        'text-danger': x.supplierMsgType === 'danger',
                                                                    }"
                                                                >
                                                                    {{ x.supplierMessage }}
                                                                </p>
                                                            </div>
                                                            <div class="d-flex align-items-center" v-else>
                                                                View: 
                                                                <div class="border p-1 px-2 ms-1 cursor-pointer" :class="{'border border-success': abstractList == 1}" @click="abstractList = 1">
                                                                    <i class="font-size-20 bx bx-list-ol" :class="{'text-success': abstractList == 1}"></i>
                                                                </div>
                                                                <div class="border py-1 px-2 ms-1 cursor-pointer" :class="{'border border-success': abstractList == 2}" @click="abstractList = 2">
                                                                    <i class="font-size-20 bx bxl-microsoft " :class="{'text-success': abstractList == 2}"></i>
                                                                </div>
                                                                <div class="ms-2" v-if="abstractList == 2">
                                                                    <input type="text" class="form-control" v-model="x.searchItem" placeholder="Search Item"/>
                                                                </div>
                                                            </div>
                                                            <div class="">
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    class="text-primary border-primary border p-2"
                                                                    :id="`supplier-popover-${x.id}`"
                                                                    @click="addMoreSupplier(x)"
                                                                    v-if="!x.reAward"
                                                                >
                                                                    <i class="bx bx-plus"></i>
                                                                    Add More Supplier
                                                                </a>
                                                                <b-popover
                                                                    :target="`supplier-popover-${x.id}`"
                                                                    triggers="click"
                                                                    placement="left"
                                                                    custom-class="popover-supplier"
                                                                    :show.sync="
                                                                        x.addSupplier
                                                                    "
                                                                >
                                                                    <template
                                                                        v-slot:title
                                                                    >
                                                                        <div
                                                                            class="
                                                                                d-flex
                                                                                align-items-center
                                                                                justify-content-between
                                                                            "
                                                                        >
                                                                            <small
                                                                                >Add
                                                                                More
                                                                                Supplier</small
                                                                            >
                                                                            <span
                                                                                class="
                                                                                    bx
                                                                                    bx-x
                                                                                    font-size-14
                                                                                    cursor-pointer
                                                                                "
                                                                                @click="
                                                                                    x.addSupplier = false
                                                                                "
                                                                            ></span>
                                                                        </div>
                                                                    </template>
                                                                    <multiselect
                                                                        v-model="
                                                                            addSupplier
                                                                        "
                                                                        :options="
                                                                            suppliers
                                                                        "
                                                                        label="name"
                                                                        track-by="id"
                                                                        value="id"
                                                                        :allow-empty="
                                                                            false
                                                                        "
                                                                        :class="{
                                                                            'is-invalid':
                                                                                submitted &&
                                                                                $v
                                                                                    .addSupplier
                                                                                    .$error,
                                                                        }"
                                                                    />
                                                                    <div
                                                                        v-if="
                                                                            submitted &&
                                                                            $v
                                                                                .addSupplier
                                                                                .$error
                                                                        "
                                                                        class="
                                                                            invalid-feedback
                                                                        "
                                                                    >
                                                                        <span
                                                                            v-if="
                                                                                !$v
                                                                                    .addSupplier
                                                                                    .required
                                                                            "
                                                                            >This
                                                                            value
                                                                            is
                                                                            required.</span
                                                                        >
                                                                    </div>
                                                                    <hr />
                                                                    <div
                                                                        class="
                                                                            text-right
                                                                        "
                                                                    >
                                                                        <button
                                                                            type="button"
                                                                            class="
                                                                                btn
                                                                                btn-success
                                                                                btn-sm
                                                                                me-1
                                                                            "
                                                                            @click="
                                                                                addSup(
                                                                                    x.id
                                                                                )
                                                                            "
                                                                        >
                                                                            <i
                                                                                class="
                                                                                    bx
                                                                                    bx-save
                                                                                    me-1
                                                                                "
                                                                            ></i
                                                                            >Add
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            class="
                                                                                btn
                                                                                btn-sm
                                                                            "
                                                                            @click="
                                                                                x.addSupplier = false
                                                                            "
                                                                        >
                                                                            <i
                                                                                class="
                                                                                    bx
                                                                                    bx-x
                                                                                    me-1
                                                                                "
                                                                            ></i
                                                                            >Cancel
                                                                        </button>
                                                                    </div>
                                                                </b-popover>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="my-3"
                                                            v-if="x.itemLoading"
                                                        >
                                                            <LoadingTemplate />
                                                        </div>
                                                        <template v-if="abstractList == 1">
                                                            <b-card
                                                                no-body
                                                                class="mb-1 shadow-none"
                                                                v-for="(y, index) in x.rfqSuppliers"
                                                                :key="y.id"
                                                            >
                                                                <RawData 
                                                                    :data="y" 
                                                                    v-if="$store.state.decrypt.isAdmin()" 
                                                                    placement="left"
                                                                    :keyId="`supplier-offer-${x.id}${y.id}`"
                                                                />
                                                                <b-card-header
                                                                    header-tag="header"
                                                                    role="tab"
                                                                    class="border"
                                                                >
                                                                    <div
                                                                        class="
                                                                            d-flex
                                                                            justify-content-between
                                                                            align-items-center
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                d-flex
                                                                                align-items-center
                                                                            "
                                                                        >
                                                                            <div
                                                                                style="
                                                                                    min-width: 30px;
                                                                                "
                                                                                class="
                                                                                    bg-success
                                                                                    bg-gradient
                                                                                    text-center
                                                                                    me-2
                                                                                    py-1
                                                                                "
                                                                            >
                                                                                <h3
                                                                                    class="
                                                                                        mb-0
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        index +
                                                                                        1
                                                                                    }}
                                                                                </h3>
                                                                            </div>
                                                                            <div>
                                                                                <h5 class="mb-0">
                                                                                    {{ y.supplier.name}}
                                                                                </h5>
                                                                                <div class="d-flex align-items-center">
                                                                                    <small class="me-1">
                                                                                        {{ y.supplier.address}}
                                                                                    </small>
                                                                                    <template v-if="!x.reAward">
                                                                                        |
                                                                                        <small class="cursor-pointer me-1" @click="removeSup(x.id, y.id)">
                                                                                            <b class="ms-1 text-danger">
                                                                                                <i class="bx bx-trash"></i>
                                                                                                Remove Supplier
                                                                                            </b>
                                                                                        </small>
                                                                                        |
                                                                                        <div class="form-check form-checkbox-outline form-check-success mb-0 mx-2">
                                                                                            <input
                                                                                                autocomplete="off"
                                                                                                class="form-check-input"
                                                                                                type="checkbox"
                                                                                                :id="`did-not-submit-${y.id}`"
                                                                                                v-model="y.didNotSubmit"
                                                                                                @click="didNotSubmit(y)"
                                                                                            />&nbsp;&nbsp;
                                                                                            <label class="form-check-label" :for="`did-not-submit-${y.id}`">
                                                                                                Did Not Submit
                                                                                            </label>
                                                                                        </div>
                                                                                        |
                                                                                        <div class="ms-2">
                                                                                            <div class="form-check form-checkbox-outline form-check-success mb-0">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    :id="`cod-${y.id}`"
                                                                                                    class="form-check-input"
                                                                                                    v-model="y.isCod"
                                                                                                    @click="cashOnDelivery(y)"
                                                                                                />&nbsp;&nbsp;
                                                                                                <label :for="`cod-${y.id}`" class="form-check-label">
                                                                                                    Cash on Delivery?
                                                                                                </label>
                                                                                            </div>
                                                                                        </div>
                                                                                    </template>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                d-flex
                                                                                align-items-center
                                                                            "
                                                                            v-if="!y.didNotSubmit"
                                                                        >
                                                                            <button
                                                                                class="
                                                                                    btn
                                                                                    border-success
                                                                                    me-3
                                                                                    text-success
                                                                                "
                                                                                type="button"
                                                                                @click="
                                                                                    updateOffer(
                                                                                        y.supplierRFQ,
                                                                                        index,
                                                                                        y.id,
                                                                                        y.rfqReturnDate,
                                                                                        x.id
                                                                                    )
                                                                                "
                                                                                v-if="!x.reAward"
                                                                            >
                                                                                Update
                                                                                Offer
                                                                            </button>
                                                                            <a
                                                                                href="javascript: void(0);"
                                                                                class="
                                                                                    d-flex
                                                                                    align-items-center
                                                                                    text-info
                                                                                "
                                                                                @click="
                                                                                    y.visible =
                                                                                        !y.visible
                                                                                "
                                                                            >
                                                                                {{
                                                                                    y.visible
                                                                                        ? "Hide"
                                                                                        : "Show"
                                                                                }}
                                                                                Offer
                                                                                <i
                                                                                    class="
                                                                                        bx
                                                                                        bx-chevron-right
                                                                                        rotate
                                                                                        font-size-14
                                                                                    "
                                                                                    :class="{
                                                                                        'rotate-90':
                                                                                            y.visible,
                                                                                    }"
                                                                                ></i>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </b-card-header>
                                                                <b-collapse
                                                                    :visible="
                                                                        y.visible
                                                                    "
                                                                    :accordion="`posted-supplier-${y.id}`"
                                                                    role="tabpanel"
                                                                >
                                                                    <div
                                                                        class="
                                                                            px-2
                                                                            py-1
                                                                        "
                                                                    >
                                                                        <table
                                                                            class="
                                                                                table
                                                                                table-bordered
                                                                            "
                                                                        >
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>
                                                                                        Item
                                                                                        Name
                                                                                        <div>
                                                                                            <small
                                                                                                >Item
                                                                                                Description</small
                                                                                            >
                                                                                        </div>
                                                                                    </th>
                                                                                    <th
                                                                                        style="
                                                                                            width: 120px;
                                                                                        "
                                                                                    >
                                                                                        Unit
                                                                                    </th>
                                                                                    <th
                                                                                        style="
                                                                                            width: 70px;
                                                                                        "
                                                                                    >
                                                                                        Qty
                                                                                    </th>
                                                                                    <th
                                                                                        style="
                                                                                            width: 150px;
                                                                                        "
                                                                                    >
                                                                                        Unit
                                                                                        Cost
                                                                                    </th>
                                                                                    <th
                                                                                        style="
                                                                                            width: 150px;
                                                                                        "
                                                                                    >
                                                                                        Total
                                                                                    </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <template v-for="(z, zIndex) in y.supplierRFQ">
                                                                                    <tr :key="z.id">
                                                                                        <td class="position-relative">
                                                                                            <div class="position-absolute bg-purple text-center item-index">
                                                                                                <span class="badge">
                                                                                                    {{ zIndex + 1 }}
                                                                                                </span>
                                                                                            </div>
                                                                                            {{ z.itemName }}
                                                                                            <div>
                                                                                                <small>{{z.description}}</small>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td>{{z.unit.shortName}}</td>
                                                                                        <td>{{ z.quantity }}</td>
                                                                                        <td>{{ formatCurrency(z.unitCost)}}</td>
                                                                                        <td>{{formatCurrency(z.total)}}</td>
                                                                                    </tr>
                                                                                    <template v-if="z.offer.noOffer">
                                                                                        <tr :key="`no-offer-${z.id}`">
                                                                                            <td colspan="5" class="text-center">
                                                                                                <i>No offer...</i>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </template>
                                                                                    <template v-else>
                                                                                        <tr 
                                                                                            :key="`offer-${z.id}`" 
                                                                                            v-if="z.offer.id > 0"
                                                                                            class="custom-border-2"
                                                                                        >
                                                                                            <td class="position-relative">
                                                                                                <div class="bg-secondary bg-soft rotate-270">
                                                                                                    <span class="badge">
                                                                                                        Item Offer
                                                                                                    </span>
                                                                                                </div>
                                                                                                {{ z.offer.itemName }}
                                                                                                <div>
                                                                                                    <small>{{ z.offer.description}}</small>
                                                                                                </div>
                                                                                                <div>
                                                                                                    <p class="mb-0" v-if="z.offer.deliveryPeriod">{{z.offer.deliveryPeriod}} calendar day(s)</p>
                                                                                                </div>
                                                                                                <div>
                                                                                                    <div>
                                                                                                        <a
                                                                                                            href="javascript:void(0);"
                                                                                                            :id="`moreSpecView${z.offer.id}`"
                                                                                                            ><i
                                                                                                                class="
                                                                                                                    mdi mdi-triangle
                                                                                                                    rotate rotate-90
                                                                                                                    me-1
                                                                                                                "
                                                                                                            ></i
                                                                                                            >More Specifications</a
                                                                                                        >
                                                                                                        <b-popover
                                                                                                            :target="`moreSpecView${z.offer.id}`"
                                                                                                            triggers="click"
                                                                                                            placement="right"
                                                                                                            :show.sync="z.offer.showMoreSpec"
                                                                                                            custom-class="popover-supplier"
                                                                                                        >
                                                                                                            <template v-slot:title>
                                                                                                                <div
                                                                                                                    class="
                                                                                                                        d-flex
                                                                                                                        align-items-center
                                                                                                                        justify-content-between
                                                                                                                    "
                                                                                                                >
                                                                                                                    <small
                                                                                                                        >More Specifications</small
                                                                                                                    >
                                                                                                                    <span
                                                                                                                        class="
                                                                                                                            bx bx-x
                                                                                                                            font-size-14
                                                                                                                            cursor-pointer
                                                                                                                        "
                                                                                                                        @click="
                                                                                                                            z.offer.showMoreSpec = false
                                                                                                                        "
                                                                                                                    ></span>
                                                                                                                </div>
                                                                                                            </template>
                                                                                                            <div class="row mb-2">
                                                                                                                <div class="col-md-6">
                                                                                                                    <label for="" class="mb-0"
                                                                                                                        >Brand</label
                                                                                                                    >
                                                                                                                    <div
                                                                                                                        type="text"
                                                                                                                        placeholder="Enter Brand"
                                                                                                                        class="
                                                                                                                            form-control
                                                                                                                            form-control-sm text-warning
                                                                                                                        "
                                                                                                                    >
                                                                                                                        {{z.offer.brand}}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div class="col-md-6">
                                                                                                                    <label for="" class="mb-0"
                                                                                                                        >Model</label
                                                                                                                    >
                                                                                                                    <div
                                                                                                                        class="
                                                                                                                            form-control
                                                                                                                            form-control-sm text-warning
                                                                                                                        "
                                                                                                                        
                                                                                                                    >
                                                                                                                        {{z.offer.model}}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div class="row mb-2">
                                                                                                                <div class="col-md-6">
                                                                                                                    <label for="" class="mb-0"
                                                                                                                        >Color</label
                                                                                                                    >
                                                                                                                    <div
                                                                                                                        class="
                                                                                                                            form-control
                                                                                                                            form-control-sm text-warning
                                                                                                                        "
                                                                                                                    >
                                                                                                                        {{z.offer.color}}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div class="col-md-6">
                                                                                                                    <label for="" class="mb-0"
                                                                                                                        >Condition</label
                                                                                                                    >
                                                                                                                    <div
                                                                                                                        class="
                                                                                                                            form-control
                                                                                                                            form-control-sm text-warning
                                                                                                                        "
                                                                                                                    >
                                                                                                                        {{z.offer.condition}}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div class="row mb-2">
                                                                                                                <div class="col-md-6">
                                                                                                                    <label for="" class="mb-0"
                                                                                                                        >Material Used</label
                                                                                                                    >
                                                                                                                    <div
                                                                                                                        class="
                                                                                                                            form-control
                                                                                                                            form-control-sm text-warning
                                                                                                                        "
                                                                                                                    >
                                                                                                                        {{z.offer.materialUsed}}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div class="col-md-6">
                                                                                                                    <label for="" class="mb-0"
                                                                                                                        >Package Description</label
                                                                                                                    >
                                                                                                                    <div
                                                                                                                        class="
                                                                                                                            form-control
                                                                                                                            form-control-sm text-warning
                                                                                                                        "
                                                                                                                    >
                                                                                                                        {{z.offer.packageDescription}}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div class="mb-2">
                                                                                                                <label for="" class="mb-0"
                                                                                                                    >Dimension Description</label
                                                                                                                >
                                                                                                                <div
                                                                                                                    class="
                                                                                                                        form-control form-control-sm text-warning
                                                                                                                    "
                                                                                                                >
                                                                                                                    {{z.offer.dimensionDescription}}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div class="mb-2">
                                                                                                                <label for="" class="mb-0"
                                                                                                                    >Other Specifications</label
                                                                                                                >
                                                                                                                <div
                                                                                                                    class="
                                                                                                                        form-control form-control-sm text-warning
                                                                                                                    "
                                                                                                                >
                                                                                                                    {{z.offer.specification}}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div class="mb-2">
                                                                                                                <label for="" class="mb-0"
                                                                                                                    >Notes</label
                                                                                                                >
                                                                                                                <div
                                                                                                                    class="
                                                                                                                        form-control form-control-sm
                                                                                                                        text-warning
                                                                                                                    "
                                                                                                                >
                                                                                                                    {{
                                                                                                                        z.offer.note
                                                                                                                    }}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </b-popover>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>
                                                                                                {{
                                                                                                    z
                                                                                                        .offer
                                                                                                        .unit
                                                                                                        .shortName
                                                                                                }}
                                                                                            </td>
                                                                                            <td>
                                                                                                {{
                                                                                                    z
                                                                                                        .offer
                                                                                                        .quantity
                                                                                                }}
                                                                                            </td>
                                                                                            <td>
                                                                                                {{
                                                                                                    formatCurrency(
                                                                                                        z
                                                                                                            .offer
                                                                                                            .unitCost
                                                                                                    )
                                                                                                }}
                                                                                            </td>
                                                                                            <td
                                                                                                class="
                                                                                                    position-relative
                                                                                                "
                                                                                            >
                                                                                                <div
                                                                                                    class="
                                                                                                        position-absolute
                                                                                                        cursor-pointer
                                                                                                        d-flex
                                                                                                    "
                                                                                                    style="
                                                                                                        right: 0;
                                                                                                        top: -12px;
                                                                                                    "
                                                                                                >
                                                                                                    <div
                                                                                                        @click="markAsWinner(z.offer)"
                                                                                                        class="me-1"
                                                                                                        v-if="!x.reAward"
                                                                                                    >
                                                                                                        <span
                                                                                                            class="
                                                                                                                badge
                                                                                                                px-1
                                                                                                            "
                                                                                                            :class="{
                                                                                                                'bg-success':
                                                                                                                    !z
                                                                                                                        .offer
                                                                                                                        .isWinner,
                                                                                                                'bg-warning bg-gradient':
                                                                                                                    z
                                                                                                                        .offer
                                                                                                                        .isWinner,
                                                                                                            }"
                                                                                                            ><i
                                                                                                                class="
                                                                                                                    bx
                                                                                                                    bx-check
                                                                                                                    me-1
                                                                                                                "
                                                                                                            ></i
                                                                                                            >{{
                                                                                                                z
                                                                                                                    .offer
                                                                                                                    .isWinner
                                                                                                                    ? "Remove as winner"
                                                                                                                    : "Mark as winner"
                                                                                                            }}</span
                                                                                                        >
                                                                                                    </div>
                                                                                                    <div @click="removeOffer(z.offer)"  v-if="!x.reAward"
                                                                                                    >
                                                                                                        <span
                                                                                                            class="
                                                                                                                badge
                                                                                                                bg-danger
                                                                                                                px-1
                                                                                                            "
                                                                                                            ><i
                                                                                                                class="
                                                                                                                    bx
                                                                                                                    bx-trash
                                                                                                                    me-1
                                                                                                                "
                                                                                                            ></i
                                                                                                            >Remove
                                                                                                            offer</span
                                                                                                        >
                                                                                                    </div>
                                                                                                </div>
                                                                                                {{
                                                                                                    formatCurrency(
                                                                                                        parseFloat(
                                                                                                            z
                                                                                                                .offer
                                                                                                                .unitCost
                                                                                                        ) *
                                                                                                            parseFloat(
                                                                                                                z
                                                                                                                    .offer
                                                                                                                    .quantity
                                                                                                            )
                                                                                                    )
                                                                                                }}
                                                                                                <div
                                                                                                    class="
                                                                                                        mt-2
                                                                                                        text-center
                                                                                                    "
                                                                                                    v-if="
                                                                                                        z
                                                                                                            .offer
                                                                                                            .isWinner
                                                                                                    "
                                                                                                >
                                                                                                    <small
                                                                                                        class="
                                                                                                            badge
                                                                                                            bg-success
                                                                                                            px-2
                                                                                                        "
                                                                                                        ><i
                                                                                                            class="
                                                                                                                bx
                                                                                                                bx-crown
                                                                                                            "
                                                                                                        ></i
                                                                                                        >Winner</small
                                                                                                    >
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr
                                                                                            :key="`no-offer-yet-${z.id}`"
                                                                                            v-else
                                                                                        >
                                                                                            <td
                                                                                                colspan="5"
                                                                                                class="
                                                                                                    text-center
                                                                                                "
                                                                                            >
                                                                                                <i
                                                                                                    >No
                                                                                                    offer
                                                                                                    yet</i
                                                                                                >
                                                                                            </td>
                                                                                        </tr>
                                                                                    </template>
                                                                                </template>
                                                                                <tr
                                                                                    class="
                                                                                        border
                                                                                        border-dashed
                                                                                    "
                                                                                >
                                                                                    <td
                                                                                        class="
                                                                                            py-2
                                                                                        "
                                                                                        colspan="3"
                                                                                    ></td>
                                                                                    <td
                                                                                        class="
                                                                                            text-right
                                                                                            py-2
                                                                                            px-2
                                                                                        "
                                                                                    >
                                                                                        Total ABC as Awarded:
                                                                                    </td>
                                                                                    <td
                                                                                        colspan="2"
                                                                                        class="
                                                                                            py-2
                                                                                        "
                                                                                    >
                                                                                        {{
                                                                                            formatCurrency(
                                                                                                getTotalABC(
                                                                                                    y.supplierRFQ
                                                                                                )
                                                                                            )
                                                                                        }}
                                                                                    </td>
                                                                                </tr>
                                                                                <tr
                                                                                    class="
                                                                                        border
                                                                                        border-dashed
                                                                                    "
                                                                                >
                                                                                    <td
                                                                                        class="
                                                                                            py-2
                                                                                        "
                                                                                        colspan="3"
                                                                                    >
                                                                                        <div>
                                                                                            <button
                                                                                                type="button"
                                                                                                class="btn btn-link"
                                                                                                @click="addAttachment(y, false)"
                                                                                            >
                                                                                                <i class="mdi mdi-paperclip"></i> Attachments
                                                                                            </button>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td
                                                                                        class="
                                                                                            text-right
                                                                                            py-2
                                                                                            px-2
                                                                                        "
                                                                                    >
                                                                                        Total Awarded Amount:
                                                                                    </td>
                                                                                    <td
                                                                                        colspan="2"
                                                                                        class="
                                                                                            py-2
                                                                                        "
                                                                                    >
                                                                                        {{
                                                                                            formatCurrency(
                                                                                                getTotalOffer(
                                                                                                    y.supplierRFQ
                                                                                                )
                                                                                            )
                                                                                        }}
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </b-collapse>
                                                            </b-card>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="!x.itemLoading">
                                                                <div class="custom-table-responsive">
                                                                    <table class="table table-bordered" style="width:unset !important;">
                                                                        <thead>
                                                                            <tr>
                                                                                <th width="100px">Qty/Unit</th>
                                                                                <th width="200px">Item</th>
                                                                                <th width="150px">Unit Cost</th>
                                                                                <template v-for="(z, index) in x.rfqSuppliers">
                                                                                    <th :key="`Supplier-${z.id}`" width="300px" style="vertical-align:top">
                                                                                        <span class="text-warning d-inline">
                                                                                            {{ z.supplier.name }} 
                                                                                            <a href="javascript:void(0);"  v-if="!x.reAward" @click="updateOffer(z.supplierRFQ, index, z.id, z.rfqReturnDate, x.id)"><i class="bx bx-edit"></i></a>
                                                                                            <a href="javascript:void(0);"  v-if="!x.reAward" class="text-danger" @click="removeSup(x.id, z.id)"><i class="bx bx-trash"></i></a>
                                                                                        </span>
                                                                                        <div class="text-ellipsis" style="width:300px;">
                                                                                            <small>{{z.supplier.address}}</small>
                                                                                        </div>
                                                                                        <div class="form-check form-checkbox-outline form-check-success mb-0" v-if="!x.reAward">
                                                                                            <input
                                                                                                autocomplete="off"
                                                                                                class="form-check-input"
                                                                                                type="checkbox"
                                                                                                :id="`did-not-submit-${z.id}`"
                                                                                                v-model="z.didNotSubmit"
                                                                                                @click="didNotSubmit(z)"
                                                                                            />&nbsp;&nbsp;
                                                                                            <label class="form-check-label" :for="`did-not-submit-${z.id}`">
                                                                                                Did Not Submit
                                                                                            </label>
                                                                                        </div>
                                                                                    </th>
                                                                                </template>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <template v-if="filteredRfqItems(x).length > 0">
                                                                                <template v-for="z in filteredRfqItems(x)">
                                                                                    <tr :key="z.id">
                                                                                        <td>{{ z.quantity }} {{ z.unit.shortName }}</td>
                                                                                        <td>{{ z.itemName }}</td>
                                                                                        <td>{{ formatCurrency(z.unitCost) }}</td>
                                                                                        <template v-for="y in x.rfqSuppliers">
                                                                                            <td :key="`Supplier-Offer-${y.id}`" class="position-relative v-align-middle">
                                                                                                <template v-if="y.didNotSubmit">
                                                                                                    <div><i>Did not Submit</i></div>
                                                                                                </template>
                                                                                                <template v-else>
                                                                                                    <template v-if="getOffer(y.supplierRFQ, z.id).offer.id > 0">
                                                                                                        <template v-if="getOffer(y.supplierRFQ, z.id).offer.noOffer">
                                                                                                            <div class="text-center">
                                                                                                                <i>Supplier has no offer</i>
                                                                                                            </div>
                                                                                                        </template>
                                                                                                        <template v-else>
                                                                                                            <div class="position-absolute isWinner" v-if="getOffer(y.supplierRFQ, z.id).offer.isWinner"></div>
                                                                                                            <div class="mb-1">
                                                                                                                <i>{{ getOffer(y.supplierRFQ, z.id).offer.itemName}}</i>
                                                                                                                <div style="width:250px;" class="line-height-1 hover-underline cursor-pointer"
                                                                                                                    :class="{'clamp-text': !getOffer(y.supplierRFQ, z.id).clamped }"
                                                                                                                    @click="getOffer(y.supplierRFQ, z.id).clamped = !getOffer(y.supplierRFQ, z.id).clamped"
                                                                                                                >
                                                                                                                    <small>{{ getOffer(y.supplierRFQ, z.id).offer.description }}</small>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div>
                                                                                                                Qty: <span class="text-warning">{{ getOffer(y.supplierRFQ, z.id).offer.quantity }}</span>
                                                                                                            </div>
                                                                                                            <div>
                                                                                                                Price: <span class="text-warning">{{ formatCurrency(getOffer(y.supplierRFQ, z.id).offer.unitCost)}}</span>
                                                                                                            </div>
                                                                                                            <div>
                                                                                                                Total: <span class="text-warning">{{ formatCurrency(parseFloat(
                                                                                                                    getOffer(y.supplierRFQ, z.id)
                                                                                                                    .offer
                                                                                                                    .unitCost
                                                                                                            ) *
                                                                                                                parseFloat(
                                                                                                                    getOffer(y.supplierRFQ, z.id)
                                                                                                                        .offer
                                                                                                                        .quantity
                                                                                                                ))}}</span>
                                                                                                            </div>
                                                                                                            <div class="d-flex align-items-center" v-if="!x.reAward">
                                                                                                                <div
                                                                                                                    @click="markAsWinner(getOffer(y.supplierRFQ, z.id).offer)"
                                                                                                                    class="me-1 cursor-pointer"
                                                                                                                >
                                                                                                                    <span
                                                                                                                        class="
                                                                                                                            badge
                                                                                                                            px-1
                                                                                                                        "
                                                                                                                        :class="{
                                                                                                                            'bg-success': !getOffer(y.supplierRFQ, z.id).offer.isWinner,
                                                                                                                            'bg-warning bg-gradient': getOffer(y.supplierRFQ, z.id).offer.isWinner,
                                                                                                                        }"
                                                                                                                    >
                                                                                                                        <i class="bx bx-check me-1"></i>
                                                                                                                        {{ getOffer(y.supplierRFQ, z.id).offer.isWinner ? "Remove as winner" : "Mark as winner" }}
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                                <div
                                                                                                                    @click="removeOffer(getOffer(y.supplierRFQ, z.id).offer)"
                                                                                                                    class="cursor-pointer"
                                                                                                                >
                                                                                                                    <span
                                                                                                                        class="
                                                                                                                            badge
                                                                                                                            bg-danger
                                                                                                                            px-1
                                                                                                                        "
                                                                                                                        ><i
                                                                                                                            class="
                                                                                                                                bx
                                                                                                                                bx-trash
                                                                                                                                me-1
                                                                                                                            "
                                                                                                                        ></i
                                                                                                                        >Remove
                                                                                                                        offer</span
                                                                                                                    >
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </template>
                                                                                                    </template>
                                                                                                    <div v-else>No offer yet</div>
                                                                                                </template>
                                                                                            </td>
                                                                                        </template>
                                                                                    </tr>
                                                                                </template>
                                                                            </template>
                                                                            <template v-else>
                                                                                <tr>
                                                                                    <td colspan="100%" class="text-center">
                                                                                        Search not found
                                                                                    </td>
                                                                                </tr>
                                                                            </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </template>
                                                        </template>
                                                    </b-collapse>
                                                    <!-- <hr />
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            cursor-pointer
                                                        "
                                                        @click="
                                                            getPublicPostAttachments(x)
                                                        "
                                                    >
                                                        <h5 class="mb-0 text-info">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-repost
                                                                    rotate
                                                                    rotate-90
                                                                "
                                                            ></i>
                                                            Public Posting Options
                                                        </h5>
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.postOptionShow,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="
                                                            x.postOptionShow
                                                        "
                                                        :accordion="`public-posting-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <div class="d-flex align-items-center justify-content-between mb-2">
                                                            <input
                                                                type="search"
                                                                class="
                                                                    form-control popover-report
                                                                "
                                                                v-model="
                                                                    x.fileSearch
                                                                "
                                                                @input="
                                                                    searchPost(
                                                                        x
                                                                    )
                                                                "
                                                                placeholder="Search Public Post Attachments..."
                                                            />
                                                            <button type="button" class="btn btn-outline-info" @click="addPublicPost(x)"><i class="bx bx-plus"></i>Add Public Post Attachment</button>
                                                        </div>
                                                        <div class="table-responsive">
                                                            <table class="table table-bordered table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Title</th>
                                                                        <th>Description</th>
                                                                        <th>Attachment</th>
                                                                        <th width="90px">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="post in x.posts" :key="post.id">
                                                                        <td>Sample Title</td>
                                                                        <td>Sample Description</td>
                                                                        <td>
                                                                            <div v-if="post.attachments.length > 0">

                                                                            </div>
                                                                            <div v-else>
                                                                                <a href="javascript:void(0);" class="hoverable-link"><i class="bx bx-plus me-1"></i>Add Attachments</a>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </b-collapse> -->
                                                    <hr />
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            cursor-pointer
                                                        "
                                                        @click="
                                                            getAttachments(x)
                                                        "
                                                    >
                                                        <h5 class="mb-0 text-warning">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-paperclip
                                                                    rotate
                                                                    rotate-90
                                                                "
                                                            ></i>
                                                            Attachments
                                                        </h5>
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.attachmentVisible,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="
                                                            x.attachmentVisible
                                                        "
                                                        :accordion="`posted-attachment-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <div
                                                            class="
                                                                d-flex
                                                                align-items-center
                                                                justify-content-between
                                                                mb-3
                                                            "
                                                        >
                                                            <div class="d-flex">
                                                                <p
                                                                    class="mb-0"
                                                                    v-if="!x.attachmentLoading &&
                                                                        x
                                                                            .rfqFiles
                                                                            .length ==
                                                                        0
                                                                    "
                                                                >
                                                                    <i
                                                                        >No
                                                                        documents
                                                                        found</i
                                                                    >
                                                                </p>
                                                                <p
                                                                    class="mb-0"
                                                                    v-if="
                                                                        x.attachmentLoading
                                                                    "
                                                                >
                                                                    <i class="font-size-15">Loading...</i
                                                                    >
                                                                </p>
                                                                <input
                                                                    v-if="!x.attachmentLoading &&
                                                                        x
                                                                            .rfqFiles
                                                                            .length >
                                                                        0
                                                                    "
                                                                    type="search"
                                                                    class="
                                                                        form-control
                                                                    "
                                                                    v-model="
                                                                        x.fileSearch
                                                                    "
                                                                    @input="
                                                                        searchDocu(
                                                                            x
                                                                        )
                                                                    "
                                                                    placeholder="Search Documents..."
                                                                />
                                                            </div>
                                                            <div class="">
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    class="
                                                                        text-primary
                                                                        border-primary
                                                                        border
                                                                        p-2
                                                                    "
                                                                    :id="`submitted-document${x.id}`"
                                                                    @click="
                                                                        x.addDocu = true
                                                                    "
                                                                    ><i
                                                                        class="
                                                                            bx
                                                                            bx-plus
                                                                        "
                                                                    ></i
                                                                    >Upload
                                                                    Documents</a
                                                                >
                                                                <upload-popover
                                                                    :option="
                                                                        uploadOptions
                                                                    "
                                                                    :sourceId="
                                                                        x.id
                                                                    "
                                                                    @uploaded="
                                                                        uploadedSubmitted(
                                                                            $event,
                                                                            x.id
                                                                        )
                                                                    "
                                                                    :showPV="
                                                                        x.addDocu
                                                                    "
                                                                    @closePopover="
                                                                        x.addDocu = false
                                                                    "
                                                                    :dzId="`dropzone-submitted${x.id}`"
                                                                    :pvId="`submitted-document${x.id}`"
                                                                ></upload-popover>
                                                            </div>
                                                        </div>
                                                        <div class="mt-2">
                                                            <b-row>
                                                                <b-col
                                                                    sm="3"
                                                                    v-for="(
                                                                        y, index
                                                                    ) in searchDocu(
                                                                        x
                                                                    )"
                                                                    :key="y.id"
                                                                    class="mb-2"
                                                                >
                                                                    <div
                                                                        class="
                                                                            position-relative
                                                                            cursor-pointer
                                                                        "
                                                                        :style="`z-index: ${
                                                                            searchDocu(
                                                                                x
                                                                            )
                                                                                .length -
                                                                            index
                                                                        }`"
                                                                    >
                                                                        <div
                                                                            class="
                                                                                border
                                                                                p-3
                                                                            "
                                                                        >
                                                                            <div>
                                                                                <div
                                                                                    class="
                                                                                        float-end
                                                                                        ms-2
                                                                                    "
                                                                                >
                                                                                    <b-dropdown
                                                                                        id="dropdown-dropleft"
                                                                                        right
                                                                                        variant="link"
                                                                                        toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                                        menu-class="dropdown-menu-end"
                                                                                        no-caret
                                                                                    >
                                                                                        <template
                                                                                            #button-content
                                                                                        >
                                                                                            <i
                                                                                                class="
                                                                                                    mdi
                                                                                                    mdi-dots-horizontal
                                                                                                "
                                                                                            ></i>
                                                                                        </template>
                                                                                        <b-dropdown-item
                                                                                            @click="
                                                                                                openDocument(
                                                                                                    y
                                                                                                )
                                                                                            "
                                                                                            ><i
                                                                                                class="
                                                                                                    bx
                                                                                                    bx-link-external
                                                                                                    me-1
                                                                                                "
                                                                                            ></i
                                                                                            >Open</b-dropdown-item
                                                                                        >
                                                                                        <b-dropdown-item
                                                                                            variant="danger"
                                                                                            @click="
                                                                                                removeFile(
                                                                                                    y.id,
                                                                                                    x.id,
                                                                                                    'submitted'
                                                                                                )
                                                                                            "
                                                                                            ><i
                                                                                                class="
                                                                                                    bx
                                                                                                    bx-trash
                                                                                                    me-1
                                                                                                "
                                                                                            ></i
                                                                                            >Remove</b-dropdown-item
                                                                                        >
                                                                                    </b-dropdown>
                                                                                </div>
                                                                                <div
                                                                                    class="
                                                                                        avatar-xs
                                                                                        me-3
                                                                                        mb-2
                                                                                    "
                                                                                    @click="
                                                                                        openDocument(
                                                                                            y
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="
                                                                                            avatar-title
                                                                                            bg-transparent
                                                                                            rounded
                                                                                        "
                                                                                    >
                                                                                        <i
                                                                                            v-if="
                                                                                                y.fileType.includes(
                                                                                                    'image'
                                                                                                )
                                                                                            "
                                                                                            class="
                                                                                                mdi
                                                                                                mdi-image
                                                                                                font-size-24
                                                                                                text-purple
                                                                                            "
                                                                                        ></i>
                                                                                        <i
                                                                                            v-if="
                                                                                                y.fileType.includes(
                                                                                                    'application'
                                                                                                )
                                                                                            "
                                                                                            class="
                                                                                                mdi
                                                                                                mdi-file-pdf-outline
                                                                                                font-size-24
                                                                                                text-danger
                                                                                            "
                                                                                        ></i>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    class="
                                                                                        d-flex
                                                                                    "
                                                                                    @click="
                                                                                        openDocument(
                                                                                            y
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="
                                                                                            overflow-hidden
                                                                                            me-auto
                                                                                        "
                                                                                    >
                                                                                        <h5
                                                                                            class="
                                                                                                font-size-14
                                                                                                text-truncate
                                                                                                mb-1
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                y.description
                                                                                            }}
                                                                                        </h5>
                                                                                        <p
                                                                                            class="
                                                                                                text-muted
                                                                                                mb-0
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                formatDateWithTime(
                                                                                                    new Date(
                                                                                                        y.dateTimeUploaded
                                                                                                    )
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row
                                                                v-if="
                                                                    searchDocu(
                                                                        x
                                                                    ).length ==
                                                                        0 &&
                                                                    x.fileSearch
                                                                "
                                                            >
                                                                <b-col
                                                                    >Search Not
                                                                    Found</b-col
                                                                >
                                                            </b-row>
                                                        </div>
                                                    </b-collapse>
                                                    <hr />
                                                    <div class="d-flex justify-content-between">
                                                        <div class="d-flex">
                                                            <button
                                                                type="button"
                                                                class="
                                                                    btn btn-success
                                                                    me-2
                                                                "
                                                                @click="postRFQ(x)"
                                                                v-if="!x.reAward"
                                                            >
                                                                <i
                                                                    class="
                                                                        bx bx-check
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Finalize Abstract
                                                            </button>
                                                            <b-dropdown
                                                                id="dropdown-dropleft"
                                                                right
                                                                variant="purple me-2"
                                                                toggle-class="text-decoration-none"
                                                                menu-class="dropdown-menu"
                                                                with-caret
                                                            >
                                                                <template #button-content>
                                                                    <i class="bx bx-printer me-1"></i> Print RFQ<i
                                                                        class="
                                                                            mdi mdi-chevron-down
                                                                            d-none d-xl-inline-block
                                                                            ms-1
                                                                        "
                                                                    ></i>
                                                                </template>
                                                                <b-dropdown-item @click="printRFQ(x.id, 'blank')"
                                                                    >Blank</b-dropdown-item
                                                                >
                                                                <b-dropdown-item @click="printRFQ(x.id, 'supplier')"
                                                                    >With Supplier</b-dropdown-item
                                                                >
                                                            </b-dropdown>
                                                            <button
                                                                type="button"
                                                                class="
                                                                    btn btn-purple
                                                                    me-2
                                                                "
                                                                @click="
                                                                    printAbstract(
                                                                        x.id
                                                                    )
                                                                "
                                                            >
                                                                <i
                                                                    class="
                                                                        bx
                                                                        bxs-printer
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Print Abstract
                                                            </button>
                                                            <b-dropdown
                                                                id="dropdown-dropleft"
                                                                right
                                                                variant="purple me-2"
                                                                toggle-class="text-decoration-none"
                                                                menu-class="dropdown-menu"
                                                                with-caret
                                                            >
                                                                <template #button-content>
                                                                    <i class="bx bx-printer me-1"></i> Print Invitation<i
                                                                        class="
                                                                            mdi mdi-chevron-down
                                                                            d-none d-xl-inline-block
                                                                            ms-1
                                                                        "
                                                                    ></i>
                                                                </template>
                                                                <b-dropdown-item @click="printInvitation(x.id, true)"
                                                                    >With SGD</b-dropdown-item
                                                                >
                                                                <b-dropdown-item @click="printInvitation(x.id, false)"
                                                                    >Without SGD</b-dropdown-item
                                                                >
                                                            </b-dropdown>
                                                            <button
                                                                type="button"
                                                                class="btn btn-danger me-2"
                                                                @click="deleteRFQ(x.id)"
                                                                v-if="!x.reAward"
                                                            >
                                                                <i class="bx bx-trash me-1"></i>Delete RFQ
                                                            </button>
                                                        </div>
                                                        <div>
                                                            <button type="button" class="btn btn-info d-flex align-items-center" @click="postToPublic(x)" v-if="x.publicPostedRfqs.length == 0 && !x.reAward"><i class="bx bx-repost me-1 font-size-18"></i>Post to Public</button>
                                                            <button type="button" class="btn btn-warning d-flex align-items-center" @click="unPostToPublic(x)" v-if="x.publicPostedRfqs.length && !x.reAward"><i class="bx bx-x me-1 font-size-18"></i>UnPost from Public</button>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="
                                                            d-flex
                                                            mt-2
                                                            align-items-center
                                                        "
                                                        v-if="x.isPosting"
                                                    >
                                                        <div
                                                            class="
                                                                spinner-border
                                                                text-success
                                                            "
                                                            role="status"
                                                            style="
                                                                width: 15px;
                                                                height: 15px;
                                                            "
                                                            v-if="!x.errorPost"
                                                        >
                                                            <span
                                                                class="sr-only"
                                                                >Loading...</span
                                                            >
                                                        </div>
                                                        <div
                                                            class="ms-1"
                                                            :class="{
                                                                'text-danger':
                                                                    x.errorPost,
                                                            }"
                                                        >
                                                            {{
                                                                x.postingMessage
                                                            }}
                                                        </div>
                                                    </div>
                                                </b-card-body>
                                            </b-collapse>
                                        </b-card>
                                    </div>
                                    <div class="mt-3">
                                        <div
                                            class="
                                                dataTables_paginate
                                                paging_simple_numbers
                                                float-end
                                            "
                                        >
                                            <ul class="pagination pagination-rounded mb-0">
                                                <b-pagination
                                                    v-model="currentSubmittedPage"
                                                    :total-rows="submittedRows"
                                                    :per-page="perSubmittedPage"
                                                ></b-pagination>
                                            </ul>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title-item-class="mb-2">
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="bx bx-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block"
                                >Posted (<template v-if="!postedBusy">{{
                                    posted.length
                                }}</template
                                ><template v-if="postedBusy"
                                    ><b-spinner
                                        type="grow"
                                        class="wh-10p"
                                        variant="success"
                                        role="status"
                                    ></b-spinner></template
                                >)</span
                            >
                        </template>
                        <div class="card">
                            <div class="card-body bg-primary bg-soft">
                                <div
                                    class="
                                        d-flex
                                        align-items-center
                                        mb-3
                                        justify-content-between
                                    "
                                >
                                    <div>
                                        <h4 class="card-title mb-0">
                                            Posted Request for Quotation
                                        </h4>
                                        <p class="card-title-desc mb-0">
                                            List of posted Request for Quotation
                                        </p>
                                    </div>
                                    <div v-if="posted.length > 0">
                                        <div class="d-flex">
                                            <input
                                                autocomplete="off"
                                                type="text"
                                                v-model="filterPostedRFQ"
                                                placeholder="Search RFQ..."
                                                class="form-control"
                                            />
                                            <b-form-select
                                                class="form-select ms-1 w-25"
                                                v-model="perPostedPage"
                                                :options="pageOptions"
                                            ></b-form-select>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="
                                        posted.length == 0 && !filterPostedRFQ
                                    "
                                    class="text-center"
                                >
                                    <h5>No data available</h5>
                                </div>
                                <div
                                    v-if="
                                        filteredPostedRFQ.length == 0 &&
                                        filterPostedRFQ
                                    "
                                    class="text-center"
                                >
                                    <h5>Search not found</h5>
                                </div>
                                <template v-if="posted.length > 0">
                                    <div
                                        role="tablist"
                                        v-for="x in filteredPostedRFQ"
                                        :key="x.id"
                                    >
                                        <b-card
                                            no-body
                                            class="mb-1 shadow-none"
                                        >
                                            <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" placement="left"/>
                                            <b-card-header
                                                header-tag="header"
                                                role="tab"
                                                header-class="cursor-pointer"
                                                @click="getPostedDetails(x)"
                                            >
                                                <div
                                                    class="
                                                        d-flex
                                                        justify-content-between
                                                        align-items-center
                                                    "
                                                >
                                                    <h6 class="m-0">
                                                        <a class="text-dark" href="javascript: void(0);">
                                                            &nbsp;
                                                            <span class="text-warning">[{{ x.rfqNumber}}]</span>
                                                            <span>[{{x.prNumber}}]</span>
                                                            :&nbsp;
                                                            {{ x.description }}
                                                            <span v-if="x.publicPostedRfqs.length > 0" class="ms-1">
                                                                <img src="@/assets/images/verified-icon.png" alt="verified" style="height:18px;">
                                                            </span>
                                                        </a>
                                                    </h6>
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                        "
                                                    >
                                                        <div>
                                                            <span
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                "
                                                                ><small
                                                                    v-if="
                                                                        !x.visible
                                                                    "
                                                                    >Click here
                                                                    to
                                                                    expand</small
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-chevron-right
                                                                        rotate
                                                                        font-size-18
                                                                        ms-3
                                                                    "
                                                                    :class="{
                                                                        'rotate-90':
                                                                            x.visible,
                                                                    }"
                                                                ></i
                                                            ></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-card-header>
                                            <b-collapse
                                                :visible="x.visible"
                                                :accordion="`posted-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <b-card-body class="border">
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            cursor-pointer
                                                        "
                                                    >
                                                        <h5 class="mb-0">
                                                            Details
                                                        </h5>
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.detailShow,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="x.detailShow"
                                                        :accordion="`rfq-details-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <div v-if="!x.detailsLoaded">
                                                            <LoadingTemplate />
                                                        </div>
                                                        <div v-if="x.detailsLoaded">
                                                            <div>
                                                                <label><i class="bx bx-receipt me-1"></i>Tracking Number:</label>
                                                                <u>{{ x.tracking}}</u>
                                                            </div>
                                                            <div>
                                                                <label class="me-1">
                                                                    <i class="bx bx-link-external me-1"></i>Mode of Procurement:
                                                                </label>
                                                                <u>{{x.mop.text}}</u>
                                                            </div>
                                                            <div>
                                                                <label class="me-1">
                                                                    <i class="bx bx-package me-1"></i>Delivery Period:
                                                                </label>
                                                                <u>{{x.deliveryPeriod}} day/s</u>
                                                            </div>
                                                            <div class="mb-2">
                                                                <label class="me-1">
                                                                    <i class="bx bx-calendar-event me-1"></i>Deadline:
                                                                </label>
                                                                <u>{{formatDate(new Date(x.deadline))}}</u>
                                                            </div>
                                                        </div>
                                                    </b-collapse>
                                                    <hr />
                                                    <div
                                                        class="d-flex align-items-center justify-content-between cursor-pointer"
                                                        @click="showRfqItems(x)"
                                                    >
                                                        <h5 class="mb-0">Bids/RFQ Items</h5>
                                                        <h5 class="mb-0">
                                                            <i class="bx bx-chevron-right rotate" :class="{'rotate-90': x.itemVisible}"></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="x.itemVisible"
                                                        :accordion="`rfq-item-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <div class="justify-content-between mb-2 d-flex">
                                                            <div class="d-flex align-center">
                                                                <div
                                                                    class="
                                                                        form-check
                                                                        form-checkbox-outline
                                                                        form-check-success
                                                                        me-2
                                                                    "
                                                                    v-if="x.selectItems"
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        :id="`select-rfq-items-${x.id}`"
                                                                        class="form-check-input"
                                                                        v-model="x.selectAll"
                                                                        @change="selectAllItems(x)"
                                                                    />
                                                                </div>
                                                                <div v-if="countItemSelected(x, 'recanvas') != 0 && $store.state.decrypt.isAdmin()" class="d-flex align-items-center">
                                                                    <button class="btn btn-sm btn-outline-danger" @click="removeSelected(x)"><i class="bx bx-x"></i> Remove Selected</button>
                                                                </div>
                                                                <span style="border-right: 1px solid #ccc;" class="mx-2" v-if="countItemSelected(x, 'recanvas') != 0 && $store.state.decrypt.isAdmin()"></span>
                                                                <div v-if="countItemSelected(x, 'recanvas') != 0" class="d-flex align-items-center">
                                                                    With {{ countItemSelected(x, 'recanvas') }} selected: Recanvass? <button type="button" class="ms-1 btn btn-sm btn-outline-success" @click="recanvasItem(x)"><i class="bx bx-check"></i> Go</button>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex">
                                                                <input type="text" class="form-control form-control-sm me-1" placeholder="Search Item..." style="width:180px;" v-model="x.searchItem"/>
                                                                <button class="btn btn-sm btn-outline-success" v-if="!x.selectItems" @click="x.selectItems = true"><i class="bx bx-check"></i> Select Item</button>
                                                                <button class="btn btn-sm btn-outline-warning" v-if="x.selectItems" @click="cancelSelectionOfItems(x)"><i class="bx bx-x"></i> Cancel</button>
                                                            </div>
                                                        </div>
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr class="custom-border-2">
                                                                    <th>
                                                                        Item Name
                                                                        <div><small>Item Description</small></div>
                                                                    </th>
                                                                    <th style="width: 120px;">Unit</th>
                                                                    <th style="width: 70px;">Qty</th>
                                                                    <th style="width: 150px;">Unit Cost</th>
                                                                    <th style="width: 150px;">Total</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template v-if="!x.rfqItemLoading && x.rfqItems.length > 0">
                                                                    <tr
                                                                        v-for="(z, zIndex) in filteredRfqItems(x)"
                                                                        :key="`poffer-${z.id}`"
                                                                    >
                                                                        <td>
                                                                            <div
                                                                                v-if="x.selectItems"
                                                                                class="
                                                                                    form-check
                                                                                    form-checkbox-outline
                                                                                    form-check-success
                                                                                "
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    :id="`select-rfq-items-${z.id}`"
                                                                                    class="form-check-input"
                                                                                    v-model="z.selected"
                                                                                    @change="selectRfqItem(x)"
                                                                                />
                                                                                <label
                                                                                    :for="`select-rfq-items-${z.id}`"
                                                                                    class="form-check-label"
                                                                                >
                                                                                    {{ z.itemName}}
                                                                                    <div>
                                                                                        <small>
                                                                                            {{ z.description }}
                                                                                        </small>
                                                                                    </div>
                                                                                </label>
                                                                            </div>
                                                                            <div class="d-flex align-items-center" v-else>
                                                                                <div style="min-width:20px;height:20px;" class="bg-success bg-gradient text-white d-flex align-items-center justify-content-center me-1">{{zIndex + 1}}</div>
                                                                                <div>
                                                                                    {{ z.itemName}}
                                                                                    <div>
                                                                                        <small>
                                                                                            {{ z.description }}
                                                                                        </small>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>{{ z.unit.shortName}}</td>
                                                                        <td>{{ z.quantity }}</td>
                                                                        <td>{{ formatCurrency(z.unitCost)}}</td>
                                                                        <td>
                                                                            {{ formatCurrency(z.total)}}<a href="javascript:void(0);" class="text-danger" v-if="$store.state.decrypt.isAdmin()" @click="removeItem(z, 'posted')"><i class="bx bx-trash"></i></a>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                                <tr v-if="x.rfqItemLoading">
                                                                    <td colspan="100%">
                                                                        <LoadingTemplate />
                                                                    </td>
                                                                </tr>
                                                                <tr v-if="!x.rfqItemLoading && x.rfqItems.length == 0">
                                                                    <td colspan="100%" class="text-center">
                                                                        <i>No offer yet</i>
                                                                    </td>
                                                                </tr>
                                                                <tr 
                                                                    class="border border-dashed"
                                                                    v-if="x.rfqItems.length > 0"
                                                                >
                                                                    <td 
                                                                        colspan="4"
                                                                        class="text-right py-2 px-2"
                                                                    >
                                                                        Total RFQ Amount:
                                                                    </td>
                                                                    <td
                                                                        colspan="2"
                                                                        class="py-2"
                                                                    >
                                                                        {{ formatCurrency(getTotalPerPR(x.rfqItems)) }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </b-collapse>
                                                    <hr />
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            cursor-pointer
                                                        "
                                                        @click="
                                                            getRFQBacMembers(x)
                                                        "
                                                    >
                                                        <h5 class="mb-0 text-primary">
                                                            BAC Members
                                                        </h5>
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.showBACMember,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="x.showBACMember"
                                                        :accordion="`rfq-bac-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <BACMembers
                                                            :data="x"
                                                            :posted="true"
                                                            viewFrom="rfq"
                                                        />
                                                    </b-collapse>
                                                    <hr />
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            cursor-pointer
                                                        "
                                                        @click="
                                                            showRfqSupplier(x)
                                                        "
                                                    >
                                                        <h5 class="mb-0">
                                                            Suppliers &amp; Offers
                                                        </h5>
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.supplierShow,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="
                                                            x.supplierShow
                                                        "
                                                        :accordion="`supplier-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <div
                                                            class="
                                                                d-flex
                                                                justify-content-center
                                                                align-items-center
                                                                my-2
                                                            "
                                                            v-if="x.itemLoading "
                                                        >
                                                            <LoadingTemplate />
                                                        </div>
                                                        <template v-else>
                                                            <b-card 
                                                                no-body 
                                                                class="mb-1 shadow-none"
                                                                v-for="(y, index) in x.rfqSuppliers"
                                                                :key="y.id"
                                                            >
                                                                <RawData 
                                                                    :data="y" 
                                                                    v-if="$store.state.decrypt.isAdmin()" 
                                                                    placement="left"
                                                                    :keyId="`supplier-offer-${x.id}${y.id}`"
                                                                />
                                                                <b-card-header
                                                                    header-tag="header"
                                                                    role="tab"
                                                                    class="border"
                                                                    :class="{'border-success': y.isWinner}"
                                                                >
                                                                    <div class="d-flex justify-content-between align-items-center">
                                                                        <div class="d-flex align-items-center">
                                                                            <div 
                                                                                style="min-width: 30px;"
                                                                                class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                                                            >
                                                                                <h3 class="mb-0 position-relative">
                                                                                    {{ index + 1 }}
                                                                                    <i 
                                                                                        class="bx bx-crown position-absolute winner-crown font-size-14"
                                                                                        v-if="y.isWinner"
                                                                                    ></i>
                                                                                </h3>
                                                                            </div>
                                                                            <div class="text-muted">
                                                                                <div class="d-flex align-items-center">
                                                                                    <h5 class="mb-0 me-1">{{ y.supplier.name }}</h5>
                                                                                    <small v-if="y.isReAward" class="bg-warning text-white rounded px-1">Re-Awarded</small>
                                                                                </div>
                                                                                <div style="line-height: 0.8;">
                                                                                    <small>{{ y.supplier.address }}</small>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex align-items-center">
                                                                            <span v-if="y.isWinner" class="me-5">Winner</span>
                                                                            <a
                                                                                href="javascript: void(0);"
                                                                                class="text-success d-flex align-items-center"
                                                                                @click="y.visible = !y.visible"
                                                                            >
                                                                                {{ y.visible ? "Hide": "Show" }} Offer
                                                                                <i 
                                                                                    class="bx bx-chevron-right rotate font-size-14"
                                                                                    :class="{ 'rotate-90': y.visible }"
                                                                                ></i>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </b-card-header>
                                                                <b-collapse
                                                                    :visible="
                                                                        y.visible
                                                                    "
                                                                    :accordion="`posted-supplier-${y.id}`"
                                                                    role="tabpanel"
                                                                >
                                                                    <table class="table table-bordered">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>
                                                                                    <div class="d-flex align-items-center">
                                                                                        <div>
                                                                                            <div>
                                                                                                Item Name
                                                                                            </div>
                                                                                            <small class="me-2">Item Description</small>
                                                                                        </div>
                                                                                        <button
                                                                                            type="button"
                                                                                            class="btn btn-sm btn-success"
                                                                                            @click="addAllToItemList(y.supplierRFQ)"
                                                                                            v-if="y.isWinner"
                                                                                        >
                                                                                            <i class="bx bx-bookmark-plus"></i> Add all items to item list
                                                                                        </button>
                                                                                        <!-- <button
                                                                                            type="button"
                                                                                            class="btn btn-sm btn-outline-success"
                                                                                            @click="addAllToItemList(y.supplierRFQ)"
                                                                                            v-if="y.isReAward"
                                                                                        >
                                                                                            <i class="bx bx-edit"></i> Update Offers
                                                                                        </button> -->
                                                                                    </div>
                                                                                </th>
                                                                                <th style="width: 120px;">Unit</th>
                                                                                <th style="width: 70px;">Qty</th>
                                                                                <th style="width: 150px;">Unit Cost</th>
                                                                                <th style="width: 150px;">Total</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr
                                                                                v-for="z in filteredSupplierOffer(y.supplierRFQ, y.isReAward)"
                                                                                :key="`poffer-${z.id}`"
                                                                                :class="{'custom-border-2 border-success': z.offer.isWinner}"
                                                                            >
                                                                                <td class="position-relative">
                                                                                    <RawData 
                                                                                        :data="z" 
                                                                                        v-if="$store.state.decrypt.isAdmin()" 
                                                                                        placement="left"
                                                                                        :keyId="`raw-data-${x.id}-${y.id}-${z.id}`"
                                                                                    />
                                                                                    {{
                                                                                        z.offer.itemName
                                                                                    }}
                                                                                    <div><small>{{z.offer.description}}</small></div>
                                                                                    <div class="d-flex align-items-center gap-2">
                                                                                        <a
                                                                                            href="javascript:void(0);"
                                                                                            :id="`moreSpecView${z.offer.id}`"
                                                                                            ><i
                                                                                                class="
                                                                                                    mdi mdi-triangle
                                                                                                    rotate rotate-90
                                                                                                    me-1
                                                                                                "
                                                                                            ></i
                                                                                            >More Specifications</a
                                                                                        >
                                                                                        <b-popover
                                                                                            :target="`moreSpecView${z.offer.id}`"
                                                                                            triggers="click"
                                                                                            placement="right"
                                                                                            :show.sync="z.offer.showMoreSpec"
                                                                                            custom-class="popover-supplier"
                                                                                        >
                                                                                            <template v-slot:title>
                                                                                                <div
                                                                                                    class="
                                                                                                        d-flex
                                                                                                        align-items-center
                                                                                                        justify-content-between
                                                                                                    "
                                                                                                >
                                                                                                    <small
                                                                                                        >More Specifications</small
                                                                                                    >
                                                                                                    <span
                                                                                                        class="
                                                                                                            bx bx-x
                                                                                                            font-size-14
                                                                                                            cursor-pointer
                                                                                                        "
                                                                                                        @click="
                                                                                                            z.offer.showMoreSpec = false
                                                                                                        "
                                                                                                    ></span>
                                                                                                </div>
                                                                                            </template>
                                                                                            <div class="row mb-2">
                                                                                                <div class="col-md-6">
                                                                                                    <label class="mb-0"
                                                                                                        >Brand</label
                                                                                                    >
                                                                                                    <div
                                                                                                        type="text"
                                                                                                        placeholder="Enter Brand"
                                                                                                        class="
                                                                                                            form-control
                                                                                                            form-control-sm
                                                                                                        "
                                                                                                    >
                                                                                                        {{z.offer.brand}}
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-6">
                                                                                                    <label class="mb-0"
                                                                                                        >Model</label
                                                                                                    >
                                                                                                    <div
                                                                                                        class="
                                                                                                            form-control
                                                                                                            form-control-sm
                                                                                                        "
                                                                                                        
                                                                                                    >
                                                                                                        {{z.offer.model}}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="row mb-2">
                                                                                                <div class="col-md-6">
                                                                                                    <label class="mb-0"
                                                                                                        >Color</label
                                                                                                    >
                                                                                                    <div
                                                                                                        class="
                                                                                                            form-control
                                                                                                            form-control-sm
                                                                                                        "
                                                                                                    >
                                                                                                        {{z.offer.color}}
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-6">
                                                                                                    <label class="mb-0"
                                                                                                        >Condition</label
                                                                                                    >
                                                                                                    <div
                                                                                                        class="
                                                                                                            form-control
                                                                                                            form-control-sm
                                                                                                        "
                                                                                                    >
                                                                                                        {{z.offer.condition}}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="row mb-2">
                                                                                                <div class="col-md-6">
                                                                                                    <label for="" class="mb-0"
                                                                                                        >Material Used</label
                                                                                                    >
                                                                                                    <div
                                                                                                        class="
                                                                                                            form-control
                                                                                                            form-control-sm
                                                                                                        "
                                                                                                    >
                                                                                                        {{z.offer.materialUsed}}
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-6">
                                                                                                    <label for="" class="mb-0"
                                                                                                        >Package Description</label
                                                                                                    >
                                                                                                    <div
                                                                                                        class="
                                                                                                            form-control
                                                                                                            form-control-sm
                                                                                                        "
                                                                                                    >
                                                                                                        {{z.offer.packageDescription}}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="mb-2">
                                                                                                <label for="" class="mb-0"
                                                                                                    >Dimension Description</label
                                                                                                >
                                                                                                <div
                                                                                                    class="
                                                                                                        form-control form-control-sm
                                                                                                    "
                                                                                                >
                                                                                                    {{z.offer.dimensionDescription}}
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="mb-2">
                                                                                                <label for="" class="mb-0"
                                                                                                    >Other Specifications</label
                                                                                                >
                                                                                                <div
                                                                                                    class="
                                                                                                        form-control form-control-sm
                                                                                                    "
                                                                                                >
                                                                                                    {{z.offer.specification}}
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="mb-2">
                                                                                                <label for="" class="mb-0"
                                                                                                    >Notes</label
                                                                                                >
                                                                                                <div
                                                                                                    class="
                                                                                                        form-control form-control-sm
                                                                                                        text-warning
                                                                                                    "
                                                                                                >
                                                                                                    {{
                                                                                                        z.offer.note
                                                                                                    }}
                                                                                                </div>
                                                                                            </div>
                                                                                        </b-popover>
                                                                                        <button
                                                                                            type="button"
                                                                                            class="btn btn-sm btn-success"
                                                                                            @click="addToItemList(z.offer.id)"
                                                                                            v-if="z.offer.id > 0 && z.offer.itemName.trim() != ''"
                                                                                        >
                                                                                            <i class="bx bx-bookmark-plus"></i> Add this to item list
                                                                                        </button>
                                                                                    </div>
                                                                                </td>
                                                                                <template v-if="z.offer.noOffer">
                                                                                    <td colspan="4" class="text-center align-middle text-warning">
                                                                                        Supplier no offer
                                                                                    </td>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <td>{{ z.offer.unit.shortName }}</td>
                                                                                    <td>{{ z.offer.quantity }}</td>
                                                                                    <td>{{ formatCurrency(z.offer.unitCost) }}</td>
                                                                                    <td>{{ formatCurrency(parseFloat(z.offer.unitCost) * parseFloat(z.offer.quantity)) }}
                                                                                        <div class="mt-2" v-if="z.offer.isWinner">
                                                                                            <small class="badge"><i class="bx bx-crown"></i>Winner</small>
                                                                                        </div>
                                                                                    </td>
                                                                                </template>
                                                                            </tr>
                                                                            <tr v-if="y.rfqSupplierOffers.length == 0">
                                                                                <td colspan="5" class="text-center">
                                                                                    <i>No offer yet</i>
                                                                                </td>
                                                                            </tr>
                                                                            <tr class="border border-dashed">
                                                                                <td class="py-2" colspan="3">
                                                                                    <div>
                                                                                        <button type="button" class="btn btn-link" @click="addAttachment(y.offer, false)">
                                                                                            <i class="mdi mdi-paperclip"></i> Attachments
                                                                                        </button>
                                                                                    </div>
                                                                                </td>
                                                                                <td class="text-right py-2 px-2">
                                                                                    Total Offer Amount:
                                                                                </td>
                                                                                <td colspan="2" class="py-2">
                                                                                    {{ formatCurrency(getTotalOffer(y.rfqSupplierOffers, "posted")) }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </b-collapse>
                                                            </b-card>
                                                        </template>
                                                    </b-collapse>
                                                    <hr />
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            cursor-pointer
                                                        "
                                                        @click="
                                                            getAttachments(x)
                                                        "
                                                    >
                                                        <h5 class="mb-0 text-warning">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-paperclip
                                                                    rotate
                                                                    rotate-90
                                                                "
                                                            ></i>
                                                            Attachments
                                                        </h5>
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.attachmentVisible,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="
                                                            x.attachmentVisible
                                                        "
                                                        :accordion="`posted-attachment-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <div
                                                            class="
                                                                d-flex
                                                                align-items-center
                                                                justify-content-between
                                                                mb-3
                                                            "
                                                        >
                                                            <div class="d-flex">
                                                                <p
                                                                    class="mb-0"
                                                                    v-if="!x.attachmentLoading &&
                                                                        x
                                                                            .rfqFiles
                                                                            .length ==
                                                                        0
                                                                    "
                                                                >
                                                                    <i
                                                                        >No
                                                                        documents
                                                                        found</i
                                                                    >
                                                                </p>
                                                                <p
                                                                    class="mb-0"
                                                                    v-if="
                                                                        x.attachmentLoading
                                                                    "
                                                                >
                                                                    <i class="font-size-15">Loading...</i
                                                                    >
                                                                </p>
                                                                <input
                                                                    v-if="!x.attachmentLoading &&
                                                                        x
                                                                            .rfqFiles
                                                                            .length >
                                                                        0
                                                                    "
                                                                    type="search"
                                                                    class="
                                                                        form-control
                                                                    "
                                                                    v-model="
                                                                        x.fileSearch
                                                                    "
                                                                    @input="
                                                                        searchDocu(
                                                                            x
                                                                        )
                                                                    "
                                                                    placeholder="Search Documents..."
                                                                />
                                                            </div>
                                                            <div class="">
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    class="
                                                                        text-primary
                                                                        border-primary
                                                                        border
                                                                        p-2
                                                                    "
                                                                    :id="`posted-document${x.id}`"
                                                                    @click="
                                                                        x.addDocu = true
                                                                    "
                                                                    ><i
                                                                        class="
                                                                            bx
                                                                            bx-plus
                                                                        "
                                                                    ></i
                                                                    >Upload
                                                                    Documents</a
                                                                >
                                                                <upload-popover
                                                                    :option="
                                                                        uploadOptions
                                                                    "
                                                                    :sourceId="
                                                                        x.id
                                                                    "
                                                                    @uploaded="
                                                                        uploadedPosted(
                                                                            $event,
                                                                            x.id
                                                                        )
                                                                    "
                                                                    :showPV="
                                                                        x.addDocu
                                                                    "
                                                                    @closePopover="
                                                                        x.addDocu = false
                                                                    "
                                                                    :dzId="`dropzone-posted${x.id}`"
                                                                    :pvId="`posted-document${x.id}`"
                                                                ></upload-popover>
                                                            </div>
                                                        </div>
                                                        <div class="mt-2">
                                                            <b-row>
                                                                <b-col
                                                                    sm="3"
                                                                    v-for="(
                                                                        y, index
                                                                    ) in searchDocu(
                                                                        x
                                                                    )"
                                                                    :key="y.id"
                                                                    class="mb-2"
                                                                >
                                                                    <div
                                                                        class="
                                                                            position-relative
                                                                            cursor-pointer
                                                                        "
                                                                        :style="`z-index: ${
                                                                            searchDocu(
                                                                                x
                                                                            )
                                                                                .length -
                                                                            index
                                                                        }`"
                                                                    >
                                                                        <div
                                                                            class="
                                                                                border
                                                                                p-3
                                                                            "
                                                                        >
                                                                            <div>
                                                                                <div
                                                                                    class="
                                                                                        float-end
                                                                                        ms-2
                                                                                    "
                                                                                >
                                                                                    <b-dropdown
                                                                                        id="dropdown-dropleft"
                                                                                        right
                                                                                        variant="link"
                                                                                        toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                                        menu-class="dropdown-menu-end"
                                                                                        no-caret
                                                                                    >
                                                                                        <template
                                                                                            #button-content
                                                                                        >
                                                                                            <i
                                                                                                class="
                                                                                                    mdi
                                                                                                    mdi-dots-horizontal
                                                                                                "
                                                                                            ></i>
                                                                                        </template>
                                                                                        <b-dropdown-item
                                                                                            @click="
                                                                                                openDocument(
                                                                                                    y
                                                                                                )
                                                                                            "
                                                                                            ><i
                                                                                                class="
                                                                                                    bx
                                                                                                    bx-link-external
                                                                                                    me-1
                                                                                                "
                                                                                            ></i
                                                                                            >Open</b-dropdown-item
                                                                                        >
                                                                                        <b-dropdown-item
                                                                                            variant="danger"
                                                                                            @click="
                                                                                                removeFile(
                                                                                                    y.id,
                                                                                                    x.id,
                                                                                                    'posted'
                                                                                                )
                                                                                            "
                                                                                            ><i
                                                                                                class="
                                                                                                    bx
                                                                                                    bx-trash
                                                                                                    me-1
                                                                                                "
                                                                                            ></i
                                                                                            >Remove</b-dropdown-item
                                                                                        >
                                                                                    </b-dropdown>
                                                                                </div>
                                                                                <div
                                                                                    class="
                                                                                        avatar-xs
                                                                                        me-3
                                                                                        mb-2
                                                                                    "
                                                                                    @click="
                                                                                        openDocument(
                                                                                            y
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="
                                                                                            avatar-title
                                                                                            bg-transparent
                                                                                            rounded
                                                                                        "
                                                                                    >
                                                                                        <i
                                                                                            v-if="
                                                                                                y.fileType.includes(
                                                                                                    'image'
                                                                                                )
                                                                                            "
                                                                                            class="
                                                                                                mdi
                                                                                                mdi-image
                                                                                                font-size-24
                                                                                                text-purple
                                                                                            "
                                                                                        ></i>
                                                                                        <i
                                                                                            v-if="
                                                                                                y.fileType.includes(
                                                                                                    'application'
                                                                                                )
                                                                                            "
                                                                                            class="
                                                                                                mdi
                                                                                                mdi-file-pdf-outline
                                                                                                font-size-24
                                                                                                text-danger
                                                                                            "
                                                                                        ></i>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    class="
                                                                                        d-flex
                                                                                    "
                                                                                    @click="
                                                                                        openDocument(
                                                                                            y
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="
                                                                                            overflow-hidden
                                                                                            me-auto
                                                                                        "
                                                                                    >
                                                                                        <h5
                                                                                            class="
                                                                                                font-size-14
                                                                                                text-truncate
                                                                                                mb-1
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                y.description
                                                                                            }}
                                                                                        </h5>
                                                                                        <p
                                                                                            class="
                                                                                                text-muted
                                                                                                mb-0
                                                                                            "
                                                                                        >
                                                                                            {{
                                                                                                formatDateWithTime(
                                                                                                    new Date(
                                                                                                        y.dateTimeUploaded
                                                                                                    )
                                                                                                )
                                                                                            }}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row
                                                                v-if="
                                                                    searchDocu(
                                                                        x
                                                                    ).length ==
                                                                        0 &&
                                                                    x.fileSearch
                                                                "
                                                            >
                                                                <b-col
                                                                    >Search Not
                                                                    Found</b-col
                                                                >
                                                            </b-row>
                                                        </div>
                                                    </b-collapse>
                                                    <hr />
                                                    <div class="d-flex">
                                                        <button
                                                            type="button"
                                                            class="
                                                                btn btn-warning
                                                                me-1
                                                            "
                                                            @click="
                                                                returnRFQ(x)
                                                            "
                                                        >
                                                            <i
                                                                class="
                                                                    bx bx-reply
                                                                    me-1
                                                                "
                                                            ></i
                                                            >Return RFQ
                                                        </button>
                                                        <button
                                                            type="button"
                                                            class="
                                                                btn btn-purple
                                                                me-1
                                                            "
                                                            @click="
                                                                printAbstract(
                                                                    x.id
                                                                )
                                                            "
                                                        >
                                                            <i
                                                                class="
                                                                    bx
                                                                    bxs-printer
                                                                    me-1
                                                                "
                                                            ></i
                                                            >Print Abstract
                                                        </button>
                                                        <button
                                                            type="button"
                                                            class="
                                                                btn btn-purple
                                                                me-2
                                                            "
                                                            @click="
                                                                printNOA(x.id)
                                                            "
                                                        >
                                                            <i
                                                                class="
                                                                    bx
                                                                    bxs-printer
                                                                    me-1
                                                                "
                                                            ></i
                                                            >Print NOA
                                                        </button>
                                                        <button
                                                            type="button"
                                                            class="btn btn-info"
                                                            :id="`gpo-popover-${x.id}`"
                                                            @click="openPO(x)"
                                                            v-if="!x.poExist"
                                                        >
                                                            <!-- && x.bacApproved -->
                                                            <i
                                                                class="
                                                                    bx
                                                                    bxs-printer
                                                                    me-1
                                                                "
                                                            ></i
                                                            >Generate P.O
                                                        </button>
                                                        <b-popover
                                                            :target="`gpo-popover-${x.id}`"
                                                            triggers="click"
                                                            placement="righttop"
                                                            custom-class="popover-supplier"
                                                            :show.sync="x.generatePO"
                                                            v-if="!x.poExist"
                                                        >
                                                            <!-- && x.bacApproved -->
                                                            <template
                                                                v-slot:title
                                                            >
                                                                <div class="d-flex align-items-center justify-content-between">
                                                                    <small>Generate P.O</small>
                                                                    <span 
                                                                        class="bx bx-x font-size-14 cursor-pointer"
                                                                        @click="x.generatePO = false"
                                                                    ></span>
                                                                </div>
                                                            </template>
                                                            <div class="position-relative">
                                                                <div class="position-absolute d-flex align-items-center justify-content-center loading-po" v-if="x.loadingPoNumber">
                                                                    <div
                                                                        class="
                                                                            spinner-border
                                                                            text-primary
                                                                            spinner-border-sm
                                                                        "
                                                                        role="status"
                                                                    >
                                                                        <span class="visually-hidden">
                                                                            Loading...
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="mb-2">
                                                                    <label>P.O Description</label>
                                                                    <textarea
                                                                        v-model="
                                                                            po.description
                                                                        "
                                                                        placeholder="Enter P.O Description"
                                                                        rows="5"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        :class="{
                                                                            'is-invalid':
                                                                                submitted &&
                                                                                $v.po
                                                                                    .description
                                                                                    .$error,
                                                                        }"
                                                                    ></textarea>
                                                                    <div
                                                                        v-if="
                                                                            submitted &&
                                                                            $v.po
                                                                                .description
                                                                                .$error
                                                                        "
                                                                        class="
                                                                            invalid-feedback
                                                                        "
                                                                    >
                                                                        <span
                                                                            v-if="
                                                                                !$v.po
                                                                                    .description
                                                                                    .required
                                                                            "
                                                                            >This value
                                                                            is
                                                                            required.</span
                                                                        >
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <label>P.O Number</label>
                                                                    <input
                                                                        v-model="
                                                                            po.poNumber
                                                                        "
                                                                        placeholder="Enter P.O Number"
                                                                        rows="5"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        :class="{
                                                                            'is-invalid':
                                                                                submitted &&
                                                                                $v.po
                                                                                    .poNumber
                                                                                    .$error,
                                                                        }"
                                                                    />
                                                                    <div
                                                                        v-if="
                                                                            submitted &&
                                                                            $v.po
                                                                                .poNumber
                                                                                .$error
                                                                        "
                                                                        class="
                                                                            invalid-feedback
                                                                        "
                                                                    >
                                                                        <span
                                                                            v-if="
                                                                                !$v.po
                                                                                    .poNumber
                                                                                    .required
                                                                            "
                                                                            >This value
                                                                            is
                                                                            required.</span
                                                                        >
                                                                    </div>
                                                                </div>
                                                                <hr />
                                                                <div
                                                                    class="
                                                                        text-right
                                                                    "
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        class="
                                                                            btn
                                                                            btn-info
                                                                            btn-sm
                                                                            me-1
                                                                        "
                                                                        @click="
                                                                            generatePO(
                                                                                x
                                                                            )
                                                                        "
                                                                    >
                                                                        <i
                                                                            class="
                                                                                bx
                                                                                bx-save
                                                                                me-1
                                                                            "
                                                                        ></i
                                                                        >Generate
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        class="
                                                                            btn
                                                                            btn-sm
                                                                        "
                                                                        @click="
                                                                            x.generatePO = false
                                                                        "
                                                                    >
                                                                        <i
                                                                            class="
                                                                                bx
                                                                                bx-x
                                                                                me-1
                                                                            "
                                                                        ></i
                                                                        >Cancel
                                                                    </button>
                                                                </div>
                                                                <div
                                                                    v-if="
                                                                        x.generatingPO
                                                                    "
                                                                >
                                                                    <p
                                                                        class="mb-0"
                                                                        :class="{
                                                                            'text-success':
                                                                                x.itemMsgType ===
                                                                                'success',
                                                                            'text-danger':
                                                                                x.itemMsgType ===
                                                                                'danger',
                                                                        }"
                                                                    >
                                                                        {{
                                                                            x.itemMessage
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </b-popover>
                                                    </div>
                                                </b-card-body>
                                            </b-collapse>
                                        </b-card>
                                    </div>
                                    <div class="mt-3">
                                        <div
                                            class="
                                                dataTables_paginate
                                                paging_simple_numbers
                                                float-end
                                            "
                                        >
                                            <ul class="pagination pagination-rounded mb-0">
                                                <b-pagination
                                                    v-model="currentPostedPage"
                                                    :total-rows="postedRows"
                                                    :per-page="perPostedPage"
                                                ></b-pagination>
                                            </ul>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title-item-class="mb-2">
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="bx bx-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block">
                                Waved Items (<template v-if="!wavedBusy">{{ waved.length }}</template>
                                    <template v-if="wavedBusy">
                                        <b-spinner type="grow" class="wh-10p" variant="success" role="status"></b-spinner>
                                    </template>)
                            </span>
                        </template>
                        <WavedItems 
                            :busy="wavedBusy" 
                            :items="waved" 
                            @reawardItem="reawardItem" 
                            @refreshRecanvas="getRecanvases($store.state.data.cycle, $store.state.data.selectedCampus.id)"
                            @reaward-rfq="reawardRfq"
                        />
                    </b-tab>
                </b-tabs>
            </b-tab>
            <b-tab @click="getPublicPosts">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Publicly Posted RFQ</span
                    >
                </template>
                <b-tabs
                    pills
                    vertical
                    nav-class="p-0"
                    nav-wrapper-class="col-sm-2"
                    content-class="pt-0 px-2 text-muted"
                >
                    <b-tab title-item-class="mb-2">
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="bx bx-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block"
                                >Active (<template v-if="!activeBusy">{{
                                    activePosts.length
                                }}</template
                                ><template v-if="activeBusy"
                                    ><b-spinner
                                        type="grow"
                                        class="wh-10p"
                                        variant="success"
                                        role="status"
                                    ></b-spinner></template
                                >)</span
                            >
                        </template>
                        <div class="card">
                            <div class="card-body bg-info bg-soft">
                                <div
                                    class="
                                        d-flex
                                        justify-content-between
                                        align-items-center
                                        mb-3
                                    "
                                >
                                    <div>
                                        <h4 class="card-title mb-0">
                                            Active Public Posts Bids/RFQ
                                        </h4>
                                        <p class="card-title-desc mb-0">
                                            List of active Public Posts Bids/RFQ
                                        </p>
                                    </div>
                                    <div v-if="activePosts.length > 0">
                                        <input
                                            autocomplete="off"
                                            type="text"
                                            v-model="filterActive"
                                            placeholder="Search RFQ..."
                                            class="form-control"
                                        />
                                    </div>
                                </div>
                                <div
                                    v-if="activePosts.length == 0"
                                    class="text-center"
                                >
                                    <h5>No data available</h5>
                                </div>
                                <div
                                    v-if="
                                        filterActive &&
                                        filteredActivePosts.length == 0
                                    "
                                    class="text-center"
                                >
                                    <h5>Search not found</h5>
                                </div>
                                <template v-if="activePosts.length > 0">
                                    <div
                                        role="tablist"
                                        v-for="(x, index) in filteredActivePosts"
                                        :key="x.id"
                                    >
                                        <b-card
                                            no-body
                                            class="mb-1 shadow-none"
                                            :style="{
                                                'z-index': `${filteredActivePosts.length - index}`,
                                            }"
                                        >
                                            <b-card-header
                                                header-tag="header"
                                                role="tab"
                                                header-class="cursor-pointer"
                                                @click="x.visible = !x.visible"
                                            >
                                                <div
                                                    class="
                                                        d-flex
                                                        justify-content-between
                                                        align-items-center
                                                    "
                                                >
                                                    <h6 class="m-0">
                                                        <a
                                                            class="text-dark"
                                                            href="javascript: void(0);"
                                                            >[{{
                                                                x.rfqNumber
                                                            }}]:&nbsp;{{
                                                                x.description
                                                            }}</a
                                                        >
                                                    </h6>
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                        "
                                                    >
                                                        <div>
                                                            <span
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                "
                                                                ><small
                                                                    v-if="
                                                                        !x.visible
                                                                    "
                                                                    >Click here
                                                                    to
                                                                    expand</small
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-chevron-right
                                                                        rotate
                                                                        font-size-18
                                                                        ms-3
                                                                    "
                                                                    :class="{
                                                                        'rotate-90':
                                                                            x.visible,
                                                                    }"
                                                                ></i
                                                            ></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-card-header>
                                            <b-collapse
                                                :visible="x.visible"
                                                :accordion="`active-posts-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <b-card-body class="border">
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                        "
                                                    >
                                                        <div class="d-flex align-items-end">
                                                            <h5 class="mb-0 me-1">
                                                                Bids/RFQ Details
                                                            </h5>
                                                        </div>
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.detailShow,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="x.detailShow"
                                                        :accordion="`public-post-rfq-details-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <div class="row">
                                                            <div class="col-md-6">
                                                                <ul>
                                                                    <li>
                                                                        <div>
                                                                            <label class="me-1">
                                                                                <i class="bx bx-receipt me-1"></i>
                                                                                Tracking Number:
                                                                            </label>
                                                                            <u>{{ x.tracking }}</u>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div>
                                                                            <label class="me-1">
                                                                                <i class="bx bx-calendar-event me-1"></i>
                                                                                Bids Opening Date:
                                                                            </label>
                                                                            <u>{{ formatDate(new Date(x.datePosted)) }}</u>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div>
                                                                            <label class="me-1">
                                                                                <i class="bx bx-calendar-event me-1"></i>
                                                                                Submission Date:
                                                                            </label>
                                                                            <u>{{formatDate(new Date(x.deadline))}}</u>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        Note: {{x.note}}
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div
                                                                class="col-md-6"
                                                            >
                                                                <ul>
                                                                    <li>Date Published : {{formatDate(new Date(x.datePublish))}}</li>
                                                                    <li>Expiry Date : {{formatDate(new Date(x.publicationEnded))}}</li>
                                                                    <li>Type : {{x.type === 'public-bidding' ? 'Public Bidding' : 'Small Value Procurement'}}</li>
                                                                    <li v-if="x.type === 'public-bidding'">Non Refundable Bidder Fee : {{formatCurrency(x.nonRefundableBidderFee)}}</li>
                                                                </ul>
                                                                <a href="javascript:void(0);" class="ms-4 d-flex align-items-center hover-underline" @click="updatePublicPosting(x)"><i class="bx bx-edit me-1"></i> Update Posting Option</a>
                                                            </div>
                                                        </div>
                                                    </b-collapse>
                                                    <hr />
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            cursor-pointer
                                                        "
                                                        @click="
                                                            getPublicPostAttachments(x)
                                                        "
                                                    >
                                                        <h5 class="mb-0 text-info">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-paperclip
                                                                    rotate
                                                                    rotate-90
                                                                "
                                                            ></i>
                                                            Public Posting Attachments
                                                        </h5>
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.postOptionShow,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="
                                                            x.postOptionShow
                                                        "
                                                        :accordion="`public-posting-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <div class="d-flex align-items-center justify-content-between mb-2">
                                                            <input
                                                                type="search"
                                                                class="
                                                                    form-control popover-report
                                                                "
                                                                v-model="
                                                                    x.fileSearch
                                                                "
                                                                @input="
                                                                    searchPost(
                                                                        x
                                                                    )
                                                                "
                                                                placeholder="Search Public Post Attachments..."
                                                            />
                                                            <button type="button" class="btn btn-outline-info" @click="addPublicPost(x)"><i class="bx bx-plus"></i>Add Public Post Attachment</button>
                                                        </div>
                                                        <div class="table-responsive">
                                                            <table class="table table-bordered table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Title</th>
                                                                        <th>Description</th>
                                                                        <th width="250px">Attachment</th>
                                                                        <th width="90px">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-if="!x.postLoading && x.posts.length == 0">
                                                                        <td colspan="4" class="text-center">No data found</td>
                                                                    </tr>
                                                                    <tr v-if="x.postLoading">
                                                                        <td colspan="4" class="text-center">
                                                                            <LoadingTemplate />
                                                                        </td>
                                                                    </tr>
                                                                    <template v-if="!x.postLoading && x.posts.length > 0">
                                                                        <tr v-for="post in x.posts" :key="post.id">
                                                                            <td>{{post.title}}</td>
                                                                            <td>{{post.description}}</td>
                                                                            <td>
                                                                                <div v-if="post.attachments.length > 0">
                                                                                    <div v-for="attachment in post.attachments" :key="attachment.id" class="d-inline-block">
                                                                                        <div class="d-flex hover-toggle align-items-center">
                                                                                            <a href="javascript:void(0);" class="text-normal-color hoverable-link me-1" @click="openDocument(attachment)"><i>{{attachment.description}}</i></a>
                                                                                            <span class="hover-content"><i class="bx bx-trash cursor-pointer text-danger" @click="removePublicPostAttachment(attachment, post)"></i></span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div v-else>
                                                                                    <a href="javascript:void(0);" class="hoverable-link" :id="`attachment-document${post.id}`" @click="post.showAttachment = true">
                                                                                        <i class="bx bx-plus me-1"></i>Add Attachments
                                                                                    </a>
                                                                                    <upload-popover
                                                                                        :option="
                                                                                            publicPostOptions
                                                                                        "
                                                                                        :sourceId="
                                                                                            post.id
                                                                                        "
                                                                                        @uploaded="
                                                                                            uploadedPublicPostAttachment(
                                                                                                $event,
                                                                                                post
                                                                                            )
                                                                                        "
                                                                                        :showPV="
                                                                                            post.showAttachment
                                                                                        "
                                                                                        @closePopover="
                                                                                            closePublicPostAttachment(post)
                                                                                        "
                                                                                        :dzId="`dropzone-attachment${post.id}`"
                                                                                        :pvId="`attachment-document${post.id}`"
                                                                                    ></upload-popover>
                                                                                </div>
                                                                            </td>
                                                                            <td class="text-center">
                                                                                <a href="javascript:void(0);" class="text-success font-size-16 me-2" title="Update" @click="updatePublicAttachment(post, x)"><i class="bx bx-edit"></i></a>
                                                                                <a href="javascript:void(0);" class="text-danger font-size-16" title="Delete" @click="deletePublicAttachment(post, x)"><i class="bx bx-trash"></i></a>
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </b-collapse>
                                                    <hr />
                                                    <button type="button" class="btn btn-warning d-flex align-items-center" @click="unPostToPublic(x, true)"><i class="bx bx-x me-1 font-size-18"></i>UnPost from Public</button>
                                                </b-card-body>
                                            </b-collapse>
                                        </b-card>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title-item-class="mb-2">
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="bx bx-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block"
                                >Expired (<template v-if="!expiredBusy">{{
                                    expiredPosts.length
                                }}</template
                                ><template v-if="expiredBusy"
                                    ><b-spinner
                                        type="grow"
                                        class="wh-10p"
                                        variant="success"
                                        role="status"
                                    ></b-spinner></template
                                >)</span
                            >
                        </template>
                        <div class="card">
                            <div class="card-body bg-warning bg-soft">
                                <div
                                    class="
                                        d-flex
                                        justify-content-between
                                        align-items-center
                                        mb-3
                                    "
                                >
                                    <div>
                                        <h4 class="card-title mb-0">
                                            Expired Public Posts Bids/RFQ
                                        </h4>
                                        <p class="card-title-desc mb-0">
                                            List of expired Public Posts Bids/RFQ
                                        </p>
                                    </div>
                                    <div v-if="expiredPosts.length > 0">
                                        <input
                                            autocomplete="off"
                                            type="text"
                                            v-model="filterExpired"
                                            placeholder="Search RFQ..."
                                            class="form-control"
                                        />
                                    </div>
                                </div>
                                <div
                                    v-if="expiredPosts.length == 0"
                                    class="text-center"
                                >
                                    <h5>No data available</h5>
                                </div>
                                <div
                                    v-if="
                                        filterExpired &&
                                        filteredExpiredPosts.length == 0
                                    "
                                    class="text-center"
                                >
                                    <h5>Search not found</h5>
                                </div>
                                <template v-if="expiredPosts.length > 0">
                                    <div
                                        role="tablist"
                                        v-for="(x, index) in filteredExpiredPosts"
                                        :key="x.id"
                                    >
                                        <b-card
                                            no-body
                                            class="mb-1 shadow-none"
                                            :style="{
                                                'z-index': `${filteredExpiredPosts.length - index}`,
                                            }"
                                        >
                                            <b-card-header
                                                header-tag="header"
                                                role="tab"
                                                header-class="cursor-pointer"
                                                @click="x.visible = !x.visible"
                                            >
                                                <div
                                                    class="
                                                        d-flex
                                                        justify-content-between
                                                        align-items-center
                                                    "
                                                >
                                                    <h6 class="m-0">
                                                        <a
                                                            class="text-dark"
                                                            href="javascript: void(0);"
                                                            >[{{
                                                                x.rfqNumber
                                                            }}]:&nbsp;{{
                                                                x.description
                                                            }}</a
                                                        >
                                                    </h6>
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                        "
                                                    >
                                                        <div>
                                                            <span
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                "
                                                                ><small
                                                                    v-if="
                                                                        !x.visible
                                                                    "
                                                                    >Click here
                                                                    to
                                                                    expand</small
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-chevron-right
                                                                        rotate
                                                                        font-size-18
                                                                        ms-3
                                                                    "
                                                                    :class="{
                                                                        'rotate-90':
                                                                            x.visible,
                                                                    }"
                                                                ></i
                                                            ></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-card-header>
                                            <b-collapse
                                                :visible="x.visible"
                                                :accordion="`active-posts-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <b-card-body class="border">
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                        "
                                                    >
                                                        <div class="d-flex align-items-end">
                                                            <h5 class="mb-0 me-1">
                                                                Bids/RFQ Details
                                                            </h5>
                                                        </div>
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.detailShow,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="x.detailShow"
                                                        :accordion="`public-post-rfq-details-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <div class="row">
                                                            <div
                                                                class="col-md-6"
                                                            >
                                                            <ul>
                                                                <li>
                                                                    <div>
                                                                        <label class="me-1">
                                                                            <i class="bx bx-receipt me-1"></i>
                                                                            Tracking Number:
                                                                        </label>
                                                                        <u>{{ x.tracking }}</u>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div>
                                                                        <label class="me-1">
                                                                            <i class="bx bx-calendar-event me-1"></i>
                                                                            Bids Opening Date:
                                                                        </label>
                                                                        <u>{{ formatDate(new Date(x.datePosted)) }}</u>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div>
                                                                        <label
                                                                            class="
                                                                                me-1
                                                                            "
                                                                            ><i
                                                                                class="
                                                                                    bx
                                                                                    bx-calendar-event
                                                                                    me-1
                                                                                "
                                                                            ></i
                                                                            >Bids/RFQ
                                                                            Deadline:</label
                                                                        >
                                                                        <u>{{
                                                                            formatDate(
                                                                                new Date(
                                                                                    x.deadline
                                                                                )
                                                                            )
                                                                        }}</u>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    Note: {{x.note}}
                                                                </li>
                                                            </ul>
                                                            </div>
                                                            <div
                                                                class="col-md-6"
                                                            >
                                                                <ul>
                                                                    <li>Date Published : {{formatDate(new Date(x.datePublish))}}</li>
                                                                    <li>Expiry Date : {{formatDate(new Date(x.publicationEnded))}}</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </b-collapse>
                                                    <hr />
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                            justify-content-between
                                                            cursor-pointer
                                                        "
                                                        @click="
                                                            getPublicPostAttachments(x)
                                                        "
                                                    >
                                                        <h5 class="mb-0 text-info">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-paperclip
                                                                    rotate
                                                                    rotate-90
                                                                "
                                                            ></i>
                                                            Public Posting Attachments
                                                        </h5>
                                                        <h5 class="mb-0">
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-chevron-right
                                                                    rotate
                                                                "
                                                                :class="{
                                                                    'rotate-90':
                                                                        x.postOptionShow,
                                                                }"
                                                            ></i>
                                                        </h5>
                                                    </div>
                                                    <b-collapse
                                                        :visible="
                                                            x.postOptionShow
                                                        "
                                                        :accordion="`public-posting-accordion-${x.id}`"
                                                        role="tabpanel"
                                                    >
                                                        <hr />
                                                        <div class="d-flex align-items-center justify-content-between mb-2">
                                                            <input
                                                                type="search"
                                                                class="
                                                                    form-control popover-report
                                                                "
                                                                v-model="
                                                                    x.fileSearch
                                                                "
                                                                @input="
                                                                    searchPost(
                                                                        x
                                                                    )
                                                                "
                                                                placeholder="Search Public Post Attachments..."
                                                            />
                                                            <button type="button" class="btn btn-outline-info" @click="addPublicPost(x)"><i class="bx bx-plus"></i>Add Public Post Attachment</button>
                                                        </div>
                                                        <div class="table-responsive">
                                                            <table class="table table-bordered table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Title</th>
                                                                        <th>Description</th>
                                                                        <th width="250px">Attachment</th>
                                                                        <th width="90px">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-if="!x.postLoading && x.posts.length == 0">
                                                                        <td colspan="4" class="text-center">No data found</td>
                                                                    </tr>
                                                                    <tr v-if="x.postLoading">
                                                                        <td colspan="4" class="text-center">
                                                                            <LoadingTemplate />
                                                                        </td>
                                                                    </tr>
                                                                    <template v-if="!x.postLoading && x.posts.length > 0">
                                                                        <tr v-for="post in x.posts" :key="post.id">
                                                                            <td>{{post.title}}</td>
                                                                            <td>{{post.description}}</td>
                                                                            <td>
                                                                                <div v-if="post.attachments.length > 0">
                                                                                    <div v-for="attachment in post.attachments" :key="attachment.id" class="d-inline-block">
                                                                                        <div class="d-flex hover-toggle align-items-center">
                                                                                            <a href="javascript:void(0);" class="text-normal-color hoverable-link me-1" @click="openDocument(attachment)"><i>{{attachment.description}}</i></a>
                                                                                            <span class="hover-content"><i class="bx bx-trash cursor-pointer text-danger" @click="removePublicPostAttachment(attachment, post)"></i></span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div v-else>
                                                                                    <a href="javascript:void(0);" class="hoverable-link" :id="`attachment-document${post.id}`" @click="post.showAttachment = true">
                                                                                        <i class="bx bx-plus me-1"></i>Add Attachments
                                                                                    </a>
                                                                                    <upload-popover
                                                                                        :option="
                                                                                            publicPostOptions
                                                                                        "
                                                                                        :sourceId="
                                                                                            post.id
                                                                                        "
                                                                                        @uploaded="
                                                                                            uploadedPublicPostAttachment(
                                                                                                $event,
                                                                                                post
                                                                                            )
                                                                                        "
                                                                                        :showPV="
                                                                                            post.showAttachment
                                                                                        "
                                                                                        @closePopover="
                                                                                            closePublicPostAttachment(post)
                                                                                        "
                                                                                        :dzId="`dropzone-attachment${post.id}`"
                                                                                        :pvId="`attachment-document${post.id}`"
                                                                                    ></upload-popover>
                                                                                </div>
                                                                            </td>
                                                                            <td class="text-center">
                                                                                <a href="javascript:void(0);" class="text-success font-size-16 me-2" title="Update" @click="updatePublicAttachment(post, x)"><i class="bx bx-edit"></i></a>
                                                                                <a href="javascript:void(0);" class="text-danger font-size-16" title="Delete" @click="deletePublicAttachment(post, x)"><i class="bx bx-trash"></i></a>
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </b-collapse>
                                                    <!-- <hr />
                                                    <button type="button" class="btn btn-warning d-flex align-items-center" @click="unPostToPublic(x, true)"><i class="bx bx-x me-1 font-size-18"></i>UnPost from Public</button> -->
                                                </b-card-body>
                                            </b-collapse>
                                        </b-card>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-tab>
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span
                        class="d-none d-sm-inline-block position-relative" :class="{'me-2': recanvasItems.length > 0}"
                        >Recanvass Form
                        <small
                            ><span
                                class="
                                    badge
                                    bg-danger
                                    position-absolute
                                    py-1
                                    ms-1
                                "
                                style="top: -2px"
                                v-if="recanvasItems.length > 0"
                                >{{ recanvasItems.length }}</span
                            ></small
                        ></span
                    >
                </template>
                <SubmissionTab 
                    title="Recanvass Form"
                    :cartItems="recanvasItems"
                    :cartBusy="recanvasLoading"
                    :cartCount="recanvasItems.length"
                    :rfq="recanvasRfq"
                    :recanvases="recanvases"
                    :selectedRecanvasRfq="selectedRecanvasRfq"
                    :selectedSupplier="selectedSupplier"
                    :mop="mop"
                    @getSuppliers="getSuppliers"
                    @removeSupplier="removeSupplier"
                    @checkOut="checkOut"
                    @cancelPR="cancelPR"
                    @getResourceInfo="getResourceInfo"
                    @changeRfq="changeRfq"
                />
            </b-tab>
        </b-tabs>
        <div class="position-fixed" style="bottom: 50px; right: 100px">
            <div
                class="position-relative"
                v-if="
                    selectedAvailableItems.length > 0 &&
                    !addItem &&
                    tabIndex == 0
                "
            >
                <button
                    class="
                        btn btn-success
                        d-flex
                        align-items-center
                        rounded-pill
                        hover-max-width
                    "
                    type="button"
                    @click="addToCart(selectedAvailableItems)"
                >
                    <i class="bx bx-cart font-size-18"></i
                    ><span>Add to Cart</span>
                </button>
                <small
                    class="position-absolute badge bg-danger"
                    style="top: -5px; right: 0; z-index: 10px"
                    >{{ selectedAvailableItems.length }}</small
                >
            </div>
        </div>
        <div
            v-if="selectedRFQ.id"
            class="position-fixed custom-border-2"
            style="top: 125px; right: 0; left: 0; bottom: 60px; z-index: -1"
        >
            <div class="position-relative">
                <span class="bg-secondary badge p-2 font-size-12"
                    >Add More Item for RFQ:<u>
                        {{ selectedRFQ.description }}</u
                    ></span
                >
            </div>
        </div>
        <div
            class="position-absolute"
            style="bottom: 100px; right: 100px"
            v-if="addItem"
        >
            <div class="d-flex">
                <div
                    class="position-relative"
                    v-if="selectedAvailableItems.length > 0"
                >
                    <button
                        class="
                            btn btn-success
                            d-flex
                            align-items-center
                            rounded-pill
                            hover-max-width
                            me-3
                        "
                        type="button"
                        @click="addToRFQ(selectedAvailableItems)"
                    >
                        <i class="bx bx-cart font-size-18"></i
                        ><span>Add to RFQ: {{ selectedRFQ.rfqNumber }}</span>
                    </button>
                    <small
                        class="position-absolute badge bg-danger"
                        style="top: -5px; right: 13px; z-index: 10px"
                        >{{ selectedAvailableItems.length }}</small
                    >
                </div>
                <button type="button" class="btn border" @click="cancelItems()">
                    <i class="bx bx-x me-1"></i>Cancel
                </button>
            </div>
        </div>
        <supplier-rfq
            ref="supplier"
            @dropData="dropSuppliers($event)"
        ></supplier-rfq>
        <print-options ref="printOpt"></print-options>
        <attachment-modal
            :wActions="wActions"
            :title="attachmentTitle"
            ref="attachmentModal"
        ></attachment-modal>
        <ResourceDetails ref="resourceDetails"></ResourceDetails>
        <employee-modal ref="empModal" @dropData="dropSingleEmployee"></employee-modal>
        <unit ref="unit" @dropData="dropUnit($event)"></unit>
        <ConsolidatedItems 
            :tableData="consolidatedItems" 
            :loading="showConsolidatedItems"
            @remove-from-consolidation="removeFromConsolidation"
        />
        <RFQNumberModal ref="rfqNumberModal" @rfqNumberChanged="updateRFQNumber"/>
        <BACMemberModal @onSubmit="createMember" @openEmployee="selectBACEmployee" ref="addBacModal"/>
    </Layout>
</template>